/*
 * @license
 * Pipeline Theme (c) Groupthought Themes
 *
 * The contents of this file should not be modified.
 * add any minor changes to assets/custom.js
 *
 */
! function(t, e, i, s, o, r, n, a, l, c, h) {
    "use strict";

    function d(t) {
        var e = Object.create(null);
        return t && Object.keys(t).forEach((function(i) {
            if ("default" !== i) {
                var s = Object.getOwnPropertyDescriptor(t, i);
                Object.defineProperty(e, i, s.get ? s : {
                    enumerable: !0,
                    get: function() {
                        return t[i]
                    }
                })
            }
        })), e.default = t, Object.freeze(e)
    }
    var u = d(o);

    function p(t) {
        const e = t.querySelectorAll("[data-modal]"),
            i = document.querySelector("[data-modal-container]");
        e.forEach((t => {
            i.querySelector(`[id="${t.id}"]`) || i.appendChild(t)
        }))
    }

    function m(t) {
        t.querySelectorAll(".float__wrapper").forEach((t => {
            const e = t.querySelector("label"),
                i = t.querySelector("input, textarea");
            e && i.addEventListener("keyup", (t => {
                "" !== t.target.value ? e.classList.add("label--float") : e.classList.remove("label--float")
            })), i && i.value && i.value.length && e.classList.add("label--float")
        }))
    }

    function y(t) {
        t.querySelectorAll(".errors").forEach((t => {
            t.setAttribute("tabindex", "0"), t.setAttribute("aria-live", "assertive"), t.setAttribute("role", "alert")
        }))
    }

    function g(t) {
        document.addEventListener("theme:resize", f.bind(null, t)), f(t)
    }

    function f(t) {
        window.innerWidth > window.theme.sizes.small && setTimeout((() => {
            t.querySelectorAll(".lazypostload-desktop").forEach((t => {
                t.style.visibility = "visible"
            }))
        }), 2e3)
    }

    function w() {
        const t = {};
        return t.windowHeight = window.innerHeight, t.announcementHeight = S("#shopify-section-announcement"), t.footerHeight = S('[data-section-type*="footer"]'), t.menuHeight = S("[data-header-height]"), t.headerHeight = t.menuHeight + t.announcementHeight, t.logoHeight = function() {
            const t = S("[data-footer-logo]");
            return t > 0 ? t + 20 : 0
        }(), t.stickyHeader = document.querySelector('[data-header-sticky="sticky"]') ? t.menuHeight : 0, t.backfillHeight = S("[data-header-backfill]"), t
    }

    function v() {
        document.addEventListener("theme:resize", b),
            function() {
                const {
                    windowHeight: t,
                    announcementHeight: e,
                    headerHeight: i,
                    logoHeight: s,
                    menuHeight: o,
                    footerHeight: r,
                    stickyHeader: n,
                    backfillHeight: a
                } = w();
                document.documentElement.style.setProperty("--scrollbar-width", `${E()}px`), document.documentElement.style.setProperty("--footer-logo", `${s}px`), document.documentElement.style.setProperty("--full-screen", `${t}px`), document.documentElement.style.setProperty("--three-quarters", .75 * t + "px"), document.documentElement.style.setProperty("--two-thirds", .66 * t + "px"), document.documentElement.style.setProperty("--one-half", .5 * t + "px"), document.documentElement.style.setProperty("--one-third", .33 * t + "px"), document.documentElement.style.setProperty("--one-fifth", .2 * t + "px"), document.documentElement.style.setProperty("--menu-height", `${o}px`), document.documentElement.style.setProperty("--announcement-height", `${e}px`), document.documentElement.style.setProperty("--header-height", `${i}px`), document.documentElement.style.setProperty("--footer-height", `${r}px`), document.documentElement.style.setProperty("--content-full", t - i - s / 2 + "px"), document.documentElement.style.setProperty("--menu-height-sticky", `${n}px`);
                let l = Math.abs(a - o) > 1 ? `${o}px` : "auto";
                document.documentElement.style.setProperty("--menu-backfill-height", l)
            }()
    }

    function b() {
        const {
            windowHeight: t,
            announcementHeight: e,
            headerHeight: i,
            logoHeight: s,
            menuHeight: o,
            footerHeight: r,
            stickyHeader: n,
            backfillHeight: a
        } = w();
        document.documentElement.style.setProperty("--scrollbar-width", `${E()}px`), document.documentElement.style.setProperty("--full-screen", `${t}px`), document.documentElement.style.setProperty("--menu-height", `${o}px`), document.documentElement.style.setProperty("--announcement-height", `${e}px`), document.documentElement.style.setProperty("--header-height", `${i}px`), document.documentElement.style.setProperty("--footer-height", `${r}px`), document.documentElement.style.setProperty("--content-full", t - i - s / 2 + "px"), document.documentElement.style.setProperty("--menu-height-sticky", `${n}px`);
        let l = Math.abs(a - o) > 1 ? `${o}px` : "auto";
        document.documentElement.style.setProperty("--menu-backfill-height", l)
    }

    function S(t) {
        const e = document.querySelector(t);
        return e ? e.clientHeight : 0
    }

    function E() {
        const t = document.createElement("div");
        t.style.visibility = "hidden", t.style.overflow = "scroll", t.style.msOverflowStyle = "scrollbar", document.body.appendChild(t);
        const e = document.createElement("div");
        t.appendChild(e);
        const i = t.offsetWidth - e.offsetWidth;
        return t.parentNode.removeChild(t), i
    }

    function L(t, e) {
        let i = 64,
            s = 0;
        e.forEach((t => {
            if (t.offsetHeight > s) {
                const e = parseInt(window.getComputedStyle(t).marginTop) + parseInt(window.getComputedStyle(t).marginBottom);
                e > i && (i = e), s = t.offsetHeight
            }
        }));
        const o = t.querySelectorAll("[data-overflow-background]");
        [t, ...o].forEach((t => {
            t.style.setProperty("min-height", `calc(${s+i}px + var(--menu-height))`)
        }))
    }

    function T(t) {
        let e = document.querySelector("[data-footer-logo]") ? document.querySelector("[data-footer-logo]").clientHeight + 20 : 0;
        const i = document.querySelector("#MainContent .shopify-section:last-child [data-section-id]"),
            s = i ? i.getAttribute("data-section-id") : null;
        if ((null !== s && t.getAttribute("data-section-id") !== s || !i) && (e = 0), window.innerWidth < window.theme.sizes.medium) {
            return void t.querySelectorAll("[data-overflow-frame]").forEach((t => {
                const e = t.querySelectorAll("[data-overflow-content]");
                L(t, e)
            }))
        }
        const o = document.createElement("div");
        t.prepend(o), o.style.display = "none", o.style.width = getComputedStyle(t).getPropertyValue("--outer");
        const r = 2 * parseInt(getComputedStyle(o).getPropertyValue("width"));
        t.firstChild.remove();
        let n = 0;
        const a = t.querySelectorAll("[data-overflow-frame]");
        t.querySelectorAll("[data-overflow-content]").forEach((t => {
            t.offsetHeight > n && (n = t.offsetHeight)
        }));
        [...a, ...t.querySelectorAll("[data-overflow-background]")].forEach((t => {
            t.style.setProperty("min-height", `${n+r}px`)
        })), t.style.setProperty("min-height", `${n+r+2+e}px`)
    }

    function k(t) {
        const i = t.querySelectorAll(".js-overflow-container");
        if (i) {
            i.forEach((t => {
                const e = t.querySelectorAll(".js-overflow-content");
                L(t, e), document.addEventListener("theme:resize", (() => {
                    L(t, e)
                }))
            }));
            const s = t.querySelectorAll("[data-slideshow-wrapper]");
            s.length && s.forEach((t => {
                const i = e.data(t);
                void 0 !== i && i.reloadCells()
            }))
        }
        const s = t.querySelectorAll("[data-overflow-wrapper]");
        s && s.forEach((t => {
            T(t), document.addEventListener("theme:resize", (() => {
                T(t)
            }))
        }))
    }

    function A(t, e) {
        let i;
        return (...s) => {
            clearTimeout(i), i = setTimeout((() => t.apply(this, s)), e)
        }
    }
    window.theme = window.theme || {}, window.theme.sizes = {
        small: 480,
        medium: 768,
        large: 1100,
        widescreen: 1400
    }, window.theme.keyboardKeys = {
        TAB: 9,
        ENTER: 13,
        ESCAPE: 27,
        SPACE: 32,
        LEFTARROW: 37,
        RIGHTARROW: 39
    };
    let q = window.innerWidth,
        C = window.innerHeight;
    let x = window.pageYOffset,
        P = null,
        $ = null,
        _ = null,
        H = null,
        M = 0;

    function I(t) {
        let e = t.target;
        t.detail && t.detail instanceof Element && (e = t.detail), i.disableBodyScroll(e), document.documentElement.setAttribute("data-scroll-locked", "")
    }

    function D() {
        if (M = setTimeout((() => {
                document.body.removeAttribute("data-drawer-closing")
            }), 20), document.body.hasAttribute("data-drawer-closing")) return document.body.removeAttribute("data-drawer-closing"), void(M && clearTimeout(M));
        document.body.setAttribute("data-drawer-closing", ""), document.documentElement.removeAttribute("data-scroll-locked"), i.clearAllBodyScrollLocks()
    }
    window.addEventListener("resize", A((function() {
            document.dispatchEvent(new CustomEvent("theme:resize", {
                bubbles: !0
            })), q !== window.innerWidth && (document.dispatchEvent(new CustomEvent("theme:resize:width", {
                bubbles: !0
            })), q = window.innerWidth), C !== window.innerHeight && (document.dispatchEvent(new CustomEvent("theme:resize:height", {
                bubbles: !0
            })), C = window.innerHeight)
        }), 50)),
        function() {
            let t;
            window.addEventListener("scroll", (function() {
                t && window.cancelAnimationFrame(t), t = window.requestAnimationFrame((function() {
                    ! function() {
                        const t = window.pageYOffset;
                        t > x ? ($ = !0, P = !1) : t < x ? ($ = !1, P = !0) : (P = null, $ = null), x = t, document.dispatchEvent(new CustomEvent("theme:scroll", {
                            detail: {
                                up: P,
                                down: $,
                                position: t
                            },
                            bubbles: !1
                        })), P && !_ && document.dispatchEvent(new CustomEvent("theme:scroll:up", {
                            detail: {
                                position: t
                            },
                            bubbles: !1
                        })), $ && !H && document.dispatchEvent(new CustomEvent("theme:scroll:down", {
                            detail: {
                                position: t
                            },
                            bubbles: !1
                        })), H = $, _ = P
                    }()
                }))
            }), {
                passive: !0
            }), window.addEventListener("theme:scroll:lock", I), window.addEventListener("theme:scroll:unlock", D)
        }(), window.addEventListener("load", (() => {
            v(), m(document), y(document), p(document), k(document), g(document), window.theme.settings.animate_scroll && t.refresh()
        })), document.addEventListener("shopify:section:load", (e => {
            const i = e.target;
            m(i), y(i), p(i), k(i), g(i), window.theme.settings.animate_scroll && t.refresh()
        })), document.addEventListener("shopify:section:reorder", (() => {
            document.dispatchEvent(new CustomEvent("theme:header:check", {
                bubbles: !1
            }))
        }));
    const B = (t, e = !1, i = "block") => {
        t && (e ? t.style.removeProperty("display") : t.style.display = i)
    };

    function W(t) {
        this.status = t.status || null, this.headers = t.headers || null, this.json = t.json || null, this.body = t.body || null
    }
    W.prototype = Error.prototype;
    const F = "data-scrollbar-slider",
        O = "[data-scrollbar-arrow-prev]",
        N = "[data-scrollbar-arrow-next]",
        z = "is-hidden",
        R = 200;
    let V = class {
        init() {
            this.arrowNext && this.arrowPrev && (window.isRTL ? this.togglePrevArrow() : this.toggleNextArrow(), this.events())
        }
        resize() {
            document.addEventListener("theme:resize", (() => {
                window.isRTL ? this.togglePrevArrow() : this.toggleNextArrow()
            }))
        }
        events() {
            this.arrowNext.addEventListener("click", (t => {
                t.preventDefault(), this.goToNext()
            })), this.arrowPrev.addEventListener("click", (t => {
                t.preventDefault(), this.goToPrev()
            })), this.scrollbar.addEventListener("scroll", (() => {
                this.togglePrevArrow(), this.toggleNextArrow()
            }))
        }
        goToNext() {
            const t = this.scrollbar.getBoundingClientRect().width / 2 + this.scrollbar.scrollLeft;
            this.move(t), this.arrowPrev.classList.remove(z), this.toggleNextArrow()
        }
        goToPrev() {
            const t = this.scrollbar.scrollLeft - this.scrollbar.getBoundingClientRect().width / 2;
            this.move(t), this.arrowNext.classList.remove(z), this.togglePrevArrow()
        }
        toggleNextArrow() {
            setTimeout((() => {
                window.isRTL ? this.arrowNext.classList.toggle(z, 0 === this.scrollbar.scrollLeft) : this.arrowNext.classList.toggle(z, Math.round(this.scrollbar.scrollLeft + this.scrollbar.getBoundingClientRect().width + 1) >= this.scrollbar.scrollWidth)
            }), R)
        }
        togglePrevArrow() {
            setTimeout((() => {
                window.isRTL ? this.arrowPrev.classList.toggle(z, Math.abs(this.scrollbar.scrollLeft) + this.scrollbar.getBoundingClientRect().width + 1 >= this.scrollbar.scrollWidth) : this.arrowPrev.classList.toggle(z, this.scrollbar.scrollLeft <= 0)
            }), R)
        }
        scrollToVisibleElement() {
            [].forEach.call(this.scrollbar.children, (t => {
                t.addEventListener("click", (e => {
                    ("a" === e.target.tagName.toLowerCase() || e.currentTarget && "a" === e.currentTarget.tagName.toLowerCase() || e.currentTarget && e.currentTarget.querySelector("a")) && e.preventDefault(), this.move(t.offsetLeft - t.clientWidth)
                }))
            }))
        }
        move(t) {
            this.scrollbar.scrollTo({
                top: 0,
                left: t,
                behavior: "smooth"
            })
        }
        constructor(t) {
            this.scrollbar = t, this.arrowNext = this.scrollbar.parentNode.querySelector(N), this.arrowPrev = this.scrollbar.parentNode.querySelector(O), this.init(), this.resize(), this.scrollbar.hasAttribute(F) && this.scrollToVisibleElement()
        }
    };
    const j = "[data-sibling-inner]";
    let U = class {
        init() {
            this.siblings.forEach((t => {
                new V(t)
            }))
        }
        constructor(t) {
            this.siblings = t.querySelectorAll(j), this.init()
        }
    };
    const J = {
            onLoad() {
                new U(this.container)
            }
        },
        K = {
            expires: 7,
            path: "/",
            domain: window.location.hostname
        };
    let Y = class {
        write(t) {
            document.cookie = `${this.options.name}=${t}; expires=${this.options.expires}; path=${this.options.path}; domain=${this.options.domain}`
        }
        read() {
            let t = [];
            const e = document.cookie.split("; ").find((t => t.startsWith(this.options.name)));
            if (-1 !== document.cookie.indexOf("; ") && e) {
                const e = document.cookie.split("; ").find((t => t.startsWith(this.options.name))).split("=")[1];
                null !== e && (t = e.split(","))
            }
            return t
        }
        destroy() {
            document.cookie = `${this.options.name}=null; expires=${this.options.expires}; path=${this.options.path}; domain=${this.options.domain}`
        }
        remove(t) {
            const e = this.read(),
                i = e.indexOf(t); - 1 !== i && (e.splice(i, 1), this.write(e))
        }
        constructor(t = {}) {
            this.options = {
                ...K,
                ...t
            }
        }
    };
    const G = 4,
        X = 10,
        Q = "[data-recently-viewed-products]",
        Z = "data-limit",
        tt = "[data-recent-link-tab]",
        et = "[data-recent-wrapper]",
        it = "[data-recently-viewed-tab]",
        st = "[data-tabs-holder-scroll]",
        ot = "[data-api-content]",
        rt = "data-minimum",
        nt = "hide",
        at = "section-without-title--skip",
        lt = {
            expires: 90,
            name: "shopify_recently_viewed"
        },
        ct = [],
        ht = [];
    const dt = {
        onLoad() {
            ct[this.id] = new class {
                renderProducts() {
                    const t = this.cookie.read(),
                        e = [];
                    let i = 0;
                    if (t.length > 0) {
                        for (let s = 0; s < t.length; s++) {
                            const o = t[s];
                            if (ht.includes(o)) continue;
                            const r = `${window.theme.routes.root_url}products/${o}?section_id=api-product-grid-item`;
                            if (e.push(r), i++, i === this.howManyToShow || i === t.length - 1) break
                        }
                        if (e.length > 0 && e.length >= this.minimum) {
                            this.container.classList.remove(nt), this.recentViewedLink && this.recentViewedLink.previousElementSibling && (this.tabsHolderScroll.classList.remove(nt), this.container.classList.add(at));
                            const t = e.map((t => fetch(t, {
                                    mode: "no-cors"
                                }).then(this.handleErrors))),
                                i = [];
                            Promise.allSettled(t).then((t => Promise.all(t.map((async t => {
                                "fulfilled" === t.status && i.push(await t.value.text())
                            }))))).then((() => {
                                i.forEach((t => {
                                    const e = document.createElement("div"),
                                        i = document.createElement("div");
                                    e.innerHTML = t, i.classList.add("product-grid-slide"), i.setAttribute("data-carousel-slide", null), i.setAttribute("data-item", null), i.innerHTML = e.querySelector(ot).innerHTML, this.wrapper.appendChild(i)
                                })), new U(this.container)
                            })).then((() => {
                                B(this.wrapper, !0), this.container.dispatchEvent(new CustomEvent("theme:recent-products:added", {
                                    bubbles: !0
                                }))
                            }))
                        } else if (this.recentViewedTab) {
                            const t = Array.prototype.filter.call(this.recentViewedTab.parentNode.children, (t => t !== this.recentViewedTab)).length > 1;
                            this.recentViewedLink && this.recentViewedLink.previousElementSibling && (this.tabsHolderScroll.classList.add(nt), this.container.classList.remove(at)), t || this.container.classList.add(nt)
                        } else this.container.classList.add(nt)
                    }
                }
                handleErrors(t) {
                    return t.ok ? t : t.text().then((function(e) {
                        throw new W({
                            status: t.statusText,
                            headers: t.headers,
                            text: e
                        })
                    }))
                }
                constructor(t) {
                    this.container = t.container, this.cookie = new Y(lt), this.wrapper = this.container.querySelector(Q), null !== this.wrapper && (this.howManyToShow = parseInt(this.container.querySelector(et).getAttribute(Z)) || G, this.minimum = parseInt(this.container.querySelector(et).getAttribute(rt)), this.recentViewedTab = this.container.querySelector(it), this.recentViewedLink = this.container.querySelector(tt), this.tabsHolderScroll = this.container.querySelector(st), this.renderProducts())
                }
            }(this)
        }
    };

    function ut(t) {
        return t.replace(/http(s)?:/, "")
    }

    function pt() {
        this.entries = []
    }

    function mt(t, e) {
        yt(t);
        var i = function(t, e) {
            yt(t),
                function(t) {
                    if (!Array.isArray(t)) throw new TypeError(t + " is not an array.");
                    if (0 === t.length) throw new Error(t + " is empty.");
                    if (!t[0].hasOwnProperty("name")) throw new Error(t[0] + "does not contain name key.");
                    if ("string" != typeof t[0].name) throw new TypeError("Invalid value type passed for name of option " + t[0].name + ". Value should be string.")
                }(e);
            var i = [];
            return e.forEach((function(e) {
                for (var s = 0; s < t.options.length; s++) {
                    if ((t.options[s].name || t.options[s]).toLowerCase() === e.name.toLowerCase()) {
                        i[s] = e.value;
                        break
                    }
                }
            })), i
        }(t, e);
        return function(t, e) {
            return yt(t),
                function(t) {
                    if (Array.isArray(t) && "object" == typeof t[0]) throw new Error(t + "is not a valid array of options.")
                }(e), t.variants.filter((function(t) {
                    return e.every((function(e, i) {
                        return t.options[i] === e
                    }))
                }))[0] || null
        }(t, i)
    }

    function yt(t) {
        if ("object" != typeof t) throw new TypeError(t + " is not an object.");
        if (0 === Object.keys(t).length && t.constructor === Object) throw new Error(t + " is empty.")
    }
    pt.prototype.add = function(t, e, i) {
        this.entries.push({
            element: t,
            event: e,
            fn: i
        }), t.addEventListener(e, i)
    }, pt.prototype.removeAll = function() {
        this.entries = this.entries.filter((function(t) {
            return t.element.removeEventListener(t.event, t.fn), !1
        }))
    };
    var gt = '[name="id"]',
        ft = '[name="selling_plan"]',
        wt = '[name^="options"]',
        vt = '[name="quantity"]',
        bt = '[name^="properties"]';
    const St = {};

    function Et(t = {}) {
        if (t.type || (t.type = "json"), t.url) return St[t.url] ? St[t.url] : function(t, e) {
            const i = new Promise(((i, s) => {
                "text" === e ? fetch(t).then((t => t.text())).then((t => {
                    i(t)
                })).catch((t => {
                    s(t)
                })) : function(t, e, i) {
                    let s = document.getElementsByTagName("head")[0],
                        o = !1,
                        r = document.createElement("script");
                    r.src = t, r.onload = r.onreadystatechange = function() {
                        o || this.readyState && "loaded" != this.readyState && "complete" != this.readyState ? i() : (o = !0, e())
                    }, s.appendChild(r)
                }(t, (function() {
                    i()
                }), (function() {
                    s()
                }))
            }));
            return St[t] = i, i
        }(t.url, t.type);
        if (t.json) return St[t.json] ? Promise.resolve(St[t.json]) : window.fetch(t.json).then((t => t.json())).then((e => (St[t.json] = e, e)));
        if (t.name) {
            const e = "".concat(t.name, t.version);
            return St[e] ? St[e] : function(t) {
                const e = "".concat(t.name, t.version),
                    i = new Promise(((e, i) => {
                        try {
                            window.Shopify.loadFeatures([{
                                name: t.name,
                                version: t.version,
                                onLoad: t => {
                                    ! function(t, e, i) {
                                        i ? e(i) : t()
                                    }(e, i, t)
                                }
                            }])
                        } catch (t) {
                            i(t)
                        }
                    }));
                return St[e] = i, i
            }(t)
        }
        return Promise.reject()
    }
    const Lt = "[data-swapper-wrapper]",
        Tt = "[data-swapper-target]",
        kt = "data-swapper-hover";
    let At = {};

    function qt(t) {
        At[t.id] = [];
        t.querySelectorAll(Lt).forEach((e => {
            At[t.id].push(new class {
                init() {
                    this.hovers.forEach((t => {
                        t.addEventListener("mouseenter", function() {
                            const e = t.getAttribute(kt);
                            this.target.innerHTML = `${e}`
                        }.bind(this))
                    })), this.hovers.forEach((t => {
                        t.addEventListener("mouseleave", function() {
                            this.target.innerHTML = this.deafaultContent
                        }.bind(this))
                    })), this.hovers.forEach((t => {
                        t.addEventListener("click", function() {
                            const e = t.getAttribute(kt);
                            this.deafaultContent = `${e}`
                        }.bind(this))
                    }))
                }
                constructor(t) {
                    this.container = t, this.target = this.container.querySelector(Tt), this.hovers = this.container.querySelectorAll(`[${kt}]`), this.target && this.hovers.length && (this.deafaultContent = this.target.innerHTML, this.init())
                }
            }(e))
        }))
    }
    const Ct = {
            onLoad() {
                qt(this.container)
            }
        },
        xt = {
            color: "ash"
        },
        Pt = "data-swatch",
        $t = "[data-grid-item]",
        _t = "data-grid-image-default",
        Ht = "data-grid-image-target",
        Mt = "data-swatch-image",
        It = "data-swatch-image-id",
        Dt = "data-swatch-variant",
        Bt = "[data-grid-swatches]",
        Wt = "[data-swatch-template]",
        Ft = "data-swatch-handle",
        Ot = "data-swatch-label",
        Nt = "is-fade";
    let zt = class extends HTMLElement {
        init() {
            this.setStyles(), this.variant && this.outer && this.outer.addEventListener("theme:upsell:media", (t => {
                t && t.detail && t.detail.media && (this.media = t.detail.media)
            }))
        }
        setStyles() {
            this.colorMatch.hex && this.element.style.setProperty("--swatch", `${this.colorMatch.hex}`), this.colorMatch.path && (this.element.style.setProperty("background-image", `url(${this.colorMatch.path})`), this.element.style.setProperty("background-size", "cover"))
        }
        replaceImage() {
            if (this.imageReplace && this.imageSlide && this.imageId) {
                if (this.imageSlide.hasAttribute(Ht) && this.imageSlide.getAttribute(Ht) !== this.imageId) {
                    this.imageSlide.classList.add(Nt);
                    const t = 1e3 * parseFloat(window.getComputedStyle(this.imageSlide).getPropertyValue("animation-duration"));
                    setTimeout((() => {
                        this.imageSlide.classList.remove(Nt)
                    }), t)
                }
                this.imageSlide.setAttribute(Ht, this.imageId), this.imageSlide.style.setProperty("background-color", "#fff"), this.imageSlide.hasAttribute(_t) || this.imageSlide.setAttribute(_t, window.getComputedStyle(this.imageSlide).backgroundImage), this.imageSlide.style.setProperty("background-image", this.imageReplace)
            }
        }
        constructor() {
            super(), this.element = this.querySelector(`[${Pt}]`), this.colorString = this.element.getAttribute(Pt), this.image = this.element.getAttribute(Mt), this.imageId = this.element.getAttribute(It), this.variant = this.element.getAttribute(Dt), this.outer = this.element.closest($t), this.media = null, this.imageSlide = null, this.imageDefault = null, this.stopSlideAnimation = !1;
            const t = new class {
                getColor() {
                    return this.match
                }
                init() {
                    return Et({
                        json: window.theme.assets.swatches
                    }).then((t => this.matchColors(t, this.settings.color))).catch((t => {
                        console.log("failed to load swatch colors script"), console.log(t)
                    }))
                }
                matchColors(t, e) {
                    let i = "#E5E5E5",
                        s = null;
                    const o = window.theme.assets.base || "/",
                        r = e.toLowerCase().replace(/\s/g, ""),
                        n = t.colors;
                    if (n) {
                        const t = t => Object.keys(t).toString().toLowerCase().replace(/\s/g, "") === r,
                            e = n.findIndex(t);
                        if (e > -1) {
                            const t = Object.values(n[e])[0],
                                r = t.toLowerCase();
                            r.includes(".jpg") || r.includes(".jpeg") || r.includes(".png") || r.includes(".svg") ? (s = `${o}${encodeURIComponent(t)}`, i = "#888888") : i = t
                        }
                    }
                    return {
                        color: this.settings.color,
                        path: s,
                        hex: i
                    }
                }
                constructor(t = {}) {
                    this.settings = {
                        ...xt,
                        ...t
                    }, this.match = this.init()
                }
            }({
                color: this.colorString
            });
            t.getColor().then((t => {
                this.colorMatch = t, this.init()
            }))
        }
    };

    function Rt(t) {
        t.querySelectorAll(Bt).forEach((t => {
            new class {
                init() {
                    this.wrap.innerHTML = "", this.swatches.forEach(((t, e) => {
                        let i = this.product.variants.find((e => e.options.includes(t)));
                        const s = i.featured_media ? i.featured_media.preview_image.src : "",
                            o = i.featured_media ? i.featured_media.id : "",
                            r = Math.floor(9999 * Math.random());
                        this.wrap.innerHTML += u.render(this.template, {
                            color: t,
                            uniq: `${this.product.id}-${i.id}-${r}`,
                            variant: i.id,
                            product_id: this.product.id,
                            image_id: o,
                            image: s,
                            index: e
                        })
                    })), new V(this.wrap)
                }
                constructor(t) {
                    this.template = document.querySelector(Wt).innerHTML, this.wrap = t, this.handle = t.getAttribute(Ft);
                    const e = t.getAttribute(Ot).trim().toLowerCase();
                    (function(t) {
                        const e = `${window.theme.routes.root_url}products/${t}.js`;
                        return window.fetch(e).then((t => t.json())).catch((t => {
                            console.error(t)
                        }))
                    })(this.handle).then((t => {
                        this.product = t, this.colorOption = t.options.find((function(t) {
                            return t.name.toLowerCase() === e || null
                        })), this.colorOption && (this.swatches = this.colorOption.values, this.init())
                    }))
                }
            }(t)
        }))
    }
    const Vt = {
            onLoad() {
                Rt(this.container), qt(this.container)
            }
        },
        jt = "[data-custom-scrollbar-items]",
        Ut = "[data-custom-scrollbar]",
        Jt = "[data-custom-scrollbar-track]",
        Kt = "hide",
        Yt = {};
    let Gt = class {
        events() {
            this.holderItems.addEventListener("scroll", this.calculatePosition.bind(this)), this.holderItems.addEventListener("theme:carousel:scroll", this.calculatePosition.bind(this)), document.addEventListener("theme:resize:width", this.calculateTrackWidth.bind(this)), document.addEventListener("theme:resize:width", this.calculatePosition.bind(this))
        }
        calculateTrackWidth() {
            const t = document.createElement("div");
            this.holderItems.prepend(t), t.style.display = "none", t.style.width = getComputedStyle(this.holderItems).getPropertyValue("--outer");
            const e = parseInt(getComputedStyle(t).getPropertyValue("width"));
            this.holderItems.firstChild.remove(), this.scrollbarWidth = 0 === this.scrollbar.clientWidth ? this.scrollbar.parentNode.getBoundingClientRect().width : this.scrollbar.clientWidth, setTimeout((() => {
                const t = this.children[0].clientWidth,
                    i = Number(getComputedStyle(this.children[0]).marginRight.replace("px", "")),
                    s = Number(getComputedStyle(this.children[0]).marginLeft.replace("px", ""));
                this.scrollWidth = this.children.length * (t + i + s) + e - i, this.trackWidth = (this.scrollbarWidth + e) / this.scrollWidth * 100, this.trackWidth = this.trackWidth < 5 ? 5 : this.trackWidth, this.scrollbar.style.setProperty("--track-width", `${this.trackWidth}%`);
                const o = Math.ceil(this.trackWidth) >= 100;
                this.scrollbar.classList.toggle(Kt, o)
            }), 100)
        }
        calculatePosition() {
            let t = this.holderItems.scrollLeft / (this.holderItems.scrollWidth - this.holderItems.clientWidth);
            t *= this.scrollbar.clientWidth - this.scrollbarTrack.clientWidth, t = t < 0 ? 0 : t, t = isNaN(t) ? 0 : t, this.scrollbar.style.setProperty("--position", `${Math.round(t)}px`), document.dispatchEvent(new CustomEvent("theme:scrollbar:scroll", {
                bubbles: !0,
                detail: {
                    holder: this.holderItems
                }
            }))
        }
        constructor(t, e = null) {
            this.holderItems = t.querySelector(jt), this.scrollbar = t.querySelector(Ut), this.scrollbarTrack = t.querySelector(Jt), this.trackWidth = 0, this.scrollWidth = 0, this.scrollbar && this.holderItems && (this.children = e || this.holderItems.children, this.events(), this.calculateTrackWidth())
        }
    };
    const Xt = {
            onLoad() {
                Yt[this.id] = new Gt(this.container)
            }
        },
        Qt = "[data-carousel]",
        Zt = "data-carousel-progress",
        te = "[data-carousel-slide]",
        ee = "[data-grid-slide]",
        ie = "[data-wrapper]",
        se = "[data-carousel-track]",
        oe = "data-options",
        re = "data-custom-scrollbar-items",
        ne = ".flickity-button.previous",
        ae = ".flickity-button.next",
        le = "data-recently-viewed-products",
        ce = "data-related-products",
        he = "[data-section-id]",
        de = "wrapper--full",
        ue = "not-moved-arrows",
        pe = "hide",
        me = "flickity-enabled",
        ye = "hidden-arrows",
        ge = "flickity-static",
        fe = 112;
    let we = class extends HTMLElement {
        connectedCallback() {
            this.carousel = this.container.querySelector(Qt), this.carouselTrack = this.container.querySelector(se), this.wrapper = this.container.closest(ie), this.section = this.container.closest(he), this.slidesVisible = null, this.carouselInstance = null, this.carouselPrev = null, this.carouselNext = null, this.customOptions = {}, this.toggleWrapperModifierEvent = () => this.toggleWrapperModifier(), this.carousel && this.carousel.hasAttribute(le) ? this.section.addEventListener("theme:recent-products:added", (() => {
                this.init()
            })) : this.carousel && this.carousel.hasAttribute(ce) ? this.section.addEventListener("theme:related-products:added", (() => {
                this.init()
            })) : this.init()
        }
        init() {
            this.carousel && (this.slidesTotal = this.carousel.querySelectorAll(te).length, this.getGridLayout(), this.trackVisibleSlides(), this.carousel.hasAttribute(oe) && (this.customOptions = JSON.parse(decodeURIComponent(this.carousel.getAttribute(oe)))), this.initCarousel(), this.calculatedArrowsTopPosition(), this.toggleWrapperModifier(), document.addEventListener("theme:resize:width", this.toggleWrapperModifierEvent), this.carousel.hasAttribute(Zt) && this.progressBarCalculate(), this.carousel.hasAttribute(re) && new Gt(this.container))
        }
        initCarousel() {
            this.options = {
                accessibility: !0,
                contain: !0,
                freeScroll: !0,
                prevNextButtons: !0,
                wrapArround: !1,
                groupCells: !1,
                autoPlay: !1,
                pageDots: !1,
                cellAlign: window.isRTL ? "right" : "left",
                rightToLeft: window.isRTL,
                dragThreshold: 10,
                arrowShape: {
                    x0: 10,
                    x1: 60,
                    y1: 50,
                    x2: 65,
                    y2: 45,
                    x3: 20
                },
                on: {
                    resize: () => {
                        this.toggleArrows(), this.calculatedArrowsTopPosition(), setTimeout((() => {
                            this.visibleSlides()
                        }), 100)
                    }
                },
                ...this.customOptions
            }, this.carouselInstance = new s(this.carousel, this.options), this.carouselPrev = this.carousel.querySelector(ne), this.carouselNext = this.carousel.querySelector(ae), this.container.addEventListener("theme:tab:change", (() => {
                this.carouselInstance.resize(), this.carouselPrev = this.carousel.querySelector(ne), this.carouselNext = this.carousel.querySelector(ae)
            })), this.carouselInstance.on("dragStart", (() => {
                this.carouselInstance.slider.style.pointerEvents = "none", this.containDrag()
            })), this.carouselInstance.on("dragEnd", (() => {
                this.carouselInstance.slider.style.pointerEvents = "auto", this.containDrag()
            })), this.carouselInstance.on("change", (t => this.lockArrows(t))), setTimeout((() => {
                this.visibleSlides()
            }), 100), Shopify.designMode && setTimeout((() => {
                this.carouselInstance.options.watchCSS && !this.carousel.classList.contains(me) ? (this.carouselInstance.destroy(), this.carouselInstance = new s(this.carousel, this.options), this.carouselInstance.resize(), this.carouselPrev = this.carousel.querySelector(ne), this.carouselNext = this.carousel.querySelector(ae)) : this.carouselInstance.resize()
            }), 10), this.carousel.classList.toggle(ge, this.smallItems === this.carousel.querySelectorAll(te).length), Rt(this.container), new U(this.container)
        }
        calculatedArrowsTopPosition() {
            const t = this.container.querySelector(ee);
            if (t) {
                const e = t.offsetHeight / 2;
                this.carousel.style.setProperty("--buttons-top", `${e}px`)
            }
        }
        toggleWrapperModifier() {
            if (!this.wrapper) return;
            const t = Number(getComputedStyle(document.documentElement).getPropertyValue("--scrollbar-width").replace("px", "")),
                e = this.wrapper.clientWidth;
            this.wrapperWidthWithGutter = e + fe + t, this.wrapper.classList.toggle(de, this.wrapperWidthWithGutter >= window.innerWidth), this.section.classList.toggle(ue, !(this.wrapperWidthWithGutter >= window.innerWidth))
        }
        progressBarCalculate() {
            null !== this.carouselInstance && this.carouselTrack && this.carouselInstance.on("scroll", (t => {
                t = 100 * Math.max(0, Math.min(1, t)) + "%", this.carouselTrack.style.width = t
            }))
        }
        getGridLayout() {
            this.largeItems = Number(getComputedStyle(this.carousel).getPropertyValue("--grid-large-items")) || 3, this.mediumItems = Number(getComputedStyle(this.carousel).getPropertyValue("--grid-medium-items")) || this.largeItems, this.smallItems = Number(getComputedStyle(this.carousel).getPropertyValue("--grid-small-items")) || this.mediumItems || this.largeItems
        }
        visibleSlides() {
            if (!this.carousel) return;
            this.getGridLayout();
            const t = this.carousel.clientWidth || this.carouselInstance.size.width,
                e = null !== this.carouselInstance && this.carouselInstance.selectedElement ? this.carouselInstance.selectedElement.clientWidth : this.carousel.querySelector(te).clientWidth,
                i = null !== this.carouselInstance && this.carouselInstance.slides ? this.carouselInstance.slides.length : this.carousel.querySelectorAll(te).length,
                s = Math.floor(t / e);
            this.section.classList.remove(ye), this.carouselPrev && this.carouselNext && (this.carouselPrev.classList.remove(pe), this.carouselNext.classList.remove(pe)), window.innerWidth > window.theme.sizes.large && !this.options.groupCells && s <= this.largeItems && i <= this.largeItems && this.carouselPrev && this.carouselNext && this.hideArrows(), window.innerWidth >= window.theme.sizes.medium && window.innerWidth <= window.theme.sizes.large && !this.options.groupCells && s <= this.mediumItems && i <= this.mediumItems && this.carouselPrev && this.carouselNext && this.hideArrows(), window.innerWidth < window.theme.sizes.medium && !this.options.groupCells && s <= this.smallItems && i <= this.smallItems && this.carouselPrev && this.carouselNext && this.hideArrows()
        }
        trackVisibleSlides() {
            const t = window.matchMedia(`(max-width: ${window.theme.sizes.medium-1}px)`),
                e = window.matchMedia(`(min-width: ${window.theme.sizes.medium}px) and (max-width: ${window.theme.sizes.large-1}px)`),
                i = window.matchMedia(`(min-width: ${window.theme.sizes.large}px)`);
            t.addEventListener("change", (t => {
                !t.matches || (this.slidesVisible = this.smallItems)
            })), !t.matches || (this.slidesVisible = this.smallItems), e.addEventListener("change", (t => {
                !t.matches || (this.slidesVisible = this.mediumItems)
            })), !e.matches || (this.slidesVisible = this.mediumItems), i.addEventListener("change", (t => {
                !t.matches || (this.slidesVisible = this.largeItems)
            })), !i.matches || (this.slidesVisible = this.largeItems)
        }
        containDrag() {
            const t = this.slidesTotal - this.slidesVisible;
            this.carouselInstance.selectedIndex >= t && (this.carouselInstance.select(t), this.lockArrows(this.carouselInstance.selectedIndex))
        }
        lockArrows(t) {
            if (this.options.wrapAround || this.options.groupCells) return;
            const e = parseInt(t),
                i = this.slidesTotal - this.slidesVisible;
            this.carouselNext.disabled = e >= i
        }
        showArrows() {
            this.carouselPrev.classList.remove(pe), this.carouselNext.classList.remove(pe), this.section.classList.remove(ye)
        }
        hideArrows() {
            this.carouselPrev.classList.add(pe), this.carouselNext.classList.add(pe), this.section.classList.add(ye)
        }
        toggleArrows() {
            this.carouselPrev && this.carouselNext && (this.carouselPrev.disabled && this.carouselNext.disabled ? this.hideArrows() : this.showArrows())
        }
        constructor() {
            super(), this.container = this
        }
    };

    function ve(t, e) {
        e = e || {}, t.focus(), void 0 !== e.className && t.classList.add(e.className), t.addEventListener("blur", (function i(s) {
            s.target.removeEventListener(s.type, i), void 0 !== e.className && t.classList.remove(e.className)
        }))
    }

    function be(t) {
        return t = t || {}, Array.prototype.slice.call(document.querySelectorAll('a[href^="#"]')).filter((function(e) {
            if ("#" === e.hash || "" === e.hash) return !1;
            if (t.ignore && e.matches(t.ignore)) return !1;
            if (i = e.hash.substr(1), null === document.getElementById(i)) return !1;
            var i, s = document.querySelector(e.hash);
            return !!s && (e.addEventListener("click", (function() {
                ve(s, t)
            })), !0)
        }))
    }
    customElements.get("flickity-carousel") || customElements.define("flickity-carousel", we);
    var Se = {};

    function Ee(t, e) {
        e = e || {};
        var i = function(t) {
                return Array.prototype.slice.call(t.querySelectorAll("[tabindex],[draggable],a[href],area,button:enabled,input:not([type=hidden]):enabled,object,select:enabled,textarea:enabled[data-focus-element]")).filter((function(t) {
                    return Boolean(t.offsetWidth || t.offsetHeight || t.getClientRects().length)
                }))
            }(t),
            s = e.elementToFocus || t,
            o = i[0],
            r = i[i.length - 1];
        Le(), Se.focusin = function(e) {
            t !== e.target && !t.contains(e.target) && o && o === e.target && o.focus(), e.target !== t && e.target !== r && e.target !== o || document.addEventListener("keydown", Se.keydown)
        }, Se.focusout = function() {
            document.removeEventListener("keydown", Se.keydown)
        }, Se.keydown = function(e) {
            9 === e.keyCode && (e.target !== r || e.shiftKey || (e.preventDefault(), o.focus()), e.target !== t && e.target !== o || !e.shiftKey || (e.preventDefault(), r.focus()))
        }, document.addEventListener("focusout", Se.focusout), document.addEventListener("focusin", Se.focusin), ve(s, e)
    }

    function Le() {
        document.removeEventListener("focusin", Se.focusin), document.removeEventListener("focusout", Se.focusout), document.removeEventListener("keydown", Se.keydown)
    }
    const Te = (t, e) => {
            let i, s;
            return function o(...r) {
                const n = Date.now();
                s = clearTimeout(s), !i || n - i >= e ? (t.apply(null, r), i = n) : s = setTimeout(o.bind(null, ...r), e - (n - i))
            }
        },
        ke = "[data-size-button]",
        Ae = "[data-media-slide]",
        qe = "is-expanded";
    let Ce = class {
        init() {
            this.sizeButtons.forEach((t => {
                t.addEventListener("click", (() => {
                    t.classList.toggle(qe), t.closest(Ae).classList.toggle(qe)
                }))
            }))
        }
        constructor(t) {
            this.container = t, this.sizeButtons = this.container.querySelectorAll(ke), this.sizeButtons.length > 0 && this.init()
        }
    };
    const xe = "data-upsell",
        Pe = "data-upsell-holder",
        $e = "[data-product-upsell-ajax]",
        _e = "[data-upsell-modal]",
        He = "[data-drawer-scrolls]",
        Me = "[data-upsell-modal-template]",
        Ie = "[data-upsell-head]",
        De = "[data-upsell-form-area]",
        Be = "[data-toggle-button]",
        We = "[data-media-slide]",
        Fe = "[data-media-id]",
        Oe = "[data-add-inside-cart]",
        Ne = "data-add-inside-cart",
        ze = "data-popup-",
        Re = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
        Ve = "hide",
        je = "is-active",
        Ue = "is-expanded",
        Je = "loading",
        Ke = 250,
        Ye = 400;
    let Ge = class extends HTMLElement {
        static get observedAttributes() {
            return [xe]
        }
        attributeChangedCallback(t, e, i) {
            e && (this.disconnectedCallback(), this.connectedCallback())
        }
        connectedCallback() {
            if (this.upsellHolder = this.container.querySelector(`[${Pe}]`), this.modalCloseEvent = () => this.modalClose(), this.clickUpsellEvent = t => this.clickUpsellButton(t), this.upsellHolder) {
                if (this.modalTemplate = this.upsellHolder.querySelector(Me), this.modal = document.querySelector(_e), this.modalID = this.upsellHolder.getAttribute(Pe), this.modalContent = null, this.modalScroll = null, this.scrollLockEnable = !0, this.windowH = window.innerHeight, this.triggerButton = this.upsellHolder.querySelector(`[${ze}${this.modalID}]`), this.handle = this.triggerButton ? this.triggerButton.getAttribute(`${ze}${this.modalID}`) : null, this.isCartItem = !!this.triggerButton && Boolean(this.triggerButton.closest(Oe)), this.modalTemplate && !this.modal) {
                    const t = this.modalTemplate.innerHTML,
                        e = document.createElement("div");
                    e.innerHTML = t, this.modalHtml = e.querySelector(_e), document.body.appendChild(this.modalHtml), this.modal = document.querySelector(_e)
                }
                this.modalTemplate && this.triggerButton && this.triggerButton.addEventListener("click", this.clickUpsellEvent)
            }
        }
        clickUpsellButton(t) {
            t.preventDefault(), this.modal && this.modalID && (this.modal.id = this.modalID), this.modal && (this.isCartItem ? this.modal.setAttribute(Ne, "") : this.modal.removeAttribute(Ne)), document.documentElement.hasAttribute("data-scroll-locked") && (this.scrollLockEnable = !1), this.container.classList.add(Je), this.getUpsellHTML()
        }
        getUpsellHTML() {
            window.fetch(`${window.theme.routes.root_url}products/${this.handle}?section_id=api-product-upsell`).then(this.handleErrors).then((t => t.text())).then((t => {
                const e = document.createElement("div");
                e.innerHTML = t, this.modalContent = this.modal.querySelector($e), this.modalContent.innerHTML = e.querySelector("[data-api-content]").innerHTML, this.modalScroll = this.modal.querySelector(He);
                const i = this.modalContent.querySelector(Fe);
                if (i) {
                    const t = document.createElement("div");
                    t.innerHTML = i.parentElement.innerHTML, this.upsellHolder.dispatchEvent(new CustomEvent("theme:upsell:media", {
                        bubbles: !0,
                        detail: {
                            media: t
                        }
                    }))
                }
                this.modalCreate(), this.container.classList.remove(Je)
            }))
        }
        modalCreate() {
            r.show(this.modalID, {
                onShow: (t, e, i) => {
                    this.upsellHead = t.querySelector(Ie), this.upsellFormArea = t.querySelector(De), this.toggleButton = t.querySelector(Be), this.toggleForm("loading"), document.addEventListener("theme:resize", Te((() => {
                        this.toggleForm("resize")
                    }), 500)), this.clickEventToggleForm();
                    const s = t.querySelector(Re);
                    Ee(t, {
                        elementToFocus: s
                    }), this.modal.addEventListener("theme:upsell:close", this.modalCloseEvent), document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                        bubbles: !0,
                        detail: this.modalScroll
                    })), new Ce(this.modal)
                },
                onClose: (t, e, i) => {
                    t.querySelectorAll(We).forEach((t => {
                        t.dispatchEvent(new CustomEvent("pause"))
                    })), Le(), e.focus(), this.modal.removeEventListener("theme:upsell:close", this.modalCloseEvent), this.scrollLockEnable ? document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                        bubbles: !0
                    })) : this.scrollLockEnable = !0
                }
            })
        }
        modalClose() {
            r.close(this.modalID)
        }
        handleErrors(t) {
            return t.ok ? t : t.json().then((function(e) {
                throw new W({
                    status: t.statusText,
                    headers: t.headers,
                    json: e
                })
            }))
        }
        toggleForm(t) {
            this.windowH === window.innerHeight && "resize" === t || (this.toggleButton.classList.contains(Ve) || this.toggleButton.classList.add(Ve), this.upsellFormArea.classList.contains(Ue) || this.upsellFormArea.classList.add(Ue), "resize" === t && (this.upsellFormArea.classList.add(Ue), this.toggleButton.classList.add(Ve), this.windowH = window.innerHeight), setTimeout((() => {
                const e = window.innerHeight - this.upsellHead.offsetHeight - this.upsellFormArea.offsetHeight,
                    i = e < Ke;
                e < Ye && e > Ke || i ? (this.toggleButton.classList.remove(Ve), this.toggleButton.classList.add(je)) : this.toggleButton.classList.add(Ve), i ? ("loading" === t && (this.upsellFormArea.classList.add(Je), setTimeout((() => {
                    this.upsellFormArea.classList.remove(Je)
                }), 50)), this.upsellFormArea.classList.remove(Ue), this.toggleButton.classList.remove(je)) : this.upsellFormArea.classList.add(Ue)
            }), 200))
        }
        clickEventToggleForm() {
            this.toggleButton && this.toggleButton.addEventListener("click", (() => {
                this.toggleButton.classList.toggle(je), this.upsellFormArea.classList.toggle(Ue)
            }))
        }
        disconnectedCallback() {
            this.modalTemplate && this.triggerButton && this.triggerButton.removeEventListener("click", this.clickUpsellEvent)
        }
        constructor() {
            super(), this.container = this
        }
    };
    const Xe = (t, e = 500, i = !0) => {
            let s = window.getComputedStyle(t).display;
            if (i && "none" !== s) return;
            t.style.removeProperty("display"), "none" === s && (s = "block"), t.style.display = s;
            let o = t.offsetHeight;
            t.style.overflow = "hidden", t.style.height = 0, t.style.paddingTop = 0, t.style.paddingBottom = 0, t.style.marginTop = 0, t.style.marginBottom = 0, t.offsetHeight, t.style.boxSizing = "border-box", t.style.transitionTimingFunction = "cubic-bezier(0.215, 0.61, 0.355, 1)", t.style.transitionProperty = "height, margin, padding", t.style.transitionDuration = e + "ms", t.style.height = o + "px", t.style.removeProperty("padding-top"), t.style.removeProperty("padding-bottom"), t.style.removeProperty("margin-top"), t.style.removeProperty("margin-bottom"), window.setTimeout((() => {
                t.style.removeProperty("height"), t.style.removeProperty("overflow"), t.style.removeProperty("transition-duration"), t.style.removeProperty("transition-property"), t.style.removeProperty("transition-timing-function")
            }), e)
        },
        Qe = (t, e = 500) => {
            t.style.transitionProperty = "height, margin, padding", t.style.transitionTimingFunction = "cubic-bezier(0.215, 0.61, 0.355, 1)", t.style.transitionDuration = e + "ms", t.style.boxSizing = "border-box", t.style.height = t.offsetHeight + "px", t.offsetHeight, t.style.overflow = "hidden", t.style.height = 0, t.style.paddingTop = 0, t.style.paddingBottom = 0, t.style.marginTop = 0, t.style.marginBottom = 0, window.setTimeout((() => {
                t.style.display = "none", t.style.removeProperty("height"), t.style.removeProperty("padding-top"), t.style.removeProperty("padding-bottom"), t.style.removeProperty("margin-top"), t.style.removeProperty("margin-bottom"), t.style.removeProperty("overflow"), t.style.removeProperty("transition-duration"), t.style.removeProperty("transition-property"), t.style.removeProperty("transition-timing-function")
            }), e)
        },
        Ze = {
            wrapper: "[data-add-action-wrapper]",
            addButton: "[data-add-to-cart]",
            insideCart: "[data-add-inside-cart]",
            errorBoundary: "[data-error-boundary]",
            errorDisplay: "[data-error-display]",
            popdown: "[data-product-add-popdown-wrapper]",
            disabledAjax: '[data-ajax-disable="true"]',
            upsellModal: "[data-upsell-modal]",
            inputFile: '[type="file"]'
        },
        ti = "loading",
        ei = "has-success",
        ii = 3500,
        si = 5e3;
    let oi = class extends HTMLElement {
        connectedCallback() {
            if (this.isCartItem = Boolean(this.closest(Ze.insideCart)), this.button = this.wrapper.querySelector(Ze.addButton), this.errors = this.wrapper.querySelector(Ze.errors), !this.errors) {
                const t = this.wrapper.closest(Ze.errorBoundary);
                t && (this.errors = t.querySelector(Ze.errorDisplay))
            }
            this.popdown = document.querySelector(Ze.popdown), this.disabledAjax = document.querySelector(Ze.disabledAjax), this.button && this.initWithForm()
        }
        initWithForm() {
            this.button.addEventListener("click", function(t) {
                t.preventDefault();
                const e = t.target.closest("form");
                if (e.querySelector(Ze.inputFile)) return;
                this.disabledAjax || t.preventDefault(), this.button.setAttribute("disabled", !0), this.button.classList.add(ti);
                const i = new FormData(e),
                    s = new URLSearchParams(i).toString();
                this.addToCartAction(s)
            }.bind(this))
        }
        addToCartAction(t) {
            const e = `${window.theme.routes.cart}/add.js`,
                i = this;
            n.post(e, t, {
                headers: {
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/x-www-form-urlencoded"
                }
            }).then((function(t) {

              console.log('console the t');
              console.log(t)
                i.onSuccess(t.data)
    i.onSuccess(t.data);
            if (t.data.product_id == "14629195350388" || t.data.product_id == "14629195186548") {
    i.addAddons();
}
              console.log('added to the cart successfully');
              
            })).catch((function(t) {
                console.warn(t), i.onError(t.data)
            }))
        }
        onSuccess(t) {
            this.updateHeaderTotal(), this.button.classList.remove(ti), this.button.classList.add(ei), setTimeout((() => {
                this.button.classList.remove(ei), this.button.removeAttribute("disabled")
            }), ii), this.button.closest(Ze.upsellModal) && this.button.closest(Ze.upsellModal).dispatchEvent(new CustomEvent("theme:upsell:close")), this.isCartItem ? document.dispatchEvent(new CustomEvent("theme:cart:reload", {
                bubbles: !0
            })) : this.popdown.dispatchEvent(new CustomEvent("theme:cart:popdown", {
                detail: {
                    variant: t
                },
                bubbles: !0
            })), this.disabledAjax && window.location.reload()
        }
         addAddons() {
           console.log('addons script to be added');
           const checkbox = document.querySelector('.moe-checkbox');
    
    if (checkbox.checked) {
      var variantId = document.querySelector('.moe-checkbox').parentElement.getAttribute('data-addon-id');
      
      if (!variantId) {
        console.log('Product variant ID is missing.');
        return;
      }

      var quantity = 1;

      var data = {
        'id': variantId, 
        'quantity': quantity  
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
      .then(response => response.json())
      .then(data => {
        console.log('Product added to cart:', data);
        console.log('Product added to cart!');
      })
      .catch((error) => {
        console.error('Error adding product to cart:', error);
      });
    } else {
      
      console.log('Please check the box to add the product to your cart.');
    }
        }
        onError(t) {
            let e = "Network error: please try again";
            t && t.description && (e = t.description);
            const i = `<div class="errors">${e}</div>`;
            this.button.classList.remove(ti), this.button.removeAttribute("disabled"), this.errors.innerHTML = i, Xe(this.errors), setTimeout((() => {
                Qe(this.errors)
            }), si)
        }
        updateHeaderTotal() {
            n.get(`${window.theme.routes.cart}.js`).then((t => {
                document.dispatchEvent(new CustomEvent("theme:cart:change", {
                    detail: {
                        cart: t.data
                    },
                    bubbles: !0
                }))
            })).catch((t => {
                console.error(t)
            }))
        }
        constructor() {
            super(), this.wrapper = this
        }
    };
    customElements.get("upsell-product") || customElements.define("upsell-product", Ge), customElements.get("product-add-button") || customElements.define("product-add-button", oi);
    const ri = "[data-address-wrapper]",
        ni = "[data-new-address-form]",
        ai = "[new-address-form-inner]",
        li = ".address-new-toggle",
        ci = ".address-edit-toggle",
        hi = ".address-delete",
        di = "hide",
        ui = "data-form-id",
        pi = "data-confirm-message",
        mi = "Are you sure you wish to delete this address?",
        yi = "#EditAddress",
        gi = "AddressCountryNew",
        fi = "AddressProvinceNew",
        wi = "AddressProvinceContainerNew",
        vi = ".address-country-option",
        bi = "AddressCountry",
        Si = "AddressProvince",
        Ei = "AddressProvinceContainer";
    const Li = document.querySelector(ri);
    Li && new class {
        init() {
            if (this.addressNewForm) {
                const t = this.section,
                    e = this.addressNewForm.querySelector(ai);
                this.customerAddresses();
                const i = t.querySelectorAll(li);
                i.length && i.forEach((t => {
                    t.addEventListener("click", (function() {
                        e.classList.toggle(di)
                    }))
                }));
                const s = t.querySelectorAll(ci);
                s.length && s.forEach((e => {
                    e.addEventListener("click", (function() {
                        const e = this.getAttribute(ui);
                        t.querySelector(`${yi}_${e}`).classList.toggle(di)
                    }))
                }));
                const o = t.querySelectorAll(hi);
                o.length && o.forEach((t => {
                    t.addEventListener("click", (function() {
                        const t = this.getAttribute(ui),
                            e = this.getAttribute(pi);
                        confirm(e || mi) && Shopify.postLink(window.theme.routes.account_addresses_url + "/" + t, {
                            parameters: {
                                _method: "delete"
                            }
                        })
                    }))
                }))
            }
        }
        customerAddresses() {
            Shopify.CountryProvinceSelector && new Shopify.CountryProvinceSelector(gi, fi, {
                hideElement: wi
            }), this.section.querySelectorAll(vi).forEach((t => {
                const e = t.getAttribute(ui),
                    i = `${bi}_${e}`,
                    s = `${Si}_${e}`,
                    o = `${Ei}_${e}`;
                new Shopify.CountryProvinceSelector(i, s, {
                    hideElement: o
                })
            }))
        }
        constructor(t) {
            this.section = t, this.addressNewForm = this.section.querySelector(ni), this.init()
        }
    }(Li), document.querySelector("#RecoverPassword") && function() {
        var t = {
            recoverPasswordForm: "#RecoverPassword",
            hideRecoverPasswordLink: "#HideRecoverPasswordLink"
        };

        function e(t) {
            t.preventDefault(), s()
        }

        function i() {
            "#recover" === window.location.hash && s()
        }

        function s() {
            var t = document.querySelector("#CustomerEmail").value;
            document.querySelector("#RecoverEmail").value = t, document.querySelector("#RecoverPasswordForm").classList.toggle("display-none"), document.querySelector("#CustomerLoginForm").classList.toggle("display-none")
        }

        function o() {
            document.querySelector(".reset-password-success") && document.querySelector("#ResetSuccess").classList.remove("display-none")
        }
        i(), o(), document.querySelector(t.recoverPasswordForm).addEventListener("click", e), document.querySelector(t.hideRecoverPasswordLink).addEventListener("click", e)
    }(), window.Shopify = window.Shopify || {}, window.Shopify.theme = window.Shopify.theme || {}, window.Shopify.theme.sections = window.Shopify.theme.sections || {}, window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {}, window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || [];
    const Ti = window.Shopify.theme.sections.registered,
        ki = window.Shopify.theme.sections.instances,
        Ai = "data-section-id",
        qi = "data-section-type";
    let Ci = class {
        callFunctions(t, e = null) {
            this.callStack[t].forEach((t => {
                const i = {
                    id: this.id,
                    type: this.type,
                    container: this.container
                };
                e ? t.call(i, e) : t.call(i)
            }))
        }
        onLoad() {
            this.callFunctions("onLoad")
        }
        onUnload() {
            this.callFunctions("onUnload")
        }
        onSelect(t) {
            this.callFunctions("onSelect", t)
        }
        onDeselect(t) {
            this.callFunctions("onDeselect", t)
        }
        onBlockSelect(t) {
            this.callFunctions("onBlockSelect", t)
        }
        onBlockDeselect(t) {
            this.callFunctions("onBlockDeselect", t)
        }
        onReorder(t) {
            this.callFunctions("onReorder", t)
        }
        constructor(t, e) {
            this.container = function(t) {
                if (!(t instanceof Element)) throw new TypeError("Theme Sections: Attempted to load section. The section container provided is not a DOM element.");
                if (null === t.getAttribute(Ai)) throw new Error("Theme Sections: The section container provided does not have an id assigned to the " + Ai + " attribute.");
                return t
            }(t), this.id = t.getAttribute(Ai), this.type = e.type, this.callStack = e.getStack();
            try {
                this.onLoad()
            } catch (t) {
                console.warn(`Error in section: ${this.id}`), console.warn(this), console.warn(t)
            }
        }
    };

    function xi(t, e) {
        if ("string" != typeof t) throw new TypeError("Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered");
        if (void 0 !== Ti[t]) throw new Error('Theme Sections: A section of type "' + t + '" has already been registered. You cannot register the same section type twice');
        Array.isArray(e) || (e = [e]);
        const i = new class {
            getStack() {
                return this.callStack
            }
            constructor(t = null, e = []) {
                this.type = t, this.components = function(t) {
                    if (void 0 !== t && "object" != typeof t || null === t) throw new TypeError("Theme Sections: The components object provided is not a valid");
                    return t
                }(e), this.callStack = {
                    onLoad: [],
                    onUnload: [],
                    onSelect: [],
                    onDeselect: [],
                    onBlockSelect: [],
                    onBlockDeselect: [],
                    onReorder: []
                }, e.forEach((t => {
                    for (const [e, i] of Object.entries(t)) {
                        const t = this.callStack[e];
                        Array.isArray(t) && "function" == typeof i ? t.push(i) : (console.warn(`Unregisted function: '${e}' in component: '${this.type}'`), console.warn(i))
                    }
                }))
            }
        }(t, e);
        return Ti[t] = i, Ti
    }

    function Pi(t, e) {
        t = Hi(t), void 0 === e && (e = document.querySelectorAll("[" + qi + "]")), e = Mi(e), t.forEach((function(t) {
            const i = Ti[t];
            void 0 !== i && (e = e.filter((function(e) {
                return !($i(e).length > 0) && (null !== e.getAttribute(qi) && (e.getAttribute(qi) !== t || (ki.push(new Ci(e, i)), !1)))
            })))
        }))
    }

    function $i(t) {
        var e = [];
        if (NodeList.prototype.isPrototypeOf(t) || Array.isArray(t)) var i = t[0];
        if (t instanceof Element || i instanceof Element) Mi(t).forEach((function(t) {
            e = e.concat(ki.filter((function(e) {
                return e.container === t
            })))
        }));
        else if ("string" == typeof t || "string" == typeof i) {
            Hi(t).forEach((function(t) {
                e = e.concat(ki.filter((function(e) {
                    return e.type === t
                })))
            }))
        }
        return e
    }

    function _i(t) {
        for (var e, i = 0; i < ki.length; i++)
            if (ki[i].id === t) {
                e = ki[i];
                break
            } return e
    }

    function Hi(t) {
        return "*" === t ? t = Object.keys(Ti) : "string" == typeof t ? t = [t] : t.constructor === Ci ? t = [t.prototype.type] : Array.isArray(t) && t[0].constructor === Ci && (t = t.map((function(t) {
            return t.type
        }))), t = t.map((function(t) {
            return t.toLowerCase()
        }))
    }

    function Mi(t) {
        return NodeList.prototype.isPrototypeOf(t) && t.length > 0 ? t = Array.prototype.slice.call(t) : NodeList.prototype.isPrototypeOf(t) && 0 === t.length || null === t ? t = [] : !Array.isArray(t) && t instanceof Element && (t = [t]), t
    }
    window.Shopify.designMode && (document.addEventListener("shopify:section:load", (function(t) {
        var e = t.detail.sectionId,
            i = t.target.querySelector("[" + Ai + '="' + e + '"]');
        null !== i && Pi(i.getAttribute(qi), i)
    })), document.addEventListener("shopify:section:reorder", (function(t) {
        var e = t.detail.sectionId,
            i = t.target.querySelector("[" + Ai + '="' + e + '"]');
        "object" == typeof $i(i)[0] && $i(i).forEach((function(t) {
            t.onReorder()
        }))
    })), document.addEventListener("shopify:section:unload", (function(t) {
        var e = t.detail.sectionId,
            i = t.target.querySelector("[" + Ai + '="' + e + '"]');
        "object" == typeof $i(i)[0] && $i(i).forEach((function(t) {
            var e = ki.map((function(t) {
                return t.id
            })).indexOf(t.id);
            ki.splice(e, 1), t.onUnload()
        }))
    })), document.addEventListener("shopify:section:select", (function(t) {
        var e = _i(t.detail.sectionId);
        "object" == typeof e && e.onSelect(t)
    })), document.addEventListener("shopify:section:deselect", (function(t) {
        var e = _i(t.detail.sectionId);
        "object" == typeof e && e.onDeselect(t)
    })), document.addEventListener("shopify:block:select", (function(t) {
        var e = _i(t.detail.sectionId);
        "object" == typeof e && e.onBlockSelect(t)
    })), document.addEventListener("shopify:block:deselect", (function(t) {
        var e = _i(t.detail.sectionId);
        "object" == typeof e && e.onBlockDeselect(t)
    })));
    const Ii = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])';

    function Di(t) {
        const e = `data-popup-${t}`;
        r.init({
            openTrigger: e,
            disableScroll: !0,
            onShow: (t, e, i) => {
                i.preventDefault();
                const s = t.querySelector(Ii);
                Ee(t, {
                    elementToFocus: s
                })
            },
            onClose: (t, e, i) => {
                i.preventDefault(), Le(), e.focus()
            }
        })
    }
    const Bi = "[data-toggle-password-modal]",
        Wi = ".storefront-password-form .errors",
        Fi = {};
    xi("password", {
            onLoad() {
                Fi[this.id] = new class {
                    init() {
                        Di("password"), this.errors && this.trigger.click()
                    }
                    constructor(t) {
                        this.container = t.container, this.trigger = this.container.querySelector(Bi), this.errors = this.container.querySelector(Wi), this.init()
                    }
                }(this)
            }
        }),
        function() {
            var t = "#QrCode",
                e = ".giftcard__code";
            const i = document.querySelector(t);
            if (i) {
                function o() {
                    const t = i.getAttribute("data-identifier");
                    new QRCode(i, {
                        text: t,
                        width: 120,
                        height: 120
                    })
                }
                window.addEventListener("load", o)
            }
            const s = document.querySelector(e);
            if (s) {
                function r() {
                    var t = document.querySelector("#GiftCardDigits"),
                        e = "";
                    if (document.body.createTextRange)(e = document.body.createTextRange()).moveToElementText(t), e.select();
                    else if (window.getSelection) {
                        var i = window.getSelection();
                        (e = document.createRange()).selectNodeContents(t), i.removeAllRanges(), i.addRange(e)
                    }
                }
                s.addEventListener("click", r())
            }
        }();
    const Oi = "[data-parallax-wrapper]",
        Ni = "[data-parallax-img]";
    let zi = {};
    const Ri = {
        onLoad() {
            zi[this.id] = [];
            this.container.querySelectorAll(Oi).forEach((t => {
                const e = t.querySelector(Ni);
                zi[this.id].push(new a(e, {
                    center: !0,
                    round: !0,
                    frame: t
                }))
            }))
        },
        onUnload: function() {
            zi[this.id].forEach((t => {
                "function" == typeof t.destroy && t.destroy()
            }))
        }
    };
    xi("article", Ri);
    const Vi = "[data-ticker-frame]",
        ji = "[data-ticker-scale]",
        Ui = "[data-ticker-text]",
        Ji = "data-clone",
        Ki = "ticker--animated",
        Yi = "ticker--unloaded",
        Gi = "ticker__comparitor",
        Xi = 1.63,
        Qi = 100,
        Zi = {};
    let ts = class {
        unload() {
            document.removeEventListener("theme:resize", this.resizeEvent)
        }
        listen() {
            document.addEventListener("theme:resize", this.resizeEvent), this.checkWidth()
        }
        checkWidth() {
            const t = 2 * window.getComputedStyle(this.frame).paddingLeft.replace("px", "");
            if (this.frame.clientWidth - t < this.comparitor.clientWidth || this.stopClone) {
                if (this.text.classList.add(Ki), 1 === this.scale.childElementCount && (this.clone = this.text.cloneNode(!0), this.clone.setAttribute("aria-hidden", !0), this.clone.setAttribute(Ji, ""), this.scale.appendChild(this.clone), this.stopClone))
                    for (let t = 0; t < 10; t++) {
                        const t = this.text.cloneNode(!0);
                        t.setAttribute("aria-hidden", !0), t.setAttribute(Ji, ""), this.scale.appendChild(t)
                    }
                const t = this.text.clientWidth / Qi * Xi;
                this.scale.style.setProperty("--animation-time", `${t}s`)
            } else {
                this.text.classList.add(Ki);
                let t = this.scale.querySelector(`[${Ji}]`);
                t && this.scale.removeChild(t), this.text.classList.remove(Ki)
            }
        }
        constructor(t, e = !1) {
            this.frame = t, this.stopClone = e, this.scale = this.frame.querySelector(ji), this.text = this.frame.querySelector(Ui), this.comparitor = this.text.cloneNode(!0), this.comparitor.classList.add(Gi), this.frame.appendChild(this.comparitor), this.scale.classList.remove(Yi), this.resizeEvent = A((() => this.checkWidth()), 300), this.listen()
        }
    };
    const es = {
            onLoad() {
                Zi[this.id] = [];
                this.container.querySelectorAll(Vi).forEach((t => {
                    Zi[this.id].push(new ts(t))
                }))
            },
            onUnload() {
                Zi[this.id].forEach((t => {
                    "function" == typeof t.unload && t.unload()
                }))
            }
        },
        is = "data-slider-speed",
        ss = "data-slide",
        os = "data-slide-index";
    const rs = "[data-cart-message]",
        ns = "data-cart-message",
        as = "[data-left-to-spend]",
        ls = "[data-cart-progress]",
        cs = "data-limit",
        hs = "data-percent",
        ds = "is-success";
    let us = class {
        init() {
            this.cartFreeLimitShipping = 100 * Number(this.cartMessage[0].getAttribute(cs)) * this.rate, this.shippingAmount = 0, this.circumference = 28 * Math.PI, this.exchangeRateConversions(this.cartFreeLimitShipping, this.shippingAmount), this.cartBarProgress(), this.listen()
        }
        listen() {
            document.addEventListener("theme:cart:change", function(t) {
                this.cart = t.detail.cart, this.render()
            }.bind(this))
        }
        render() {
            const t = this.cart.total_price;
            this.freeShippingMessageHandle(t), this.cart && this.cart.total_price && this.cartMessage.length > 0 && (this.shippingAmount = t, this.updateProgress())
        }
        freeShippingMessageHandle(t) {
            this.cartMessage.length > 0 && this.container.querySelectorAll(rs).forEach((e => {
                const i = e.hasAttribute(ns) && "true" === e.getAttribute(ns) && t >= this.cartFreeLimitShipping && 0 !== t;
                e.classList.toggle(ds, i)
            }))
        }
        cartBarProgress(t = null) {
            this.container.querySelectorAll(ls).forEach((e => {
                this.setProgress(e, null === t ? e.getAttribute(hs) : t)
            }))
        }
        setProgress(t, e) {
            const i = this.circumference - e / 100 * this.circumference / 2;
            t.style.strokeDashoffset = i
        }
        updateProgress() {
            const t = this.shippingAmount / this.cartFreeLimitShipping * 100;
            this.exchangeRateConversions(this.cartFreeLimitShipping, this.shippingAmount), this.cartBarProgress(t > 100 ? 100 : t)
        }
        exchangeRateConversions(t, e) {
            const i = theme.settings.currency_code_enable ? l.formatMoney(t - e, theme.moneyFormat) + ` ${theme.currencyCode}` : l.formatMoney(t - e, theme.moneyFormat);
            this.container.querySelectorAll(as).forEach((t => {
                t.innerHTML = i.replace(".00", "")
            }))
        }
        constructor(t) {
            this.container = t, this.cartMessage = this.container.querySelectorAll(rs), this.rate = window.Shopify.currency.rate, this.cartMessage.length > 0 && this.init()
        }
    };
    const ps = "[data-bar]",
        ms = "[data-slide]",
        ys = "[data-ticker-frame]",
        gs = "[data-announcement-slider]",
        fs = "data-slide",
        ws = "[data-ticker-scale]",
        vs = "[data-ticker-text]",
        bs = "data-target-referrer",
        Ss = "data-slide",
        Es = "mobile",
        Ls = "desktop",
        Ts = "ticker--animated",
        ks = {};
    xi("announcement", {
        onLoad() {
            ks[this.id] = [], ks[this.id].push(new class {
                init() {
                    this.removeAnnouncement(), this.slider ? this.slider && this.slides && this.slides.length > 1 ? this.initSliders() : this.initTickers() : this.initTickers(!0)
                }
                removeAnnouncement() {
                    for (let t = 0; t < this.slides.length; t++) {
                        const e = this.slides[t];
                        e.hasAttribute(bs) && (-1 !== this.locationPath.indexOf(e.getAttribute(bs)) || window.Shopify.designMode || e.parentNode.removeChild(e))
                    }
                }
                initSliders() {
                    this.slider = new class {
                        init() {
                            const t = {
                                initialIndex: 0,
                                autoPlay: this.speed,
                                contain: !0,
                                pageDots: !1,
                                adaptiveHeight: !0,
                                wrapAround: !0,
                                groupCells: !1,
                                cellAlign: "left",
                                freeScroll: !1,
                                prevNextButtons: !0,
                                draggable: !0,
                                rightToLeft: window.isRTL,
                                on: {
                                    ready: () => {
                                        setTimeout((() => {
                                            this.slideshow.dispatchEvent(new CustomEvent("theme:announcement:loaded", {
                                                bubbles: !0,
                                                detail: {
                                                    slider: this
                                                }
                                            }))
                                        }), 50)
                                    }
                                }
                            };
                            this.flkty = new s(this.slideshow, t), this.flkty && (document.addEventListener("theme:resize", this.resizeEvent), document.addEventListener("theme:scroll", this.scrollEvent))
                        }
                        resizeEvents() {
                            this.flkty.resize()
                        }
                        scrollEvents() {
                            if (this.flkty && this.speed) {
                                const t = this.flkty.element,
                                    e = t.getBoundingClientRect().top + window.scrollY + t.offsetHeight;
                                window.pageYOffset > e ? "playing" === this.flkty.player.state && this.flkty.pausePlayer() : "paused" === this.flkty.player.state && this.flkty.playPlayer()
                            }
                        }
                        onUnload() {
                            this.slideshow && this.flkty && (document.removeEventListener("theme:resize", this.resizeEvent), document.removeEventListener("theme:scroll", this.scrollEvent), this.flkty.options.watchCSS = !1, this.flkty.destroy())
                        }
                        onBlockSelect(t) {
                            if (!this.slideshow) return;
                            const e = this.slideshow.querySelector(`[${ss}="${t.detail.blockId}"]`);
                            if (!e) return;
                            const i = parseInt(e.getAttribute(os));
                            this.flkty.selectCell(i), this.flkty.stopPlayer()
                        }
                        onBlockDeselect() {
                            this.flkty.playPlayer()
                        }
                        constructor(t, e) {
                            this.container = t, this.slideshow = e;
                            const i = this.slideshow.getAttribute(is);
                            this.speed = !!i && parseInt(i), this.scrollEvent = () => this.scrollEvents(), this.resizeEvent = () => this.resizeEvents(), this.slideshow && (this.flkty = null, this.init())
                        }
                    }(this.container, this.slider), this.slider.flkty.reposition(), this.barHolder.addEventListener("theme:announcement:loaded", (() => {
                        this.initTickers()
                    }))
                }
                initTickers(t = !1) {
                    const e = this.barHolder.querySelector(ys);
                    e && new ts(e, t)
                }
                toggleTicker(t, e) {
                    const i = document.querySelector(ws),
                        s = document.querySelector(`[${fs}="${t.detail.blockId}"]`);
                    e && s && (i.setAttribute("data-stop", ""), i.querySelectorAll(vs).forEach((t => {
                        t.classList.remove(Ts), t.style.transform = `translate3d(${-(s.offsetLeft-s.clientWidth)}px, 0, 0)`
                    }))), !e && s && (i.querySelectorAll(vs).forEach((t => {
                        t.classList.add(Ts), t.removeAttribute("style")
                    })), i.removeAttribute("data-stop"))
                }
                onBlockSelect(t) {
                    this.slider && "function" == typeof this.slider.onBlockSelect ? this.slider.onBlockSelect(t) : (document.querySelectorAll(`[${Ss}="${t.detail.blockId}"]`).forEach((t => {
                        t.classList.contains(Es) && (this.hasDeviceClass = Es), t.classList.contains(Ls) && (this.hasDeviceClass = Ls), "" !== this.hasDeviceClass && t.classList.remove(this.hasDeviceClass)
                    })), this.toggleTicker(t, !0))
                }
                onBlockDeselect(t) {
                    this.slider && "function" == typeof this.slider.onBlockDeselect ? this.slider.onBlockDeselect(t) : ("" !== this.hasDeviceClass && document.querySelectorAll(`[${Ss}="${t.detail.blockId}"]`).forEach((t => {
                        t.classList.add(this.hasDeviceClass)
                    })), this.toggleTicker(t, !1))
                }
                onUnload() {
                    this.slider && "function" == typeof this.slider.onUnload && this.slider.onUnload()
                }
                constructor(t) {
                    this.container = t.container, this.barHolder = this.container.querySelector(ps), this.locationPath = location.href, this.slides = this.barHolder.querySelectorAll(ms), this.slider = this.barHolder.querySelector(gs), this.hasDeviceClass = "", new us(this.container), this.init()
                }
            }(this))
        },
        onUnload() {
            ks[this.id].forEach((t => {
                "function" == typeof t.onUnload && t.onUnload()
            }))
        },
        onBlockSelect(t) {
            ks[this.id].forEach((e => {
                "function" == typeof e.onBlockSelect && e.onBlockSelect(t)
            }))
        },
        onBlockDeselect(t) {
            ks[this.id].forEach((e => {
                "function" == typeof e.onBlockSelect && e.onBlockDeselect(t)
            }))
        }
    });
    const As = "[data-ticker-frame]",
        qs = "data-slide",
        Cs = "[data-ticker-scale]",
        xs = "[data-ticker-text]",
        Ps = "ticker--animated",
        $s = {};
    xi("logos", {
        onLoad() {
            $s[this.id] = [], $s[this.id].push(new class {
                init() {
                    this.initTickers(!0)
                }
                initTickers(t = !1) {
                    const e = this.container.querySelector(As);
                    e && new ts(e, t)
                }
                toggleTicker(t, e) {
                    const i = this.container.querySelector(Cs),
                        s = this.container.querySelector(`[${qs}="${t.detail.blockId}"]`);
                    e && s && i && (i.setAttribute("data-stop", ""), i.querySelectorAll(xs).forEach((t => {
                        t.classList.remove(Ps), t.style.transform = `translate3d(${-(s.offsetLeft-s.clientWidth)}px, 0, 0)`
                    }))), !e && s && i && (i.querySelectorAll(xs).forEach((t => {
                        t.classList.add(Ps), t.removeAttribute("style")
                    })), i.removeAttribute("data-stop"))
                }
                onBlockSelect(t) {
                    this.toggleTicker(t, !0)
                }
                onBlockDeselect(t) {
                    this.toggleTicker(t, !1)
                }
                constructor(t) {
                    this.container = t.container, this.init()
                }
            }(this))
        },
        onBlockSelect(t) {
            $s[this.id].forEach((e => {
                "function" == typeof e.onBlockSelect && e.onBlockSelect(t)
            }))
        },
        onBlockDeselect(t) {
            $s[this.id].forEach((e => {
                "function" == typeof e.onBlockSelect && e.onBlockDeselect(t)
            }))
        }
    }), xi("blog", Ri);
    var _s = "[data-drawer]",
        Hs = "[data-drawer-scrolls]",
        Ms = "[data-drawer-underlay]",
        Is = "[data-stagger-animation]",
        Ds = "data-drawer-toggle",
        Bs = ":scope > * > [data-animates]",
        Ws = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
        Fs = "drawer--visible",
        Os = "display-none",
        Ns = {};
    const zs = {
            onLoad() {
                Ns[this.id] = [];
                this.container.querySelectorAll(_s).forEach((t => {
                    Ns[this.id].push(new class {
                        unload() {}
                        connectToggle() {
                            this.buttons.forEach((t => {
                                t.addEventListener("click", function(t) {
                                    t.preventDefault(), this.drawer.dispatchEvent(new CustomEvent("theme:drawer:toggle", {
                                        bubbles: !1
                                    }))
                                }.bind(this))
                            }))
                        }
                        connectDrawer() {
                            this.drawer.addEventListener("theme:drawer:toggle", function() {
                                this.drawer.classList.contains(Fs) ? this.drawer.dispatchEvent(new CustomEvent("theme:drawer:close", {
                                    bubbles: !1
                                })) : this.drawer.dispatchEvent(new CustomEvent("theme:drawer:open", {
                                    bubbles: !1
                                }))
                            }.bind(this)), this.drawer.addEventListener("theme:drawer:close", this.hideDrawer.bind(this)), this.drawer.addEventListener("theme:drawer:open", this.showDrawer.bind(this))
                        }
                        staggerChildAnimations() {
                            this.staggers.forEach((t => {
                                t.querySelectorAll(Bs).forEach(((t, e) => {
                                    t.style.transitionDelay = 50 * e + 10 + "ms"
                                }))
                            }))
                        }
                        closers() {
                            this.drawer.addEventListener("keyup", function(t) {
                                t.which === window.theme.keyboardKeys.ESCAPE && (this.hideDrawer(), this.buttons[0].focus())
                            }.bind(this)), this.underlay.addEventListener("click", function() {
                                this.hideDrawer()
                            }.bind(this))
                        }
                        showDrawer() {
                            this.drawer.classList.remove(Os), setTimeout((() => {
                                this.buttons.forEach((t => t.setAttribute("aria-expanded", !0))), this.drawer.classList.add(Fs), document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                                    bubbles: !0,
                                    detail: this.drawerScrolls
                                }));
                                const t = this.drawer.querySelector(Ws);
                                Ee(this.drawer, {
                                    elementToFocus: t
                                })
                            }), 1)
                        }
                        hideDrawer() {
                            this.buttons.forEach((t => t.setAttribute("aria-expanded", !0))), this.drawer.classList.remove(Fs), this.drawerScrolls.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                                bubbles: !0
                            })), document.dispatchEvent(new CustomEvent("theme:sliderule:close", {
                                bubbles: !1
                            })), Le(), setTimeout((() => {
                                this.drawer.classList.contains(Fs) || this.drawer.classList.add(Os)
                            }), 800)
                        }
                        constructor(t) {
                            this.drawer = t, this.drawerScrolls = this.drawer.querySelector(Hs), this.underlay = this.drawer.querySelector(Ms), this.key = this.drawer.dataset.drawer;
                            const e = `[${Ds}='${this.key}']`;
                            this.buttons = document.querySelectorAll(e), this.staggers = this.drawer.querySelectorAll(Is), this.connectToggle(), this.connectDrawer(), this.closers(), this.staggerChildAnimations()
                        }
                    }(t))
                }))
            },
            onUnload: function() {
                Ns[this.id].forEach((t => {
                    "function" == typeof t.unload && t.unload()
                }))
            }
        },
        Rs = "#shopify-section-announcement",
        Vs = "data-header-transparent",
        js = "[data-header-wrapper] header",
        Us = "js__header__stuck",
        Js = "js__header__stuck--animated",
        Ks = "js__header__stuck--trigger-animation",
        Ys = "js__header__stuck__backdrop";
    let Gs = {};
    const Xs = {
            onLoad() {
                Gs = new class {
                    unload() {
                        document.removeEventListener("theme:scroll", this.listen), document.removeEventListener("theme:scroll:up", this.scrollUpDirectional), document.removeEventListener("theme:scroll:down", this.scrollDownDirectional)
                    }
                    listen() {
                        (this.sticks || this.animated) && document.addEventListener("theme:scroll", (t => {
                            t.detail.down ? (!this.currentlyStuck && t.detail.position > this.stickDown && this.stickSimple(), !this.currentlyBlurred && t.detail.position > this.blur && this.addBlur()) : (t.detail.position <= this.stickUp && this.unstickSimple(), t.detail.position <= this.blur && this.removeBlur())
                        })), this.animated && (document.addEventListener("theme:scroll:up", this.scrollUpDirectional.bind(this)), document.addEventListener("theme:scroll:down", this.scrollDownDirectional.bind(this)))
                    }
                    stickSimple() {
                        this.animated && this.cls.add(Js), this.cls.add(Us), this.wrapper.setAttribute(Vs, !1), this.currentlyStuck = !0
                    }
                    unstickSimple() {
                        this.cls.remove(Us), this.wrapper.setAttribute(Vs, this.transparent), this.animated && this.cls.remove(Js), this.currentlyStuck = !1
                    }
                    scrollDownInit() {
                        window.scrollY > this.stickDown && this.stickSimple(), window.scrollY > this.blur && this.addBlur()
                    }
                    stickDirectional() {
                        this.cls.add(Ks)
                    }
                    unstickDirectional() {
                        this.cls.remove(Ks)
                    }
                    scrollDownDirectional() {
                        this.unstickDirectional()
                    }
                    scrollUpDirectional() {
                        window.scrollY <= this.stickDown ? this.unstickDirectional() : this.stickDirectional()
                    }
                    addBlur() {
                        this.cls.add(Ys), this.currentlyBlurred = !0
                    }
                    removeBlur() {
                        this.cls.remove(Ys), this.currentlyBlurred = !1
                    }
                    constructor(t) {
                        this.wrapper = t, this.type = this.wrapper.dataset.headerSticky, this.transparent = this.wrapper.dataset.headerTransparent, this.sticks = "sticky" === this.type, this.animated = "directional" === this.type, this.currentlyStuck = !1, this.cls = this.wrapper.classList;
                        const e = document.querySelector(Rs),
                            i = e ? e.clientHeight : 0,
                            s = document.querySelector(js).clientHeight;
                        this.blur = s + i, this.stickDown = s + i, this.stickUp = i, "false" !== this.wrapper.getAttribute(Vs) && (this.blur = i), this.sticks && (this.stickDown = i, this.scrollDownInit()), this.listen()
                    }
                }(this.container)
            },
            onUnload: function() {
                "function" == typeof Gs.unload && Gs.unload()
            }
        },
        Qs = "data-hover-disclosure-toggle",
        Zs = "[data-hover-disclosure]",
        to = "[data-top-link]",
        eo = "[data-header-wrapper]",
        io = "[data-stagger]",
        so = "[data-stagger-first]",
        oo = "[data-stagger-second]",
        ro = "[data-grid-item], [data-header-image]",
        no = "is-visible",
        ao = "meganav--visible",
        lo = "grandparent";
    let co = {},
        ho = {};
    const uo = {
            onLoad() {
                co[this.id] = [], ho = this.container.querySelectorAll(Zs), ho.forEach((t => {
                    co[this.id].push(new class {
                        onBlockSelect(t) {
                            this.disclosure.contains(t.target) && this.showDisclosure()
                        }
                        onBlockDeselect(t) {
                            this.disclosure.contains(t.target) && this.hideDisclosure()
                        }
                        showDisclosure() {
                            this.grandparent ? this.wrapper.classList.add(ao) : this.wrapper.classList.remove(ao), this.trigger.setAttribute("aria-expanded", !0), this.trigger.classList.add(no), this.disclosure.classList.add(no)
                        }
                        hideDisclosure() {
                            this.disclosure.classList.remove(no), this.trigger.classList.remove(no), this.trigger.setAttribute("aria-expanded", !1), this.wrapper.classList.remove(ao)
                        }
                        staggerChildAnimations() {
                            this.disclosure.querySelectorAll(io).forEach(((t, e) => {
                                t.style.transitionDelay = 50 * e + 10 + "ms"
                            })), this.disclosure.querySelectorAll(so).forEach(((t, e) => {
                                const i = 150 * e;
                                t.style.transitionDelay = `${i}ms`, t.parentElement.querySelectorAll(oo).forEach(((t, e) => {
                                    const s = 20 * (e + 1);
                                    t.style.transitionDelay = `${i+s}ms`
                                }))
                            })), this.disclosure.querySelectorAll(ro).forEach(((t, e) => {
                                t.style.transitionDelay = 80 * (e + 1) + "ms"
                            }))
                        }
                        handleTablets() {
                            this.trigger.addEventListener("touchstart", function(t) {
                                this.disclosure.classList.contains(no) || (t.preventDefault(), this.showDisclosure())
                            }.bind(this), {
                                passive: !0
                            })
                        }
                        connectHoverToggle() {
                            this.trigger.addEventListener("mouseenter", this.showDisclosure.bind(this)), this.link.addEventListener("focus", this.showDisclosure.bind(this)), this.trigger.addEventListener("mouseleave", this.hideDisclosure.bind(this)), this.trigger.addEventListener("focusout", function(t) {
                                this.trigger.contains(t.relatedTarget) || this.hideDisclosure()
                            }.bind(this)), this.disclosure.addEventListener("keyup", function(t) {
                                t.which === window.theme.keyboardKeys.ESCAPE && this.hideDisclosure()
                            }.bind(this))
                        }
                        constructor(t) {
                            this.disclosure = t, this.wrapper = t.closest(eo), this.key = this.disclosure.id;
                            const e = `[${Qs}='${this.key}']`;
                            this.trigger = document.querySelector(e), this.link = this.trigger.querySelector(to), this.grandparent = this.trigger.classList.contains(lo), this.trigger.setAttribute("aria-haspopup", !0), this.trigger.setAttribute("aria-expanded", !1), this.trigger.setAttribute("aria-controls", this.key), this.connectHoverToggle(), this.handleTablets(), this.staggerChildAnimations()
                        }
                    }(t))
                }))
            },
            onBlockSelect(t) {
                co[this.id].forEach((e => {
                    "function" == typeof e.onBlockSelect && e.onBlockSelect(t)
                }))
            },
            onBlockDeselect(t) {
                co[this.id].forEach((e => {
                    "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t)
                }))
            },
            onUnload: function() {
                co[this.id].forEach((t => {
                    "function" == typeof t.unload && t.unload()
                }))
            }
        },
        po = "[data-main-menu-text-item]",
        mo = "[data-text-items-wrapper]",
        yo = ".navtext",
        go = "data-menu-active",
        fo = "[data-header-wrapper]",
        wo = "data-underline-current",
        vo = ".menu__item.main-menu--active .navtext, .header__desktop__button.main-menu--active .navtext";
    let bo = {},
        So = null;
    const Eo = {
            onLoad() {
                bo[this.id] = [];
                this.container.querySelectorAll(mo).forEach((t => {
                    bo[this.id].push(new class {
                        init() {
                            if (this.itemList.length) {
                                if (this.listen(), this.listenResize(), this.textBottom = null, this.setHeight(), So) {
                                    if (this.defaultItem) {
                                        const t = this.defaultItem.offsetLeft || 0;
                                        this.sectionOuter.style.setProperty("--bar-left", `${t}px`)
                                    }
                                    this.reset()
                                } else {
                                    const t = this.sectionOuter.querySelector(po).offsetLeft;
                                    this.sectionOuter.style.setProperty("--bar-left", `${t}px`), this.sectionOuter.style.setProperty("--bar-width", "0px")
                                }
                                this.sectionOuter.style.setProperty("--bar-opacity", "1")
                            }
                        }
                        unload() {
                            document.removeEventListener("theme:resize", this.reset), So = null
                        }
                        listenResize() {
                            document.addEventListener("theme:resize", this.reset.bind(this))
                        }
                        setDefault() {
                            this.defaultItem && (So = {
                                left: this.defaultItem.offsetLeft || null,
                                width: this.defaultItem.clientWidth || null
                            })
                        }
                        setHeight() {
                            const t = this.wrapper.clientHeight,
                                e = this.itemList[0].querySelector(yo).clientHeight,
                                i = Math.floor(t / 2 - e / 2) - 4;
                            this.textBottom !== i && (this.sectionOuter.style.setProperty("--bar-text", `${e}px`), this.sectionOuter.style.setProperty("--bar-bottom", `${i}px`), this.textBottom = i)
                        }
                        listen() {
                            this.itemList.forEach((t => {
                                t.addEventListener("mouseenter", (t => {
                                    const e = t.target.querySelector(yo);
                                    this.startBar(e)
                                }))
                            })), this.wrapper.addEventListener("mouseleave", this.clearBar.bind(this))
                        }
                        startBar(t) {
                            this.setHeight();
                            let e = "false" !== this.sectionOuter.getAttribute(go),
                                i = t.offsetLeft,
                                s = t.clientWidth;
                            e ? this.render(s, i) : (this.sectionOuter.setAttribute(go, !0), this.render(0, i), setTimeout((() => {
                                this.render(s, i)
                            }), 10))
                        }
                        render(t, e) {
                            this.sectionOuter.style.setProperty("--bar-left", `${e}px`), this.sectionOuter.style.setProperty("--bar-width", `${t}px`)
                        }
                        reset() {
                            this.setDefault(), So && So.left && So.width ? (this.sectionOuter.style.setProperty("--bar-left", `${So.left}px`), this.sectionOuter.style.setProperty("--bar-width", `${So.width}px`)) : this.sectionOuter.style.setProperty("--bar-width", "0px")
                        }
                        clearBar() {
                            this.sectionOuter.setAttribute(go, !1), setTimeout((() => {
                                "false" !== this.sectionOuter.getAttribute(go) || this.reset()
                            }), 150)
                        }
                        constructor(t) {
                            this.wrapper = t, this.itemList = this.wrapper.querySelectorAll(po), this.sectionOuter = document.querySelector(fo), this.underlineCurrent = "true" === this.sectionOuter.getAttribute(wo), this.defaultItem = null, this.underlineCurrent && (this.defaultItem = this.wrapper.querySelector(vo)), this.setDefault(), document.fonts.ready.then((() => {
                                this.init()
                            }))
                        }
                    }(t))
                }))
            },
            onUnload: function() {
                bo[this.id].forEach((t => {
                    "function" == typeof t.unload && t.unload()
                })), delete bo[this.id]
            }
        },
        Lo = "data-header-cart-price",
        To = "data-header-cart-count",
        ko = "data-header-cart-full";
    const Ao = {
            onLoad() {
                new class {
                    listen() {
                        document.addEventListener("theme:cart:change", function(t) {
                            this.cart = t.detail.cart, this.update()
                        }.bind(this))
                    }
                    update() {
                        this.cart && (this.prices.forEach((t => {
                            t.setAttribute(Lo, this.cart.total_price);
                            const e = l.formatMoney(this.cart.total_price, theme.moneyFormat);
                            t.innerHTML = e
                        })), this.counts.forEach((t => {
                            t.setAttribute(To, this.cart.item_count), t.innerHTML = `(${this.cart.item_count})`
                        })), this.dots.forEach((t => {
                            const e = this.cart.item_count > 0;
                            t.setAttribute(ko, e)
                        })))
                    }
                    constructor(t) {
                        this.section = t, this.counts = this.section.querySelectorAll(`[${To}]`), this.prices = this.section.querySelectorAll(`[${Lo}]`), this.dots = this.section.querySelectorAll(`[${ko}]`), this.cart = null, this.listen()
                    }
                }(this.container)
            }
        },
        qo = "[data-search-popdown-wrap]",
        Co = "data-popdown-toggle",
        xo = "[data-close-popdown]",
        Po = "[data-predictive-search-input]",
        $o = "[data-search-underlay]",
        _o = "underlay--visible",
        Ho = "is-visible";
    let Mo = {};
    const Io = {
            onLoad() {
                Mo[this.id] = {};
                const t = this.container.querySelector(`[${Co}]`);
                t && (Mo[this.id] = new class {
                    initTriggerEvents() {
                        this.trigger.setAttribute("aria-haspopup", !0), this.trigger.setAttribute("aria-expanded", !1), this.trigger.setAttribute("aria-controls", this.key), this.trigger.addEventListener("click", function(t) {
                            t.preventDefault(), this.showPopdown()
                        }.bind(this)), this.trigger.addEventListener("keyup", function(t) {
                            t.which === window.theme.keyboardKeys.SPACE && this.showPopdown()
                        }.bind(this))
                    }
                    initPopdownEvents() {
                        this.popdown.addEventListener("keyup", function(t) {
                            t.which === window.theme.keyboardKeys.ESCAPE && this.hidePopdown()
                        }.bind(this)), this.close.addEventListener("click", function() {
                            this.hidePopdown()
                        }.bind(this)), this.underlay.addEventListener("click", function() {
                            this.hidePopdown()
                        }.bind(this))
                    }
                    hidePopdown() {
                        this.popdown.classList.remove(Ho), this.underlay.classList.remove(_o), this.trigger.focus(), this.input.value = "", Le(), this.input.dispatchEvent(new CustomEvent("theme:search:clear", {
                            bubbles: !1
                        })), this.popdown.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                            bubbles: !0
                        }))
                    }
                    showPopdown() {
                        this.input.value = "", this.popdown.classList.add(Ho), this.underlay.classList.add(_o), Ee(this.popdown, {
                            elementToFocus: this.input
                        }), this.popdown.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                            bubbles: !0
                        }))
                    }
                    constructor(t) {
                        this.trigger = t, this.key = this.trigger.getAttribute(Co), this.popdown = document.querySelector(`[id='${this.key}']`), this.input = this.popdown.querySelector(Po), this.close = this.popdown.querySelector(xo), this.wrapper = this.popdown.closest(qo), this.underlay = this.wrapper.querySelector($o), this.initTriggerEvents(), this.initPopdownEvents()
                    }
                }(t))
            },
            onUnload: function() {
                "function" == typeof Mo[this.id].unload && Mo[this.id].unload()
            }
        },
        Do = "data-grid-item-variant",
        Bo = "data-grid-image";
    let Wo = class extends HTMLElement {
        connectedCallback() {
            this.gridItemVariantLinks.length && this.gridItemVariantLinks.forEach((t => {
                t.hasAttribute(Do) && (this.siblingHoverEvent(t), this.siblingClickEvent(t))
            }))
        }
        siblingHoverEvent(t) {
            t.addEventListener("mouseenter", (() => {
                if (t.hasAttribute(Do)) {
                    const e = t.getAttribute(Do);
                    this.container.querySelectorAll(`product-grid-item-content[${Do}]`).forEach((t => {
                        t.getAttribute(Do) === e && t.querySelectorAll(`[${Bo}]`).forEach((t => {
                            t.classList.add("lazypreload")
                        }))
                    }))
                }
            }))
        }
        siblingClickEvent(t) {
            t.addEventListener("click", (e => {
                e.preventDefault();
                const i = this.container.querySelector(`a[${Do}][aria-current="true"]`);
                if (i && i.removeAttribute("aria-current"), t.setAttribute("aria-current", "true"), t.hasAttribute(Do)) {
                    const e = t.getAttribute(Do);
                    this.container.querySelectorAll(`product-grid-item-content[${Do}]`).forEach((t => {
                        t.getAttribute(Do) === e ? t.removeAttribute("hidden") : t.setAttribute("hidden", "")
                    }))
                }
            }))
        }
        constructor() {
            super(), this.container = this, this.gridItemVariantLinks = this.container.querySelectorAll(`a[${Do}]`)
        }
    };
    const Fo = "[data-grid-link]",
        Oo = "data-grid-images",
        No = "data-grid-image",
        zo = "data-grid-image-target",
        Ro = "data-grid-image-current-variant",
        Vo = "data-grid-pagination",
        jo = "data-grid-page",
        Uo = "data-stop-slideshow-mobile",
        Jo = "--width",
        Ko = "is-active",
        Yo = "is-mobile",
        Go = "product-grid-item__pagination",
        Xo = 1500;
    let Qo = class extends HTMLElement {
        static get observedAttributes() {
            return ["hidden"]
        }
        connectedCallback() {
            this.images.length > 1 && (this.createPaging(), this.container.addEventListener("theme:swatch:change", (t => {
                const e = t.detail.id,
                    i = this.container.querySelector(`[${zo}="${e}"]`);
                if (i) {
                    const e = i.getAttribute(No);
                    this.pagingProgressCounter = 0, this.changeImage(e), t.detail.stopSlideAnimation && this.stopPaging()
                }
            }))), this.images.length > 1 && (this.mobileStopSlideshow && (this.checkMobile(), document.addEventListener("theme:resize:width", (() => this.checkMobile()))), this.container.addEventListener("mouseenter", (() => {
                this.pagingProgressPause = this.mobileStopProgress, this.progressPaging()
            })), this.container.addEventListener("mouseleave", (() => {
                this.pagingProgressPause = !0, this.changeToCurrentVariantImage(), this.progressPaging()
            })))
        }
        attributeChangedCallback(t) {
            "hidden" === t && this.changeToCurrentVariantImage()
        }
        checkMobile() {
            const t = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            this.mobileStopProgress = t < window.theme.sizes.medium, this.container.classList.toggle(Yo, this.mobileStopProgress)
        }
        changeToCurrentVariantImage() {
            const t = this.container.querySelector(`[${Ro}]`);
            if (!t) return;
            const e = t.getAttribute(No);
            e && (this.pagingProgressPause = !0, this.changeImage(Number(e)))
        }
        changeImage(t = null) {
            const e = this.container.querySelector(`[${No}].${Ko}`),
                i = null !== t ? this.images[t] : e.nextSibling ? e.nextSibling : this.images[0];
            if (e && e.classList.remove(Ko), i) {
                const t = i.hasAttribute(No) ? i.getAttribute(No) : 0;
                i.classList.add(Ko), this.changePaging(t)
            }
        }
        changePaging(t = 0) {
            const e = this.container.querySelector(`[${jo}].${Ko}`),
                i = this.container.querySelector(`[${jo}="${t}"]`);
            e && (e.style.setProperty(Jo, "100%"), e.classList.remove(Ko)), i && (i.classList.add(Ko), this.progressPaging())
        }
        progressPaging() {
            const t = this.container.querySelector(`[${jo}].${Ko}`);
            t && !this.mobileStopProgress && (this.stopPaging(), 0 === this.pagingProgressCounter && t.style.setProperty(Jo, "0%"), this.interval = setInterval((() => {
                this.pagingProgressCounter >= 100 && !this.pagingProgressPause ? (this.stopPaging(), this.pagingProgressCounter = 0, this.changeImage()) : this.pagingProgressPause || (this.pagingProgressCounter++, t.style.setProperty(Jo, `${this.pagingProgressCounter}%`))
            }), this.timeout / 100))
        }
        stopPaging() {
            this.interval && clearInterval(this.interval)
        }
        createPaging() {
            if (this.imagesHolder) {
                let t = "";
                for (let e = 0; e < this.images.length; e++) {
                    let i = "";
                    0 === e && (i = `class="${Ko}"`), t += `<span ${i} ${jo}="${e}">${e+1}</span>`
                }
                if ("" !== t) {
                    let e = this.container.querySelector(`[${Vo}]`);
                    e || (e = document.createElement("div"), e.className = Go, e.setAttribute(Vo, "")), e.innerHTML = t, this.imagesHolder.parentElement.prepend(e)
                }
            }
        }
        removePaging() {
            const t = this.container.querySelector(`[${Vo}]`);
            t && t.remove()
        }
        constructor() {
            super(), this.container = this, this.mobileStopSlideshow = "true" === this.container.getAttribute(Uo), this.imagesHolder = this.container.querySelector(`[${Oo}]`), this.images = this.container.querySelectorAll(`[${No}]`), this.links = this.container.querySelectorAll(Fo), this.imagesLimit = this.imagesHolder && this.imagesHolder.hasAttribute(Oo) ? parseInt(this.imagesHolder.getAttribute(Oo)) : 5, this.timeout = Xo, this.interval = null, this.mobileStopProgress = !1, this.pagingProgressPause = !1, this.pagingProgressCounter = 0, this.siblingsFetchCounter = 0, this.siblingLoadImageIndex = null
        }
    };
    const Zo = "[data-popout]",
        tr = "[data-popout-list]",
        er = "data-popout-list-scroll",
        ir = "data-popout-toggle",
        sr = "[data-popout-input]",
        or = "[data-popout-option]",
        rr = "data-popout-prevent",
        nr = "data-quantity-field",
        ar = "data-value",
        lr = "aria-expanded",
        cr = "aria-current",
        hr = "popout-list--visible",
        dr = "--current";
    let ur = class extends HTMLElement {
        unload() {
            this.popoutOptions.length && this.popoutOptions.forEach((t => {
                t.removeEventListener("theme:popout:click", this.popupOptionsClick.bind(this)), t.removeEventListener("click", this._connectOptionsDispatch.bind(this))
            })), this.popoutToggle.removeEventListener("click", this.popupToggleClick.bind(this)), this.popoutToggle.removeEventListener("focusout", this.popupToggleFocusout.bind(this)), this.popoutList.removeEventListener("focusout", this.popupListFocusout.bind(this)), this.container.removeEventListener("keyup", this.containerKeyup.bind(this)), this.outsidePopupToggle && (this.outsidePopupToggle.removeEventListener("click", this.popupToggleClick.bind(this)), this.outsidePopupToggle.removeEventListener("focusout", this.popupToggleFocusout.bind(this)))
        }
        popupToggleClick(t) {
            const e = "true" === t.currentTarget.getAttribute(lr);
            t.currentTarget.setAttribute(lr, !e), this.popoutList.classList.toggle(hr), this.popupListMaxWidth(), this.popoutList.hasAttribute(er) && setTimeout((() => {
                this.popoutList.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                    bubbles: !0
                }))
            }), 1)
        }
        popupToggleFocusout(t) {
            this.container.contains(t.relatedTarget) || this._hideList()
        }
        popupListFocusout(t) {
            const e = t.currentTarget.contains(t.relatedTarget);
            this.popoutList.classList.contains(hr) && !e && this._hideList()
        }
        popupListMaxWidth() {
            this.popoutList.style.maxWidth = `${parseInt(document.body.clientWidth-this.popoutList.getBoundingClientRect().left)}px`
        }
        popupOptionsClick(t) {
            if ("#" === t.target.closest(or).attributes.href.value) {
                t.preventDefault();
                let e = "";
                if (t.currentTarget.getAttribute(ar) && (e = t.currentTarget.getAttribute(ar)), this.popoutInput.value = e, this.popoutPrevent) {
                    this.popoutInput.dispatchEvent(new Event("change")), !t.detail.preventTrigger && this.popoutInput.hasAttribute(nr) && this.popoutInput.dispatchEvent(new Event("input"));
                    const i = this.popoutList.querySelector(`[class*="${dr}"]`);
                    let s = dr;
                    if (i && i.classList.length)
                        for (const t of i.classList)
                            if (t.includes(dr)) {
                                s = t;
                                break
                            } const o = this.popoutList.querySelector(`.${s}`);
                    o && (o.classList.remove(`${s}`), t.currentTarget.parentElement.classList.add(`${s}`));
                    const r = this.popoutList.querySelector(`[${cr}]`);
                    r && r.hasAttribute(`${cr}`) && (r.removeAttribute(`${cr}`), t.currentTarget.setAttribute(`${cr}`, "true")), "" !== e && (this.popoutToggle.textContent = e, this.outsidePopupToggle && (this.outsidePopupToggle.textContent = e)), this.popupToggleFocusout(t), this.popupListFocusout(t)
                } else this._submitForm(e)
            }
        }
        updatePopout(t) {
            const e = this.popoutList.querySelector(`[${ar}="${this.popoutInput.value}"]`);
            e && e.dispatchEvent(new CustomEvent("theme:popout:click", {
                cancelable: !0,
                bubbles: !0,
                detail: {
                    preventTrigger: !0
                }
            }))
        }
        containerKeyup(t) {
            t.which === window.theme.keyboardKeys.ESCAPE && (this._hideList(), this.popoutToggle.focus())
        }
        bodyClick(t) {
            const e = this.container.contains(t.target),
                i = this.popoutList.classList.contains(hr);
            this.outsidePopupToggle, t.target, i && !e && this._hideList()
        }
        _connectToggle() {
            this.popoutToggle.addEventListener("click", this.popupToggleClick.bind(this)), this.outsidePopupToggle && this.outsidePopupToggle.addEventListener("click", this.popupToggleClick.bind(this))
        }
        _connectOptions() {
            this.popoutOptions.length && this.popoutOptions.forEach((t => {
                t.addEventListener("theme:popout:click", this.popupOptionsClick.bind(this)), t.addEventListener("click", this._connectOptionsDispatch.bind(this))
            }))
        }
        _connectOptionsDispatch(t) {
            const e = new CustomEvent("theme:popout:click", {
                cancelable: !0,
                bubbles: !0,
                detail: {
                    preventTrigger: !1
                }
            });
            t.target.dispatchEvent(e) || t.preventDefault()
        }
        _onFocusOut() {
            this.popoutToggle.addEventListener("focusout", this.popupToggleFocusout.bind(this)), this.outsidePopupToggle && this.outsidePopupToggle.addEventListener("focusout", this.popupToggleFocusout.bind(this)), this.popoutList.addEventListener("focusout", this.popupListFocusout.bind(this)), this.container.addEventListener("keyup", this.containerKeyup.bind(this)), document.body.addEventListener("click", this.bodyClick.bind(this))
        }
        _submitForm(t) {
            const e = this.container.closest("form");
            e && e.submit()
        }
        _hideList() {
            this.popoutList.classList.remove(hr), this.popoutToggle.setAttribute(lr, !1), this.outsidePopupToggle && this.outsidePopupToggle.setAttribute(lr, !1)
        }
        constructor() {
            super(), this.container = this.querySelector(Zo), this.popoutList = this.container.querySelector(tr), this.popoutToggle = this.container.querySelector(`[${ir}]`), this.outsidePopupToggle = document.querySelector(`[${ir}="${this.popoutList.id}"]`), this.popoutInput = this.container.querySelector(sr), this.popoutOptions = this.container.querySelectorAll(or), this.popoutPrevent = "true" === this.container.getAttribute(rr), this._connectOptions(), this._connectToggle(), this._onFocusOut(), this.popupListMaxWidth(), this.popoutInput && this.popoutInput.hasAttribute(nr) && document.addEventListener("theme:popout:update", this.updatePopout.bind(this)), document.addEventListener("theme:resize", (() => {
                this.popupListMaxWidth()
            }))
        }
    };
    const pr = "[data-cart-note]";
    class mr {
        initInputs() {
            this.inputs.forEach((t => {
                t.addEventListener("change", function(t) {
                    const e = t.target.value.toString() || "";
                    this.saveNotes(e)
                }.bind(this))
            }))
        }
        saveNotes(t) {
            window.fetch(`${window.theme.routes.cart}/update.js`, {
                method: "post",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    note: t
                })
            }).catch((t => {
                console.error(t)
            }))
        }
        constructor(t) {
            this.inputs = t.querySelectorAll(pr), this.initInputs()
        }
    }
    const yr = (t, e = [], i = !1) => {
            const s = Object.keys(t).map((s => {
                let o = t[s];
                if ("[object Object]" === Object.prototype.toString.call(o) || Array.isArray(o)) return Array.isArray(t) ? e.push("") : e.push(s), yr(o, e, Array.isArray(o));
                {
                    let t = s;
                    if (e.length > 0) {
                        t = (i ? e : [...e, s]).reduce(((t, e) => "" === t ? e : `${t}[${e}]`), "")
                    }
                    return i ? `${t}[]=${o}` : `${t}=${o}`
                }
            })).join("&");
            return e.pop(), s
        },
        gr = "html",
        fr = "[data-submit-shipping]",
        wr = "[data-shipping-estimate-form]",
        vr = "[data-response-template]",
        br = "#estimate_address_country",
        Sr = "#estimate_address_province",
        Er = "#estimate_address_zip",
        Lr = "[data-response-wrapper]",
        Tr = "lang",
        kr = "data-default",
        Ar = "shipping--success",
        qr = "errors",
        Cr = "disabled";
    class xr {
        enableButtons() {
            this.button.removeAttribute("disabled"), this.button.classList.remove(Cr)
        }
        disableButtons() {
            this.button.setAttribute("disabled", "disabled"), this.button.classList.add(Cr)
        }
        render(t) {
            if (this.template && this.ratesWrapper) {
                const e = u.render(this.template, t);
                this.ratesWrapper.innerHTML = e
            }
            this.enableButtons(), this.ratesWrapper.style.removeProperty("display")
        }
        estimate(t) {
            const e = encodeURI(yr({
                    shipping_address: t
                })),
                i = `${window.theme.routes.cart}/shipping_rates.json?${e}`,
                s = this;
            n.get(i).then((function(t) {
                const e = s.sanitize(t);
                s.render(e), s.enableButtons(), s.ratesWrapper.style.removeProperty("display")
            })).catch((function(t) {
                const e = s.sanitizeErrors(t);
                s.render(e)
            }))
        }
        sanitize(t) {
            const e = {};
            if (e.class = Ar, e.items = [], t.data.shipping_rates && t.data.shipping_rates.length > 0) {
                t.data.shipping_rates.forEach((t => {
                    let i = {};
                    i.title = t.presentment_name, i.value = l.formatMoney(t.price, theme.moneyFormat), e.items.push(i)
                }))
            } else e.items[0] = {
                value: theme.strings.noShippingAvailable
            };
            return e
        }
        sanitizeErrors(t) {
            const e = {};
            if (e.class = qr, e.items = [], "object" == typeof t.data)
                for (const [i, s] of Object.entries(t.data)) {
                    let t = {};
                    t.title = i.toString(), t.value = s.toString(), e.items.push(t)
                } else e.items[0] = {
                    value: theme.strings.noShippingAvailable
                };
            return e
        }
        init() {
            const t = document.querySelector(gr);
            let e = "en";
            t.hasAttribute(Tr) && "" !== t.getAttribute(Tr) && (e = t.getAttribute(Tr)), this.form && c.AddressForm(this.form, e, {
                shippingCountriesOnly: !0
            }), this.country && this.country.hasAttribute(kr) && this.province && this.province.hasAttribute(kr) && this.country.addEventListener("change", (function() {
                this.country.removeAttribute(kr), this.province.removeAttribute(kr)
            })), this.button && this.button.addEventListener("click", function(t) {
                for (t.preventDefault(), this.disableButtons(); this.ratesWrapper.firstChild;) this.ratesWrapper.removeChild(this.ratesWrapper.firstChild);
                this.ratesWrapper.style.display = "none";
                const e = {};
                let i = this.country.value,
                    s = this.province.value;
                const o = this.country.getAttribute(kr);
                "" === i && o && "" !== o && (i = o);
                const r = this.province.getAttribute(kr);
                "" === s && r && "" !== r && (s = r), e.zip = this.zip.value || "", e.country = i || "", e.province = s || "", this.estimate(e)
            }.bind(this))
        }
        constructor(t) {
            this.button = t.container.querySelector(fr), this.template = t.container.querySelector(vr).innerHTML, this.ratesWrapper = t.container.querySelector(Lr), this.form = t.container.querySelector(wr), this.country = t.container.querySelector(br), this.province = t.container.querySelector(Sr), this.zip = t.container.querySelector(Er), this.init()
        }
    }
    const Pr = "[data-quantity-selector]",
        $r = "[data-increase-quantity]",
        _r = "[data-decrease-quantity]",
        Hr = "[data-quantity-input]";

    function Mr(t) {
        t.querySelectorAll(Pr).forEach((t => {
            new class {
                initButtons() {
                    this.increase.addEventListener("click", function(t) {
                        t.preventDefault();
                        let e = parseInt(this.input.value, 10);
                        e = isNaN(e) ? 0 : e, e++, this.input.value = e, this.input.dispatchEvent(new Event("change"))
                    }.bind(this)), this.decrease.addEventListener("click", function(t) {
                        t.preventDefault();
                        let e = parseInt(this.input.value, 10);
                        e = isNaN(e) ? 0 : e, e--, e = Math.max(this.min, e), this.input.value = e, this.input.dispatchEvent(new Event("change"))
                    }.bind(this))
                }
                constructor(t) {
                    this.wrapper = t, this.increase = this.wrapper.querySelector($r), this.decrease = this.wrapper.querySelector(_r), this.input = this.wrapper.querySelector(Hr), this.min = parseInt(this.input.getAttribute("min"), 10), this.initButtons()
                }
            }(t)
        }))
    }
    const Ir = '[data-drawer="drawer-cart"]',
        Dr = "[data-shipping-estimate-form]",
        Br = "[data-cart-loading]",
        Wr = "[data-cart-form]",
        Fr = "[data-cart-empty]",
        Or = "[data-cart-progress]",
        Nr = "[data-line-items]",
        zr = "[data-cart-subtotal]",
        Rr = "[data-cart-bottom]",
        Vr = "[data-form-errors]",
        jr = "[data-cart-item]",
        Ur = "[data-cart-final]",
        Jr = "data-update-cart",
        Kr = "data-remove-key",
        Yr = "[data-upsell-holder]",
        Gr = '[data-section-type="cart"]',
        Xr = "[data-cart-bar]",
        Qr = "[data-cart-message]",
        Zr = "[data-item-loadbar]",
        tn = "[data-cart-message-container]",
        en = "[data-api-content]",
        sn = "cart--hidden",
        on = "cart--loading";
    let rn = class {
        listen() {
            document.addEventListener("theme:cart:change", function(t) {
                this.cart = t.detail.cart, this.stale = !0
            }.bind(this)), document.addEventListener("theme:cart:init", function() {
                this.init()
            }.bind(this)), document.addEventListener("theme:cart:reload", function() {
                this.stale = !0, this.cart ? this.loadHTML() : this.init().then((() => this.loadHTML()))
            }.bind(this)), this.drawer && this.drawer.addEventListener("theme:drawer:open", function() {
                this.cart ? this.loadHTML() : this.init().then((() => this.loadHTML()))
            }.bind(this)), new mr(this.container), new us(this.container)
        }
        init() {
            return window.fetch(`${window.theme.routes.cart}.js`).then(this.handleErrors).then((t => t.json())).then((t => (this.cart = t, this.fireChange(t), t))).catch((t => {
                console.error(t)
            }))
        }
        loadHTML() {
            this.stale && (this.cart && this.cart.item_count > 0 ? this.loadForm() : (this.showEmpty(), this.cartMessages.forEach((t => {
                new us(t)
            })))), this.stale = !1
        }
        initInputs() {
            this.inputs = this.container.querySelectorAll(`[${Jr}]`), this.inputs.forEach((t => {
                const e = t.getAttribute(Jr);
                t.addEventListener("change", function(t) {
                    const i = parseInt(t.target.value, 10);
                    this.latestClick = t.target.closest(jr), this.lockState(), this.updateCart(e, i)
                }.bind(this))
            }))
        }
        initRemove() {
            this.removers = this.container.querySelectorAll(`[${Kr}]`), this.removers.forEach((t => {
                const e = t.getAttribute(Kr);
                t.addEventListener("click", function(t) {
                    t.preventDefault(), this.latestClick = t.target.closest(jr), this.lockState(), this.updateCart(e, 0)
                }.bind(this))
            }))
        }
        lockState() {
            this.latestClick.querySelector(Zr).style.display = "block", this.loader.classList.add(on)
        }
        updateCart(t, e) {
            let i = null,
                s = null,
                o = null;
            window.fetch(`${window.theme.routes.cart}.js`).then(this.handleErrors).then((t => t.json())).then((s => {
                const r = s.items.findIndex((e => e.key === t));
                i = s.item_count, o = s.items[r].title;
                const n = {
                    line: `${r+1}`,
                    quantity: e
                };
                return window.fetch(`${window.theme.routes.cart}/change.js`, {
                    method: "post",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(n)
                })
            })).then(this.handleErrors).catch((t => {
                console.error(t), this.showError(`<p>Error: ${t.message||"Could not update your cart, please try again in a second"}</p>`), this.loadHTML()
            })).then((t => t.json())).then((t => {
                this.cart = t, s = t.item_count, i === s ? (this.stockoutError(o), this.stale = !0) : (Qe(this.errors), this.fireChange(t), this.stale = !0), this.loadHTML()
            })).catch((t => {
                console.error(t);
                let e = "";
                void 0 !== t.status && (e = `<p>${t.status}</p>`);
                let i = t.json.description || "";
                this.showError(`${e+i}`), this.loadHTML()
            }))
        }
        fireChange(t) {
            document.dispatchEvent(new CustomEvent("theme:cart:change", {
                detail: {
                    cart: t
                },
                bubbles: !0
            }))
        }
        updateTotal() {
            if (this.cart && this.cart.total_price) {
                const t = l.formatMoney(this.cart.total_price, theme.moneyFormat);
                this.finalPrice.innerHTML = t + ` ${theme.currencyCode}`
            }
            this.subtotal && this.cart && window.fetch(`${window.theme.routes.root_url}?section_id=api-cart-subtotal`).then(this.handleErrors).then((t => t.text())).then((t => {
                const e = document.createElement("div");
                e.innerHTML = t, this.subtotal.innerHTML = e.querySelector(en).innerHTML
            }))
        }
        showError(t) {
            Qe(this.errors), this.errors.innerHTML = t, window.setTimeout((() => {
                Xe(this.errors)
            }), 600)
        }
        stockoutError(t) {
            let e = `<p><strong>${window.theme.strings.stockout}</strong></p>`,
                i = `<p>${t}</p>`;
            this.showError(`${e+i}`)
        }
        loadForm() {
            window.fetch(`${window.theme.routes.root_url}?section_id=api-cart-items`).then(this.handleErrors).then((t => t.text())).then((t => {
                const e = document.createElement("div");
                e.innerHTML = t, this.items.innerHTML = e.querySelector(en).innerHTML, this.showForm(), this.initQuantity(), this.initUpsell(), this.updateTotal()
            }))
        }
        initUpsell() {
            const t = this.items.querySelector(Yr),
                e = this.bottom.querySelector(Yr);
            e && e.remove(), this.cartPage && t && this.bottom.insertBefore(t, this.bottom.firstChild)
        }
        initQuantity() {
            Mr(this.container), this.initInputs(), this.initRemove()
        }
        showForm() {
            this.bar && this.bar.classList.remove(sn), this.ship && this.ship.classList.remove(sn), this.progress && this.progress.classList.remove(sn), this.form.classList.remove(sn), this.bottom.classList.remove(sn), this.loader.classList.remove(on), this.emptystate.classList.add(sn)
        }
        showEmpty() {
            this.bar && this.bar.classList.add(sn), this.ship && this.ship.classList.add(sn), this.progress && this.progress.classList.add(sn), this.emptystate.classList.remove(sn), this.loader.classList.remove(on), this.form.classList.add(sn), this.bottom.classList.add(sn)
        }
        handleErrors(t) {
            return t.ok ? t : t.json().then((function(e) {
                throw new W({
                    status: t.statusText,
                    headers: t.headers,
                    json: e
                })
            }))
        }
        constructor(t) {
            this.section = t, this.container = t.container, this.cartMessages = document.querySelectorAll(tn), this.bar = this.container.querySelector(Xr), this.ship = this.container.querySelector(Qr), this.drawer = this.container.querySelector(Ir), this.form = this.container.querySelector(Wr), this.loader = this.container.querySelector(Br), this.bottom = this.container.querySelector(Rr), this.items = this.container.querySelector(Nr), this.subtotal = this.container.querySelector(zr), this.errors = this.container.querySelector(Vr), this.finalPrice = this.container.querySelector(Ur), this.emptystate = this.container.querySelector(Fr), this.progress = this.container.querySelector(Or), this.latestClick = null, this.cart = null, this.stale = !0, this.cartPage = document.querySelector(Gr), this.listen()
        }
    };
    const nn = {
            onLoad() {
                this.container.querySelector(Ir) && (this.cart = new rn(this));
                this.container.querySelector(Dr) && new xr(this)
            },
            onUnload: function() {
                this.cart && "function" == typeof this.cart.unload && this.cart.unload()
            }
        },
        an = "[data-accordion-group]",
        ln = "data-accordion-trigger",
        cn = "[data-accordion-body]",
        hn = "data-accordion-body-mobile",
        dn = "data-range-holder",
        un = "[data-section-id]",
        pn = "accordion-is-open";
    let mn = {},
        yn = class {
            mobileAccordions() {
                window.innerWidth < window.theme.sizes.medium ? (this.init(), this.setDefaultState()) : (this.resetMobileAccordions(), this.body.removeAttribute("style")), document.addEventListener("theme:resize", (() => {
                    window.innerWidth < window.theme.sizes.medium ? (this.init(), this.setDefaultState()) : (this.resetMobileAccordions(), this.body.removeAttribute("style"))
                }))
            }
            init() {
                this.trigger.setAttribute("aria-haspopup", !0), this.trigger.setAttribute("aria-expanded", !1), this.trigger.setAttribute("aria-controls", this.key), this.setDefaultState(), this.trigger.addEventListener("click", this.toggleEvent), this.body.addEventListener("keyup", this.keyboardEvent), this.body.addEventListener("theme:accordion:close", this.hideEvent)
            }
            hideEvents() {
                this.hideAccordion()
            }
            clickEvents(t) {
                t.preventDefault(), this.toggleState()
            }
            keyboardEvents(t) {
                t.which === window.theme.keyboardKeys.ESCAPE && (this.hideAccordion(), this.trigger.focus())
            }
            resetMobileAccordions() {
                this.trigger.removeEventListener("click", this.toggleEvent), this.body.removeEventListener("keyup", this.keyboardEvent), this.body.removeEventListener("theme:accordion:close", this.hideEvent)
            }
            setDefaultState() {
                this.trigger.classList.contains(pn) ? B(this.body) : this.hideAccordion()
            }
            getSiblings() {
                const t = [...this.body.closest(un).querySelectorAll(an)].filter((t => t.contains(this.body))).shift();
                if (t) {
                    return [...t.querySelectorAll(cn)].filter((t => !t.contains(this.body)))
                }
                return []
            }
            closeSiblings() {
                this.syncBodies.forEach((t => {
                    t.dispatchEvent(new CustomEvent("theme:accordion:close", {
                        bubbles: !1
                    }))
                }))
            }
            toggleState() {
                this.trigger.classList.contains(pn) ? this.hideAccordion() : (this.showAccordion(), this.closeSiblings(), this.body.hasAttribute(dn) && setTimeout((() => {
                    document.dispatchEvent(new CustomEvent("theme:price-range:reset", {
                        bubbles: !1
                    }))
                }), 400))
            }
            hideAccordion() {
                this.trigger.classList.remove(pn), Qe(this.body)
            }
            showAccordion() {
                this.trigger.classList.add(pn), Xe(this.body), setTimeout((() => {
                    this.checkInViewportAndScrollTo()
                }), 600)
            }
            checkInViewportAndScrollTo() {
                const t = this.trigger.getBoundingClientRect(),
                    e = (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);
                t.top >= 0 && t.left >= 0 && t.bottom <= (window.innerHeight || document.documentElement.clientHeight) && t.right <= (window.innerWidth || document.documentElement.clientWidth) || window.scrollTo({
                    top: e + t.top,
                    left: 0,
                    behavior: "smooth"
                })
            }
            onBlockSelect(t) {
                this.body.contains(t.target) && this.showAccordion()
            }
            onBlockDeselect(t) {
                this.body.contains(t.target) && this.hideAccordion()
            }
            constructor(t) {
                this.body = t, this.key = this.body.id;
                const e = `[${ln}='${this.key}']`;
                this.trigger = document.querySelector(e), this.toggleEvent = t => this.clickEvents(t), this.keyboardEvent = t => this.keyboardEvents(t), this.hideEvent = () => this.hideEvents(), this.syncBodies = this.getSiblings(), this.body.hasAttribute(hn) ? this.mobileAccordions() : this.init()
            }
        };
    const gn = {
            onLoad() {
                mn[this.id] = [];
                this.container.querySelectorAll(cn).forEach((t => {
                    mn[this.id].push(new yn(t))
                }))
            },
            onUnload: function() {
                mn[this.id].forEach((t => {
                    "function" == typeof t.unload && t.unload()
                }))
            },
            onSelect: function() {
                "accordion-single" === this.type && this.container.querySelector(`[${ln}]`).click()
            },
            onDeselect: function() {
                "accordion-single" === this.type && this.container.querySelector(`[${ln}]`).click()
            },
            onBlockSelect(t) {
                mn[this.id].forEach((e => {
                    "function" == typeof e.onBlockSelect && e.onBlockSelect(t)
                }))
            },
            onBlockDeselect(t) {
                mn[this.id].forEach((e => {
                    "function" == typeof e.onBlockSelect && e.onBlockDeselect(t)
                }))
            }
        },
        fn = "on-sale",
        wn = "sold-out";
    const vn = "[data-search-popdown-wrap]",
        bn = "[data-predictive-search-results]",
        Sn = "[data-predictive-search-input]",
        En = "[data-search-product-template]",
        Ln = "[data-search-other-template]",
        Tn = "[data-predictive-search-title-template]",
        kn = "[data-predictive-search-aria-template]",
        An = "[data-product-title-wrap]",
        qn = "[data-product-wrap]",
        Cn = "[data-collection-wrap]",
        xn = "[data-article-wrap]",
        Pn = "[data-page-wrap]",
        $n = "[data-predictive-search-aria]",
        _n = "[data-popdown-outer]",
        Hn = "[data-loading-indicator]",
        Mn = "dirty",
        In = "search--empty";
    let Dn = {};
    u.filters.define("animationDelay", (function(t) {
        return 90 * t + 10
    }));
    const Bn = {
            onLoad() {
                Dn[this.id] = [];
                document.querySelectorAll(vn).forEach((t => {
                    Dn[this.id].push(new class {
                        initSearch() {
                            this.input.addEventListener("input", A(function(t) {
                                const e = t.target.value;
                                e && e.length > 1 ? (this.loader.style.display = "block", this.render(e)) : (this.resetTemplates(), this.outer.classList.remove(Mn))
                            }.bind(this), 300)), this.input.addEventListener("theme:search:clear", this.reset.bind(this))
                        }
                        render(t) {
                            let e = "";
                            e += window.theme.settings.search_products ? "product," : "", e += window.theme.settings.search_collections ? "collection," : "", e += window.theme.settings.search_articles ? "article," : "", e += window.theme.settings.search_pages ? "page," : "", e = e.slice(0, -1), fetch(`/search/suggest.json?q=${t}&resources[type]=${e}&resources[options][unavailable_products]=last`).then(this.handleErrors).then((t => t.json())).then((e => {
                                this.resetTemplates(), this.outer.classList.add(Mn);
                                const i = e.resources.results,
                                    s = [];
                                for (const t in i)({}).hasOwnProperty.call(i, t) && s.push(...i[t]);
                                s.length ? (this.outer.classList.remove(In), this.injectOther(i), this.injectProduct(i.products)) : this.noResults(t), this.injectAria(t, s), Ee(this.outer, {
                                    elementToFocus: this.input
                                })
                            })).catch((t => {
                                console.error(t)
                            })).finally((() => {
                                this.loader.style.display = "none"
                            }))
                        }
                        injectAria(t, e) {
                            let i = window.theme.strings.noResultsFor,
                                s = null;
                            e.length && (s = e.length, i = window.theme.strings.resultsFor), this.ariaWrapper.innerHTML = u.render(this.ariaTemplate, {
                                count: s,
                                title: i,
                                query: t
                            })
                        }
                        noResults() {
                            this.resetTemplates(), this.outer.classList.add(Mn), this.outer.classList.add(In)
                        }
                        resetTemplates() {
                            this.productTitleWrapper.innerHTML = "", this.collectionWrapper.innerHTML = "", this.articleWrapper.innerHTML = "", this.productWrapper.innerHTML = "", this.pageWrapper.innerHTML = "", this.ariaWrapper.innerHTML = ""
                        }
                        reset() {
                            this.resetTemplates(), this.outer.classList.remove(Mn), this.outer.classList.remove(In), this.input.val = ""
                        }
                        injectOther(t) {
                            const e = t.collections;
                            if (this.productTitleWrapper.innerHTML += u.render(this.titleTemplate, {
                                    title: window.theme.strings.products,
                                    count: t.products.length
                                }), e && e.length) {
                                for (let t = e.length - 1; t >= 0; t--) {
                                    const i = e[t];
                                    theme.settings.excluded_collections_strict.forEach((s => {
                                        s.trim() == i.handle && e.splice(t, 1)
                                    })), theme.settings.excluded_collections.forEach((s => {
                                        i.handle.includes(s.trim()) && e.splice(t, 1)
                                    }))
                                }
                                this.collectionWrapper.innerHTML += u.render(this.titleTemplate, {
                                    title: window.theme.strings.collections,
                                    count: e.length
                                }), this.collectionWrapper.innerHTML += u.render(this.otherTemplate, e)
                            }
                            t.pages && t.pages.length && (this.pageWrapper.innerHTML += u.render(this.titleTemplate, {
                                title: window.theme.strings.pages,
                                count: t.pages.length
                            }), this.pageWrapper.innerHTML += u.render(this.otherTemplate, t.pages)), t.articles && t.articles.length && (this.articleWrapper.innerHTML += u.render(this.titleTemplate, {
                                title: window.theme.strings.articles,
                                count: t.articles.length
                            }), this.articleWrapper.innerHTML += u.render(this.otherTemplate, t.articles))
                        }
                        injectProduct(t) {
                            let e = [];
                            t.forEach((t => {
                                let i = t;
                                i = function(t) {
                                    const e = t.price < t.compare_at_price_min;
                                    let i = e ? fn : "";
                                    if (i += t.available ? "" : wn, t.price = theme.settings.currency_code_enable ? l.formatMoney(t.price, theme.moneyFormat) + ` ${theme.currencyCode}` : l.formatMoney(t.price, theme.moneyFormat), t.price_min !== t.price_max) {
                                        let e = theme.settings.currency_code_enable ? l.formatMoney(t.price_min, theme.moneyFormat) + ` ${theme.currencyCode}` : l.formatMoney(t.price_min, theme.moneyFormat);
                                        t.price = `${window.theme.strings.from} ${e}`
                                    }
                                    return {
                                        ...t,
                                        classes: i,
                                        on_sale: e,
                                        sold_out: !t.available,
                                        sold_out_translation: window.theme.strings.soldOut,
                                        compare_at_price: theme.settings.currency_code_enable ? l.formatMoney(t.compare_at_price_min, theme.moneyFormat) + ` ${theme.currencyCode}` : l.formatMoney(t.compare_at_price_min, theme.moneyFormat),
                                        compare_at_price_max: theme.settings.currency_code_enable ? l.formatMoney(t.compare_at_price_max, theme.moneyFormat) + ` ${theme.currencyCode}` : l.formatMoney(t.compare_at_price_max, theme.moneyFormat),
                                        compare_at_price_min: theme.settings.currency_code_enable ? l.formatMoney(t.compare_at_price_min, theme.moneyFormat) + ` ${theme.currencyCode}` : l.formatMoney(t.compare_at_price_min, theme.moneyFormat),
                                        price_max: theme.settings.currency_code_enable ? l.formatMoney(t.price_max, theme.moneyFormat) + ` ${theme.currencyCode}` : l.formatMoney(t.price_max, theme.moneyFormat),
                                        price_min: theme.settings.currency_code_enable ? l.formatMoney(t.price_min, theme.moneyFormat) + ` ${theme.currencyCode}` : l.formatMoney(t.price_min, theme.moneyFormat)
                                    }
                                }(i), i.image = null, i.featured_image && (i.thumb = function(t, e) {
                                    if (null === e) return t;
                                    if (null == t && (t = window.theme.assets.noImage), "master" === e) return ut(t);
                                    const i = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i);
                                    if (i) {
                                        const s = t.split(i[0]),
                                            o = i[0];
                                        return ut(`${s[0]}_${e}${o}`)
                                    }
                                    return null
                                }(i.featured_image.url, "360x360")), e.push(i)
                            }));
                            const i = u.render(this.productTemplate, e);
                            this.productWrapper.innerHTML += i
                        }
                        handleErrors(t) {
                            return t.ok ? t : t.json().then((function(e) {
                                throw new W({
                                    status: t.statusText,
                                    headers: t.headers,
                                    json: e
                                })
                            }))
                        }
                        constructor(t) {
                            this.wrapper = t, this.input = this.wrapper.querySelector(Sn), this.loader = this.wrapper.querySelector(Hn), this.results = this.wrapper.querySelector(bn), this.outer = this.input.closest(_n), this.productTemplate = this.wrapper.querySelector(En).innerHTML, this.otherTemplate = this.wrapper.querySelector(Ln).innerHTML, this.titleTemplate = this.wrapper.querySelector(Tn).innerHTML, this.ariaTemplate = this.wrapper.querySelector(kn).innerHTML, this.productTitleWrapper = this.results.querySelector(An), this.productWrapper = this.results.querySelector(qn), this.collectionWrapper = this.results.querySelector(Cn), this.articleWrapper = this.results.querySelector(xn), this.pageWrapper = this.results.querySelector(Pn), this.ariaWrapper = this.results.querySelector($n), this.initSearch()
                        }
                    }(t))
                }))
            },
            onUnload: function() {
                Dn[this.id].forEach((t => {
                    "function" == typeof t.unload && t.unload()
                }))
            }
        },
        Wn = "[data-drawer-search]",
        Fn = "[data-search-popdown-wrap]",
        On = "[data-predictive-search-input]",
        Nn = "[data-clear-input]";
    const zn = {
            onLoad() {
                this.searchDrawer = new class {
                    init() {
                        this.clear.addEventListener("click", function(t) {
                            t.preventDefault(), this.clearInput()
                        }.bind(this))
                    }
                    clearInput() {
                        this.input.value = "", this.input.dispatchEvent(new CustomEvent("theme:search:clear", {
                            bubbles: !1
                        })), this.input.focus()
                    }
                    constructor(t) {
                        this.outer = t.container.querySelector(Wn), this.outer && (this.wrapper = this.outer.querySelector(Fn), this.input = this.outer.querySelector(On), this.clear = this.outer.querySelector(Nn), this.init())
                    }
                }(this)
            },
            onUnload: function() {
                this.searchDrawer && "function" == typeof this.searchDrawer.unload && this.searchDrawer.unload()
            }
        },
        Rn = {
            drawer: "data-drawer-scrolls",
            slideruleOpen: "data-sliderule-open",
            slideruleClose: "data-sliderule-close",
            sliderulePane: "data-sliderule-pane",
            slideruleWrappper: "[data-sliderule]",
            dataAnimates: "data-animates",
            children: ":scope > [data-animates],\n             :scope > * > [data-animates],\n             :scope > * > * >[data-animates],\n             :scope .sliderule-grid  > *"
        },
        Vn = "is-visible",
        jn = "is-hiding",
        Un = "is-hidden";
    let Jn = {};
    const Kn = {
            onLoad() {
                Jn[this.id] = [];
                this.container.querySelectorAll(Rn.slideruleWrappper).forEach((t => {
                    Jn[this.id].push(new class {
                        clickEvents() {
                            this.trigger.addEventListener("click", function() {
                                this.showSliderule()
                            }.bind(this)), this.exit.forEach((t => {
                                t.addEventListener("click", function() {
                                    this.hideSliderule()
                                }.bind(this))
                            }))
                        }
                        keyboardEvents() {
                            this.trigger.addEventListener("keyup", function(t) {
                                t.which === window.theme.keyboardKeys.SPACE && this.showSliderule()
                            }.bind(this)), this.sliderule.addEventListener("keyup", function(t) {
                                t.which === window.theme.keyboardKeys.ESCAPE && (this.hideSliderule(), this.buttons[0].focus())
                            }.bind(this))
                        }
                        staggerChildAnimations(t = !1) {
                            (t ? Array.prototype.slice.call(this.children).slice().reverse() : this.children).forEach(((t, e) => {
                                t.style.transitionDelay = 50 * e + 10 + "ms"
                            }))
                        }
                        hideSliderule(t = !1) {
                            const e = window.getComputedStyle(this.pane),
                                i = 1e3 * parseFloat(e.getPropertyValue("transition-duration")),
                                s = t ? this.pane.querySelectorAll(`.${Vn}`) : this.children;
                            this.pane.style.setProperty("--sliderule-height", "auto"), this.staggerChildAnimations(!0), this.pane.classList.add(jn), this.sliderule.classList.add(jn), this.sliderule.classList.remove(Vn), s.forEach((t => {
                                t.classList.remove(Vn)
                            }));
                            const o = parseInt(this.pane.dataset.sliderulePane, 10) - 1;
                            this.pane.setAttribute(Rn.sliderulePane, o);
                            const r = t ? `[${Rn.dataAnimates}].${Un}` : `[${Rn.dataAnimates}="${o}"].${Un}`,
                                n = this.pane.querySelectorAll(r);
                            n.length && n.forEach((t => {
                                t.classList.remove(Un)
                            })), setTimeout((() => {
                                this.pane.classList.remove(jn), this.sliderule.classList.remove(jn), this.staggerChildAnimations()
                            }), i)
                        }
                        showSliderule() {
                            this.pane.style.setProperty("--sliderule-height", "auto"), this.sliderule.classList.add(Vn), this.children.forEach((t => {
                                t.classList.add(Vn)
                            }));
                            const t = parseInt(this.pane.dataset.sliderulePane, 10),
                                e = t + 1;
                            this.pane.setAttribute(Rn.sliderulePane, e);
                            const i = this.pane.querySelectorAll(`[${Rn.dataAnimates}="${t}"]`);
                            if (i.length) {
                                const t = 1e3 * parseFloat(window.getComputedStyle(i[0]).getPropertyValue("transition-duration"));
                                setTimeout((() => {
                                    i.forEach((t => {
                                        t.classList.add(Un)
                                    }))
                                }), t)
                            }
                            const s = parseInt(this.trigger.nextElementSibling.offsetHeight);
                            this.pane.style.setProperty("--sliderule-height", `${s}px`);
                            const o = this.drawer.scrollTop,
                                r = this.pane.offsetTop;
                            r < o && this.pane.offsetHeight >= this.drawer.offsetHeight && this.drawer.scrollTo({
                                top: r,
                                left: 0,
                                behavior: "smooth"
                            })
                        }
                        closeSliderule() {
                            this.pane && this.pane.hasAttribute(Rn.sliderulePane) && parseInt(this.pane.getAttribute(Rn.sliderulePane)) > 0 && (this.hideSliderule(!0), parseInt(this.pane.getAttribute(Rn.sliderulePane)) > 0 && this.pane.setAttribute(Rn.sliderulePane, 0))
                        }
                        constructor(t) {
                            this.sliderule = t, this.wrapper = t.closest(Rn.wrapper), this.key = this.sliderule.id;
                            const e = `[${Rn.slideruleOpen}='${this.key}']`,
                                i = `[${Rn.slideruleClose}='${this.key}']`;
                            this.trigger = document.querySelector(e), this.drawer = document.querySelector(`[${Rn.drawer}]`), this.exit = document.querySelectorAll(i), this.pane = document.querySelector(`[${Rn.sliderulePane}]`), this.children = this.sliderule.querySelectorAll(Rn.children), this.trigger.setAttribute("aria-haspopup", !0), this.trigger.setAttribute("aria-expanded", !1), this.trigger.setAttribute("aria-controls", this.key), this.clickEvents(), this.staggerChildAnimations(), document.addEventListener("theme:sliderule:close", this.closeSliderule.bind(this))
                        }
                    }(t))
                }))
            }
        },
        Yn = "[data-product-add-popdown-wrapper]",
        Gn = "[data-close-popdown]",
        Xn = "[data-api-content]",
        Qn = '[data-ajax-disable="false"]',
        Zn = '[data-ajax-disable="true"]',
        ta = '[data-drawer-toggle="drawer-cart"]',
        ea = '[data-drawer="drawer-cart"]',
        ia = "is-visible";
    let sa;
    const oa = {
            onLoad() {
                new class {
                    renderPopdown(t) {
                        const e = t.detail.variant,
                            i = `${window.theme.routes.root_url}variants/${e.id}/?section_id=api-product-popdown`,
                            s = this;
                        n.get(i).then((function(t) {
                            const e = document.createElement("div");
                            e.innerHTML = t.data, s.drawer.innerHTML = e.querySelector(Xn).innerHTML, s.connectCartButton(), s.connectCloseButton()
                        })).catch((function(t) {
                            console.warn(t)
                        }))
                    }
                    connectCloseButton() {
                        this.drawer.classList.add(ia), this.drawer.querySelector(Gn).addEventListener("click", function(t) {
                            t.preventDefault(), this.drawer.classList.remove(ia)
                        }.bind(this)), this.popdownTimer()
                    }
                    connectCartButton() {
                        const t = this.drawer.querySelector(ta),
                            e = document.querySelector(ea);
                        e && t.addEventListener("click", function(t) {
                            t.preventDefault(), this.drawer.classList.remove(ia), e.dispatchEvent(new CustomEvent("theme:drawer:open", {
                                bubbles: !1
                            }))
                        }.bind(this))
                    }
                    popdownTimer() {
                        clearTimeout(sa), sa = setTimeout((() => {
                            this.drawer.classList.remove(ia)
                        }), 5e3)
                    }
                    constructor() {
                        this.drawer = document.querySelector(Yn), this.cartSectionAjax = document.querySelector(Qn), this.ajaxDisabled = document.querySelector(Zn), document.addEventListener("theme:cart:popdown", (t => {
                            this.cartSectionAjax ? this.cartSectionAjax.dispatchEvent(new CustomEvent("theme:cart:reload", {
                                bubbles: !0
                            })) : this.ajaxDisabled ? window.location.reload() : this.renderPopdown(t)
                        }))
                    }
                }(this)
            }
        },
        ra = "[data-takes-space]",
        na = "[data-header-desktop]",
        aa = "js__header__clone",
        la = "js__show__mobile",
        ca = "[data-header-backfill]",
        ha = "data-header-transparent",
        da = "header-override-border",
        ua = ".main-content > .shopify-section:first-child [data-overlay-header]",
        pa = ".main-content > .shopify-section:first-child [data-prevent-transparent-header]",
        ma = '.navlink[href="#"]',
        ya = "has-overlay";
    let ga = {};
    xi("header", [{
        onLoad() {
            ga = new class {
                unload() {
                    document.removeEventListener("theme:resize", this.checkWidth)
                }
                checkForImage() {
                    this.overlayedImages = document.querySelectorAll(ua);
                    let t = document.querySelectorAll(pa).length;
                    this.overlayedImages.length && !t && this.transparent ? (document.querySelector(ca).style.display = "none", this.listenOverlay()) : this.wrapper.setAttribute(ha, !1), !this.overlayedImages.length || t || this.transparent || (this.wrapper.classList.add(da), this.subtractHeaderHeight())
                }
                listenOverlay() {
                    document.addEventListener("theme:resize", this.checkWidth.bind(this)), this.subtractAnnouncementHeight()
                }
                listenWidth() {
                    document.addEventListener("theme:resize", this.checkWidth.bind(this)), this.checkWidth()
                }
                killDeadLinks() {
                    this.deadLinks.forEach((t => {
                        t.onclick = t => {
                            t.preventDefault()
                        }
                    }))
                }
                subtractAnnouncementHeight() {
                    const {
                        windowHeight: t,
                        announcementHeight: e
                    } = w();
                    this.overlayedImages.forEach((i => {
                        i.style.setProperty("--full-screen", t - e + "px"), i.classList.add(ya)
                    }))
                }
                subtractHeaderHeight() {
                    const {
                        windowHeight: t,
                        headerHeight: e
                    } = w();
                    this.overlayedImages.forEach((i => {
                        i.style.setProperty("--full-screen", t - e + "px")
                    }))
                }
                checkWidth() {
                    document.body.clientWidth < this.minWidth ? this.wrapper.classList.add(la) : this.wrapper.classList.remove(la)
                }
                getMinWidth() {
                    const t = this.wrapper.cloneNode(!0);
                    t.classList.add(aa), document.body.appendChild(t);
                    const e = t.querySelectorAll(ra);
                    let i = 0;
                    return i = 3 === e.length ? function(t) {
                        let e = [];
                        return t.forEach((t => {
                            e.push(t.clientWidth)
                        })), e[0] > e[2] ? e[2] = e[0] : e[0] = e[2], e.reduce(((t, e) => t + e))
                    }(e) : function(t) {
                        let e = 0;
                        return t.forEach((t => {
                            e += t.clientWidth
                        })), e
                    }(e), document.body.removeChild(t), i + 20 * e.length
                }
                constructor(t) {
                    this.wrapper = t, this.style = this.wrapper.dataset.style, this.desktop = this.wrapper.querySelector(na), this.transparent = "false" !== this.wrapper.getAttribute(ha), this.overlayedImages = document.querySelectorAll(ua), this.deadLinks = document.querySelectorAll(ma), this.killDeadLinks(), "drawer" !== this.style && this.desktop && (this.minWidth = this.getMinWidth(), this.listenWidth()), this.checkForImage(), window.dispatchEvent(new Event("resize")), document.addEventListener("theme:header:check", this.checkForImage.bind(this))
                }
            }(this.container)
        },
        onUnload: function() {
            "function" == typeof ga.unload && ga.unload()
        }
    }, zs, Kn, Xs, uo, Eo, Ao, Io, Bn, zn, Vt, nn, oa, gn, es]), customElements.get("popout-select") || customElements.define("popout-select", ur), customElements.get("upsell-product") || customElements.define("upsell-product", Ge), customElements.get("radio-swatch") || customElements.define("radio-swatch", zt), customElements.get("product-grid-item") || customElements.define("product-grid-item", Wo), customElements.get("product-grid-item-content") || customElements.define("product-grid-item-content", Qo);
    const fa = "[data-newsletter-form]",
        wa = "has-success",
        va = "has-error",
        ba = {};
    const Sa = {
        onLoad() {
            ba[this.id] = [];
            this.container.querySelectorAll(fa).forEach((t => {
                ba[this.id].push(new class {
                    init() {
                        this.newsletter.addEventListener("submit", this.newsletterSubmit), this.showMessage()
                    }
                    newsletterSubmitEvent(t) {
                        this.stopSubmit && (t.preventDefault(), this.removeStorage(), this.writeStorage(), this.stopSubmit = !1, this.newsletter.submit())
                    }
                    checkForChallengePage() {
                        this.isChallengePage = "/challenge" === window.location.pathname
                    }
                    writeStorage() {
                        void 0 !== this.sessionStorage && this.sessionStorage.setItem("newsletter_form_id", this.newsletter.id)
                    }
                    readStorage() {
                        this.formID = this.sessionStorage.getItem("newsletter_form_id")
                    }
                    removeStorage() {
                        this.sessionStorage.removeItem("newsletter_form_id")
                    }
                    showMessage() {
                        if (this.readStorage(), this.newsletter.id === this.formID) {
                            const t = document.getElementById(this.formID); - 1 !== window.location.search.indexOf("?customer_posted=true") ? (t.classList.remove(va), t.classList.add(wa)) : -1 !== window.location.search.indexOf("accepts_marketing") && (t.classList.remove(wa), t.classList.add(va)), this.scrollToForm(t)
                        }
                    }
                    scrollToForm(t) {
                        const e = t.getBoundingClientRect();
                        e.top >= 0 && e.left >= 0 && e.bottom <= (window.innerHeight || document.documentElement.clientHeight) && e.right <= (window.innerWidth || document.documentElement.clientWidth) || setTimeout((() => {
                            window.scroll({
                                top: e.top,
                                left: 0,
                                behavior: "smooth"
                            })
                        }), 400)
                    }
                    unload() {
                        this.newsletter.removeEventListener("submit", this.newsletterSubmit)
                    }
                    constructor(t) {
                        this.sessionStorage = window.sessionStorage, this.newsletter = t, this.stopSubmit = !0, this.isChallengePage = !1, this.formID = null, this.checkForChallengePage(), this.newsletterSubmit = t => this.newsletterSubmitEvent(t), this.isChallengePage || this.init()
                    }
                }(t))
            }))
        },
        onUnload() {
            ba[this.id].forEach((t => {
                "function" == typeof t.unload && t.unload()
            }))
        }
    };

    function Ea() {
        const t = "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
        return document.documentElement.classList.toggle("supports-touch", t), t
    }
    xi("footer", [gn, Sa]), customElements.get("popout-select") || customElements.define("popout-select", ur), Ea();
    const La = {
            cc_load_policy: 1,
            iv_load_policy: 3,
            modestbranding: 1,
            playsinline: 1,
            controls: 1,
            showinfo: 0,
            ecver: 2,
            fs: 1,
            rel: 0
        },
        Ta = "iframe, [data-replace]",
        ka = "data-video-id";

    function Aa(t, e) {
        const i = {
                ...La,
                ...e
            },
            s = document.querySelector(`[data-player="${t}"]`),
            o = s.querySelector(Ta),
            r = s.querySelector(`[${ka}]`).getAttribute(ka);
        Et({
            url: "https://www.youtube.com/iframe_api"
        });
        return window.youtubeLoaderPromise.then((function() {
            let t = new window.YT.Player(o, {
                videoId: r,
                playerVars: {
                    ...i
                }
            });
            return s.addEventListener("pause", (function() {
                try {
                    t.pauseVideo && t.pauseVideo()
                } catch (t) {
                    console.warn(t)
                }
            })), s.addEventListener("theme:media:play-desktop", (function() {
                Ea() || s.dispatchEvent(new Event("play"))
            })), s.addEventListener("play", (function() {
                try {
                    t.playVideo ? t.playVideo() : t.addEventListener("onReady", (function(t) {
                        t.target.playVideo()
                    }))
                } catch (t) {
                    console.warn(t)
                }
            })), s.addEventListener("destroy", (function() {
                try {
                    t.destroy && t.destroy()
                } catch (t) {
                    console.warn(t)
                }
            })), t
        })).catch((function(t) {
            console.error(t)
        }))
    }
    window.youtubeLoaderPromise = new Promise((t => {
        window.onYouTubeIframeAPIReady = function() {
            t()
        }
    }));
    const qa = {
            autoplay: !0,
            loop: !0,
            controls: !0,
            muted: !1,
            playsinline: !0
        },
        Ca = "iframe, [data-replace]",
        xa = "data-video-id";
    const Pa = "[data-video-popup]",
        $a = "[data-video-autoplay]",
        _a = "data-unique",
        Ha = "data-video-id",
        Ma = "data-video-type",
        Ia = "data-player";
    const Da = {
            onLoad() {
                new class {
                    init() {
                        this.triggers.forEach((t => {
                            const e = t.getAttribute(_a),
                                i = t.getAttribute(Ha),
                                s = t.getAttribute(Ma),
                                o = `${i}-${e}`,
                                n = document.querySelector(`[${Ia}="${o}"]`);
                            r.init({
                                onShow: () => {
                                    this.backgroundVideo && "function" == typeof this.backgroundVideo.pause && this.backgroundVideo.pause();
                                    let t = {};
                                    "youtube" === s ? t = Aa(o) : "vimeo" === s && (t = function(t, e) {
                                        const i = {
                                                ...qa,
                                                ...e
                                            },
                                            s = document.querySelector(`[data-player="${t}"]`),
                                            o = s.querySelector(Ca),
                                            r = s.querySelector(`[${xa}]`).getAttribute(xa),
                                            n = Et({
                                                url: "https://player.vimeo.com/api/player.js"
                                            }),
                                            a = `select-${t}`;
                                        return o.setAttribute("id", a), n.then((function() {
                                            const t = new window.Vimeo.Player(a, {
                                                ...i,
                                                id: r
                                            });
                                            return s.addEventListener("pause", (function() {
                                                try {
                                                    t.pause && t.pause()
                                                } catch (t) {
                                                    console.warn(t)
                                                }
                                            })), s.addEventListener("theme:media:play-desktop", (function() {
                                                Ea() || s.dispatchEvent(new Event("play"))
                                            })), s.addEventListener("play", (function() {
                                                t.play && t.play()
                                            })), s.addEventListener("destroy", (function() {
                                                try {
                                                    t.destroy && t.destroy()
                                                } catch (t) {
                                                    console.log(t)
                                                }
                                            })), t
                                        })).catch((function(t) {
                                            console.error(t)
                                        }))
                                    }(o)), t.then((() => {
                                        n.dispatchEvent(new CustomEvent("play"))
                                    }))
                                },
                                onClose: (t, e, i) => {
                                    i.preventDefault(), n.dispatchEvent(new CustomEvent("destroy")), this.backgroundVideo && "function" == typeof this.backgroundVideo.play && this.backgroundVideo.play()
                                },
                                openTrigger: `data-trigger-${i}-${e}`
                            })
                        }))
                    }
                    constructor(t) {
                        this.container = t.container, this.triggers = this.container.querySelectorAll(Pa), this.backgroundVideo = this.container.querySelector($a), this.init()
                    }
                }(this)
            }
        },
        Ba = "[data-scroll-down]";
    const Wa = {
        onLoad() {
            this.scrollButton = new class {
                init() {
                    const t = this.wrapper.querySelectorAll(Ba);
                    t && t.forEach((t => {
                        t.addEventListener("click", this.scroll.bind(this))
                    }))
                }
                scroll() {
                    const t = this.wrapper.offsetTop + this.wrapper.clientHeight;
                    window.scroll({
                        top: t,
                        left: 0,
                        behavior: "smooth"
                    })
                }
                constructor(t) {
                    this.wrapper = t, this.init()
                }
            }(this.container)
        },
        onUnload: function() {
            delete this.scrollButton
        }
    };
    xi("video", [Ri, Wa, Da]), xi("page-faq", gn), xi("hero", [Ri, Wa, Xt]);
    const Fa = "[data-slider]",
        Oa = "[data-grid-slide]",
        Na = "[data-wrapper]",
        za = "data-custom-scrollbar-items",
        Ra = "data-show-dots",
        Va = "wrapper",
        ja = "wrapper--full",
        Ua = window.innerWidth - document.documentElement.clientWidth,
        Ja = 112,
        Ka = {};
    const Ya = {
        onLoad() {
            Ka[this.id] = [];
            this.container.querySelectorAll(Fa).forEach((t => {
                Ka[this.id].push(new class {
                    init() {
                        const t = this,
                            e = {
                                initialIndex: 0,
                                accessibility: !0,
                                autoPlay: !1,
                                contain: !0,
                                pageDots: this.pageDots,
                                adaptiveHeight: !1,
                                wrapAround: !1,
                                groupCells: !1,
                                cellAlign: "left",
                                freeScroll: !0,
                                prevNextButtons: !0,
                                draggable: !0,
                                rightToLeft: window.isRTL,
                                watchCSS: !0,
                                arrowShape: {
                                    x0: 10,
                                    x1: 60,
                                    y1: 50,
                                    x2: 65,
                                    y2: 45,
                                    x3: 20
                                },
                                on: {
                                    ready: function() {
                                        t.removeIncorrectAria()
                                    }
                                }
                            };
                        this.flkty = new s(this.slideshow, e), this.container.addEventListener("theme:tab:change", (() => {
                            this.flkty.resize()
                        })), this.toggleWrapperModifier(), document.addEventListener("theme:resize:width", this.toggleWrapperModifier.bind(this)), this.slideshow.hasAttribute(za) && new Gt(this.container), new U(this.container)
                    }
                    toggleWrapperModifier() {
                        this.wrapper.classList.contains(Va) && this.wrapper.classList.toggle(ja, this.wrapperWidthWithGutter >= window.innerWidth)
                    }
                    removeIncorrectAria() {
                        this.slideshow.querySelectorAll('[aria-hidden="true"]').forEach((t => t.removeAttribute("aria-hidden")))
                    }
                    onUnload() {
                        this.slideshow && this.flkty && (this.flkty.options.watchCSS = !1, this.flkty.destroy())
                    }
                    constructor(t, e) {
                        if (this.container = t, this.slideshow = e, this.wrapper = this.container.closest(Na), this.wrapperWidth = Number(getComputedStyle(document.documentElement).getPropertyValue("--LAYOUT-WIDTH").replace("px", "")), this.wrapperWidthWithGutter = this.wrapperWidth + Ja + Ua, this.pageDots = "true" === this.slideshow.getAttribute(Ra), this.firstPhoto = this.container.querySelector(Oa), this.firstPhoto) {
                            const t = this.firstPhoto.offsetHeight / 2;
                            this.slideshow.style.setProperty("--buttons-top", `${t}px`)
                        }
                        this.slideshow && (this.flkty = null, this.init())
                    }
                }(this.container, t))
            }))
        },
        onUnload(t) {
            Ka[this.id].forEach((e => {
                "function" == typeof e.onUnload && e.onUnload(t)
            }))
        }
    };
    xi("custom-content", [Ri, Da, Vt, Ya]), customElements.get("radio-swatch") || customElements.define("radio-swatch", zt), customElements.get("product-grid-item") || customElements.define("product-grid-item", Wo), customElements.get("product-grid-item-content") || customElements.define("product-grid-item-content", Qo), customElements.get("upsell-product") || customElements.define("upsell-product", Ge);
    const Ga = [],
        Xa = "[data-slideshow-wrapper]",
        Qa = "data-slideshow-speed",
        Za = "data-slideshow-autoplay",
        tl = "data-slideshow-slides",
        el = "[data-slide-custom-prev]",
        il = "[data-slide-custom-next]",
        sl = "data-slideshow-index",
        ol = "flickity-enabled";
    xi("slideshow", [{
        onLoad() {
            Ga[this.id] = new class {
                init() {
                    const t = {
                        autoPlay: !(!this.autoplay || !this.speed) && parseInt(this.speed),
                        contain: !1,
                        pageDots: !0,
                        adaptiveHeight: !0,
                        accessibility: !0,
                        wrapAround: 2 !== this.slideCount,
                        prevNextButtons: !1,
                        draggable: !0,
                        fade: !0,
                        rightToLeft: window.isRTL
                    };
                    this.flkty = new e(this.wrapper, t), this.prevButtons.length && this.prevButtons.forEach((t => {
                        t.onclick = () => {
                            this.flkty.previous(!0, !1)
                        }
                    })), this.nextButtons.length && this.nextButtons.forEach((t => {
                        t.onclick = () => {
                            this.flkty.next(!0, !1)
                        }
                    })), document.addEventListener("theme:scroll", this.scrollEvent)
                }
                scrollEvents() {
                    if (this.flkty && this.autoplay && this.speed) {
                        const t = this.flkty.element,
                            e = t.getBoundingClientRect().top + window.scrollY + t.offsetHeight;
                        window.pageYOffset > e ? "playing" === this.flkty.player.state && this.flkty.pausePlayer() : "paused" === this.flkty.player.state && this.flkty.playPlayer()
                    }
                }
                unload() {
                    document.removeEventListener("theme:scroll", this.scrollEvent), this.flkty && this.wrapper && this.wrapper.classList.contains(ol) && this.flkty.destroy()
                }
                onBlockSelect(t) {
                    const e = t.target.closest(`[${sl}]`).getAttribute(sl),
                        i = parseInt(e);
                    this.flkty.selectCell(i), this.flkty.stopPlayer()
                }
                onBlockDeselect() {
                    this.autoplay && this.flkty.playPlayer()
                }
                constructor(t) {
                    this.container = t.container, this.wrapper = t.container.querySelector(Xa), this.speed = this.wrapper.getAttribute(Qa), this.autoplay = "true" === this.wrapper.getAttribute(Za), this.slideCount = parseInt(this.wrapper.getAttribute(tl), 10), this.prevButtons = this.wrapper.querySelectorAll(el), this.nextButtons = this.wrapper.querySelectorAll(il), this.flkty = null, this.scrollEvent = () => this.scrollEvents(), this.init()
                }
            }(this)
        },
        onUnload() {
            "function" == typeof Ga[this.id].unload && Ga[this.id].unload()
        },
        onBlockSelect(t) {
            "function" == typeof Ga[this.id].onBlockSelect && Ga[this.id].onBlockSelect(t)
        },
        onBlockDeselect(t) {
            "function" == typeof Ga[this.id].onBlockSelect && Ga[this.id].onBlockDeselect(t)
        }
    }, Ri, Wa]);
    const rl = "[data-range-slider]",
        nl = "[data-range-left]",
        al = "[data-range-right]",
        ll = "[data-range-line]",
        cl = "[data-range-holder]",
        hl = "data-se-min",
        dl = "data-se-max",
        ul = "data-se-min-value",
        pl = "data-se-max-value",
        ml = "data-se-step",
        yl = "data-range-filter-update",
        gl = "[data-field-price-min]",
        fl = "[data-field-price-max]",
        wl = "is-initialized";
    let vl = class {
        init() {
            this.setDefaultValues(), this.touchLeft.addEventListener("mousedown", this.onStartEvent), this.touchRight.addEventListener("mousedown", this.onStartEvent), this.touchLeft.addEventListener("touchstart", this.onStartEvent), this.touchRight.addEventListener("touchstart", this.onStartEvent), this.slider.classList.add(wl)
        }
        setDefaultValues() {
            let t = this.min;
            this.slider.hasAttribute(ul) && (t = parseFloat(this.slider.getAttribute(ul)));
            let e = this.max;
            this.slider.hasAttribute(pl) && (e = parseFloat(this.slider.getAttribute(pl))), t < this.min && (t = this.min), e > this.max && (e = this.max), t > e && (t = e), this.slider.getAttribute(ml) && (this.step = Math.abs(parseFloat(this.slider.getAttribute(ml)))), this.reset(), this.maxX = this.slider.offsetWidth - this.touchRight.offsetWidth, this.selectedTouch = null, this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact, this.setMinValue(t), this.setMaxValue(e)
        }
        reset() {
            this.touchLeft.style.left = "0px", this.touchRight.style.left = this.slider.offsetWidth - this.touchLeft.offsetWidth + "px", this.lineSpan.style.marginLeft = "0px", this.lineSpan.style.width = this.slider.offsetWidth - this.touchLeft.offsetWidth + "px", this.startX = 0, this.x = 0
        }
        setMinValue(t) {
            const e = (t - this.min) / (this.max - this.min);
            this.touchLeft.style.left = Math.ceil(e * (this.slider.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact))) + "px", this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px", this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px", this.slider.setAttribute(ul, t)
        }
        setMaxValue(t) {
            const e = (t - this.min) / (this.max - this.min);
            this.touchRight.style.left = Math.ceil(e * (this.slider.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact)) + this.normalizeFact) + "px", this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px", this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px", this.slider.setAttribute(pl, t)
        }
        onStart(t) {
            t.preventDefault();
            let e = t;
            t.touches && (e = t.touches[0]), t.currentTarget === this.touchLeft ? this.x = this.touchLeft.offsetLeft : t.currentTarget === this.touchRight && (this.x = this.touchRight.offsetLeft), this.startX = e.pageX - this.x, this.selectedTouch = t.currentTarget, document.addEventListener("mousemove", this.onMoveEvent), document.addEventListener("mouseup", this.onStopEvent), document.addEventListener("touchmove", this.onMoveEvent), document.addEventListener("touchend", this.onStopEvent)
        }
        onMove(t) {
            let e = t;
            if (t.touches && (e = t.touches[0]), this.x = e.pageX - this.startX, this.selectedTouch === this.touchLeft ? (this.x > this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10 ? this.x = this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10 : this.x < 0 && (this.x = 0), this.selectedTouch.style.left = this.x + "px") : this.selectedTouch === this.touchRight && (this.x < this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10 ? this.x = this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10 : this.x > this.maxX && (this.x = this.maxX), this.selectedTouch.style.left = this.x + "px"), this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px", this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px", this.calculateValue(), this.slider.getAttribute("on-change")) {
                new Function("min, max", this.slider.getAttribute("on-change"))(this.slider.getAttribute(ul), this.slider.getAttribute(pl))
            }
            this.onChange(this.slider.getAttribute(ul), this.slider.getAttribute(pl))
        }
        onStop(t) {
            document.removeEventListener("mousemove", this.onMoveEvent), document.removeEventListener("mouseup", this.onStopEvent), document.removeEventListener("touchmove", this.onMoveEvent), document.removeEventListener("touchend", this.onStopEvent), this.selectedTouch = null, this.calculateValue(), this.onChanged(this.slider.getAttribute(ul), this.slider.getAttribute(pl))
        }
        onChange(t, e) {
            const i = this.slider.closest(cl);
            if (i) {
                const s = i.querySelector(gl),
                    o = i.querySelector(fl);
                s && o && (s.value = t, o.value = e)
            }
        }
        onChanged(t, e) {
            this.slider.hasAttribute(yl) && this.slider.dispatchEvent(new CustomEvent("theme:range:update", {
                bubbles: !0
            }))
        }
        calculateValue() {
            const t = (this.lineSpan.offsetWidth - this.normalizeFact) / this.initialValue;
            let e = this.lineSpan.offsetLeft / this.initialValue,
                i = e + t;
            if (e = e * (this.max - this.min) + this.min, i = i * (this.max - this.min) + this.min, 0 !== this.step) {
                let t = Math.floor(e / this.step);
                e = this.step * t, t = Math.floor(i / this.step), i = this.step * t
            }
            this.selectedTouch === this.touchLeft && this.slider.setAttribute(ul, e), this.selectedTouch === this.touchRight && this.slider.setAttribute(pl, i)
        }
        constructor(t) {
            this.container = t.container, this.slider = t.querySelector(rl), this.slider && (this.onMoveEvent = t => this.onMove(t), this.onStopEvent = t => this.onStop(t), this.onStartEvent = t => this.onStart(t), this.startX = 0, this.x = 0, this.touchLeft = this.slider.querySelector(nl), this.touchRight = this.slider.querySelector(al), this.lineSpan = this.slider.querySelector(ll), this.min = parseFloat(this.slider.getAttribute(hl)), this.max = parseFloat(this.slider.getAttribute(dl)), this.step = 0, this.normalizeFact = 26, this.init(), document.addEventListener("theme:price-range:reset", (() => {
                this.setDefaultValues()
            })))
        }
    };
    const bl = "data-filters",
        Sl = "[data-filters-underlay]",
        El = "data-default-hide",
        Ll = "data-filters-toggle",
        Tl = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
        kl = "data-group-heading",
        Al = "data-show-more",
        ql = "drawer--visible",
        Cl = "filters--default-visible",
        xl = "hidden",
        Pl = "is-hidden",
        $l = "focus-enabled",
        _l = {};
    let Hl = class {
        unload() {
            this.filtersToggleButtons.length && this.filtersToggleButtons.forEach((t => {
                t.removeEventListener("click", this.connectToggleMemory)
            })), this.showMoreButtons.length && this.showMoreButtons.forEach((t => {
                t.removeEventListener("click", this.connectShowHiddenOptions)
            }))
        }
        expandingEvents() {
            this.showMoreButtons.length && this.showMoreButtons.forEach((t => {
                t.addEventListener("click", Te(this.connectShowHiddenOptions, 500))
            }))
        }
        showHiddenOptions(t) {
            const e = t.target.hasAttribute(Al) ? t.target : t.target.closest(`[${Al}]`);
            e.classList.add(Pl), e.previousElementSibling.querySelectorAll(`.${Pl}`).forEach((t => {
                t.classList.remove(Pl)
            }))
        }
        connectToggle(t = !1) {
            this.filtersToggleButtons.forEach((e => {
                const i = null !== e.closest(`[${bl}]`);
                (i && t || i && !t || !i && !t) && e.addEventListener("click", this.connectToggleMemory.bind(this))
            }))
        }
        connectToggleFunction(t) {
            "true" === t.currentTarget.getAttribute("aria-expanded") ? this.hideFilters() : this.showFilters()
        }
        onFocusOut() {
            this.container.addEventListener("focusout", function(t) {
                if (window.innerWidth >= window.theme.sizes.medium) return;
                const e = t.currentTarget.contains(t.relatedTarget),
                    i = this.container.classList.contains(ql);
                document.body.classList.contains($l) && i && !e && this.hideFilters()
            }.bind(this)), this.container.addEventListener("keyup", function(t) {
                t.which === window.theme.keyboardKeys.ESCAPE && (this.hideFilters(), this.filtersToggleButtons[0].focus())
            }.bind(this)), this.underlay.addEventListener("click", function() {
                this.hideFilters()
            }.bind(this))
        }
        getShowOnLoad() {
            const t = `[${El}='false']`,
                e = document.querySelector(t),
                i = window.innerWidth >= window.theme.sizes.medium;
            return !(!e || !i)
        }
        showFilters() {
            this.filtersToggleButtons = document.querySelectorAll(this.selector), this.container.classList.remove(xl), setTimeout((() => {
                this.filtersToggleButtons.forEach((t => t.setAttribute("aria-expanded", !0))), this.filtersToggleButtons.forEach((t => t.classList.add(ql))), this.container.classList.add(ql), this.container.querySelector(Tl).focus()
            }), 1)
        }
        hideFilters() {
            this.filtersToggleButtons = document.querySelectorAll(this.selector), this.filtersToggleButtons.forEach((t => t.setAttribute("aria-expanded", !1))), this.container.classList.remove(ql), this.container.classList.remove(Cl), this.filtersToggleButtons.forEach((t => t.classList.remove(ql))), this.filtersToggleButtons.forEach((t => t.classList.remove(Cl))), setTimeout((() => {
                this.container.classList.contains(ql) || this.container.classList.add(xl)
            }), 800)
        }
        constructor(t, e = !1) {
            this.container = t, this.underlay = this.container.querySelector(Sl), this.groupHeadings = this.container.querySelectorAll(`[${kl}]`), this.showMoreButtons = this.container.querySelectorAll(`[${Al}]`), this.triggerKey = this.container.getAttribute(bl), this.selector = `[${Ll}='${this.triggerKey}']`, this.filtersToggleButtons = document.querySelectorAll(this.selector), this.connectToggleMemory = t => this.connectToggleFunction(t), this.connectShowHiddenOptions = t => this.showHiddenOptions(t), this.connectToggle(e), this.onFocusOut(), this.expandingEvents(), this.getShowOnLoad() ? this.showFilters() : this.hideFilters()
        }
    };
    const Ml = {
            onLoad() {
                _l[this.id] = [];
                this.container.querySelectorAll(`[${bl}]`).forEach((t => {
                    _l[this.id].push(new Hl(t))
                }))
            },
            onUnload: function() {
                _l[this.id].forEach((t => {
                    "function" == typeof t.unload && t.unload()
                }))
            }
        },
        Il = {
            collectionSidebar: "[data-collection-sidebar]",
            form: "[data-sidebar-filter-form]",
            inputs: "input, select, label, textarea",
            priceMin: "data-field-price-min",
            priceMax: "data-field-price-max",
            rangeMin: "data-se-min-value",
            rangeMax: "data-se-max-value",
            rangeMinDefault: "data-se-min",
            rangeMaxDefault: "data-se-max",
            productsContainer: "[data-products-grid]",
            filterUpdateUrlButton: "[data-filter-update-url]",
            activeFiltersHolder: "[data-active-filters]",
            activeFiltersCount: "[data-active-filters-count]",
            productsCount: "[data-products-count]",
            dataSort: "data-sort-enabled",
            collectionTools: "[data-collection-tools]",
            filtersWrappper: "[data-filters]",
            headerSticky: '[data-header-sticky="sticky"]',
            headerHeight: "[data-header-height]",
            gridLarge: "data-grid-large",
            gridSmall: "data-grid-small",
            accordionBody: "[data-accordion-body]",
            checkedOption: "input:checked",
            optionHolder: "[data-option-holder]"
        },
        Dl = "is-hidden",
        Bl = "is-loading",
        Wl = 1e3,
        Fl = 1e3;
    const Ol = {
        onLoad() {
            this.filterForm = new class {
                init() {
                    this.showAllOptions(), this.form && (new vl(this.form), this.sidebar.addEventListener("input", A((t => {
                        const e = t.type,
                            i = t.target;
                        if (!Il.inputs.includes(e) || !this.form || "function" != typeof this.form.submit) return;
                        const s = this.form.querySelector(`[${Il.priceMin}]`),
                            o = this.form.querySelector(`[${Il.priceMax}]`);
                        if (i.hasAttribute(Il.priceMin) || i.hasAttribute(Il.priceMax)) {
                            const t = this.form.querySelector(`[${Il.rangeMin}]`),
                                e = this.form.querySelector(`[${Il.rangeMax}]`);
                            parseInt(t.getAttribute(Il.rangeMinDefault));
                            const i = parseInt(e.getAttribute(Il.rangeMaxDefault));
                            s.value && !o.value && (o.value = i), o.value && !s.value && (s.value = rangeMinDefault), s.value <= rangeMinDefault && o.value >= i && (s.placeholder = rangeMinDefault, o.placeholder = i, s.value = "", o.value = "")
                        }
                        this.filtering(t)
                    }), 1500)), this.form.addEventListener("theme:range:update", (t => this.updateRange(t)))), this.sidebar && this.sidebar.addEventListener("click", (t => this.updateFilterFromUrl(t))), this.activeFiltersHolder && this.activeFiltersHolder.addEventListener("click", (t => this.updateFilterFromUrl(t))), this.productsContainer && this.productsContainer.addEventListener("click", (t => this.updateFilterFromUrl(t))), qt(this.sidebar)
                }
                updateRange(t) {
                    if (this.form && "function" == typeof this.form.submit) {
                        const e = this.form.querySelector(`[${Il.rangeMin}]`),
                            i = this.form.querySelector(`[${Il.rangeMax}]`),
                            s = this.form.querySelector(`[${Il.priceMin}]`),
                            o = this.form.querySelector(`[${Il.priceMax}]`);
                        if (e && i && s && o && e.hasAttribute(Il.rangeMin) && i.hasAttribute(Il.rangeMax)) {
                            const r = parseInt(s.placeholder),
                                n = parseInt(o.placeholder),
                                a = parseInt(e.getAttribute(Il.rangeMin)),
                                l = parseInt(i.getAttribute(Il.rangeMax));
                            r === a && n === l || (s.value = a, o.value = l, this.filtering(t))
                        }
                    }
                }
                updateFilterFromUrl(t) {
                    const e = t.target;
                    if (e.matches(Il.filterUpdateUrlButton) || e.closest(Il.filterUpdateUrlButton) && e) {
                        t.preventDefault();
                        const i = e.matches(Il.filterUpdateUrlButton) ? e : e.closest(Il.filterUpdateUrlButton);
                        this.filtering(t, i.getAttribute("href"))
                    }
                }
                addToHistory(t, e = "") {
                    const i = this.sort ? this.sort.getAttribute(Il.dataSort) : "";
                    if (!t || t && "popstate" !== t.type) {
                        if ("" === e) {
                            const e = new window.URL(window.location.href).searchParams,
                                s = Object.fromEntries(e),
                                o = e.toString();
                            if (o.includes("filter.") || o.includes("sort_by") || o.includes("page"))
                                for (const t in s)(t.includes("filter.") || t.includes("sort_by") || t.includes("page")) && e.delete(t);
                            if (this.form) {
                                const t = new URLSearchParams(new FormData(this.form));
                                for (let [i, s] of t.entries()) i.includes("filter.") && s && e.append(i, s);
                                const i = this.form.querySelector(`[${Il.rangeMin}]`),
                                    s = this.form.querySelector(`[${Il.rangeMax}]`),
                                    o = this.form.querySelector(`[${Il.priceMin}]`),
                                    r = this.form.querySelector(`[${Il.priceMax}]`);
                                if (i && s && o && r && i.hasAttribute(Il.rangeMinDefault) && s.hasAttribute(Il.rangeMaxDefault)) {
                                    const t = parseFloat(i.getAttribute(Il.rangeMinDefault), 10),
                                        n = parseFloat(s.getAttribute(Il.rangeMaxDefault), 10),
                                        a = "" === o.value ? parseFloat(o.placeholder, 10) : parseFloat(o.value, 10),
                                        l = "" === r.value ? parseFloat(r.placeholder, 10) : parseFloat(r.value, 10);
                                    a <= t && l >= n && (e.delete("filter.v.price.gte"), e.delete("filter.v.price.lte"))
                                }
                            }
                            if (i || t && t.detail && t.detail.href) {
                                const s = i || t.detail.params;
                                e.set("sort_by", s)
                            }
                            const r = e.toString(),
                                n = r ? `?${r}` : location.pathname;
                            return void window.history.pushState(null, "", n)
                        }
                        window.history.pushState(null, "", e)
                    }
                }
                getFilterResult() {
                    this.productsContainer.classList.add(Bl), this.getGridValues(), fetch(`${window.location.pathname}${window.location.search}`).then((t => t.text())).then((t => {
                        const e = document.createElement("div");
                        e.innerHTML = t, this.sidebar && (this.sidebar.innerHTML = e.querySelector(Il.collectionSidebar).innerHTML), this.activeFiltersCount && (this.activeFiltersCount.innerHTML = e.querySelector(Il.activeFiltersCount).innerHTML), this.productsContainer.innerHTML = e.querySelector(Il.productsContainer).innerHTML, this.activeFiltersHolder.innerHTML = e.querySelector(Il.activeFiltersHolder).innerHTML, this.activeFiltersHolder.parentNode.classList.toggle(Dl, "" === this.activeFiltersHolder.innerHTML), this.productsCount && (this.productsCount.innerHTML = e.querySelector(Il.productsCount).innerHTML), this.setGridValues(), this.refreshFunctionalities(), setTimeout((() => {
                            this.productsContainer.classList.remove(Bl)
                        }), Wl)
                    }))
                }
                refreshFunctionalities() {
                    this.form = this.container.querySelector(Il.form), this.form && (new vl(this.form), this.form.addEventListener("theme:range:update", (t => this.updateRange(t)))), this.container.querySelectorAll(Il.filtersWrappper).forEach((t => {
                        new Hl(t, !0)
                    })), this.container.querySelectorAll(Il.accordionBody).forEach((t => {
                        new yn(t)
                    })), new U(this.container), this.sidebar && qt(this.sidebar), Rt(this.container), this.showAllOptions()
                }
                getGridValues() {
                    this.layoutLarge && (this.layoutLargeValue = this.layoutLarge.getAttribute(Il.gridLarge)), this.layoutSmall && (this.layoutSmallValue = this.layoutSmall.getAttribute(Il.gridSmall))
                }
                setGridValues() {
                    this.layoutLarge && (this.layoutLarge = this.container.querySelector(`[${Il.gridLarge}]`), this.layoutLarge.setAttribute(Il.gridLarge, this.layoutLargeValue)), this.layoutSmall && (this.layoutSmall = this.container.querySelector(`[${Il.gridSmall}]`), this.layoutSmall.setAttribute(Il.gridSmall, this.layoutSmallValue))
                }
                showAllOptions() {
                    this.container.querySelectorAll(Il.checkedOption).forEach((t => {
                        if (t.closest(Il.optionHolder) && t.closest(Il.optionHolder).classList.contains(Dl)) {
                            const e = t.closest(Il.accordionBody).nextElementSibling;
                            e.classList.contains(Il.classHidden) || e.dispatchEvent(new Event("click"))
                        }
                    }))
                }
                filtering(t, e = "") {
                    const i = window.scrollY || window.pageYOffset,
                        s = this.headerIsSticky ? document.querySelector(Il.headerHeight).getBoundingClientRect().height : 0,
                        o = this.container.querySelector(Il.collectionTools),
                        r = o.offsetTop - s,
                        n = o.offsetTop + o.getBoundingClientRect().height < i - s;
                    n && window.scrollTo({
                        top: r,
                        left: 0,
                        behavior: "smooth"
                    }), setTimeout((() => {
                        this.addToHistory(t, e), this.getFilterResult()
                    }), n ? Fl : 10)
                }
                constructor(t) {
                    this.section = t, this.container = this.section.container, this.sidebar = this.container.querySelector(Il.collectionSidebar), this.form = t.container.querySelector(Il.form), this.sort = this.container.querySelector(`[${Il.dataSort}]`), this.productsContainer = this.container.querySelector(Il.productsContainer), this.activeFiltersHolder = this.container.querySelector(Il.activeFiltersHolder), this.activeFiltersCount = this.container.querySelector(Il.activeFiltersCount), this.productsCount = this.container.querySelector(Il.productsCount), this.headerIsSticky = null !== document.querySelector(Il.headerSticky), this.layoutLarge = this.container.querySelector(`[${Il.gridLarge}]`), this.layoutSmall = this.container.querySelector(`[${Il.gridSmall}]`), this.productsContainer && this.sidebar && this.init(), this.sort && this.container.addEventListener("theme:form:filter", (t => this.filtering(t))), (this.sidebar || this.sort) && window.addEventListener("popstate", (t => this.filtering(t)))
                }
            }(this)
        },
        onUnload() {
            this.filterForm && "function" == typeof this.filterForm.unload && this.filterForm.unload()
        }
    };
    xi("search-page", [Ml, Ol, Vt, gn]), customElements.get("popout-select") || customElements.define("popout-select", ur), customElements.get("radio-swatch") || customElements.define("radio-swatch", zt), customElements.get("product-grid-item") || customElements.define("product-grid-item", Wo), customElements.get("product-grid-item-content") || customElements.define("product-grid-item-content", Qo), customElements.get("upsell-product") || customElements.define("upsell-product", Ge);
    const Nl = "[data-image-zoom]",
        zl = "[data-modal-container]",
        Rl = "data-unique",
        Vl = "data-src";
    const jl = {
        onLoad() {
            new class {
                init() {
                    this.triggers.forEach((t => {
                        const e = t.getAttribute(Rl),
                            i = this.modalContainer.querySelector(`#zoom-${e}`);
                        if (i) {
                            const t = this.container.querySelector(`#zoom-${e}`);
                            t && (i.parentNode.removeChild(i), this.modalContainer.appendChild(t))
                        }
                        r.init({
                            disableScroll: !0,
                            openTrigger: `data-popup-${e}`,
                            onShow: t => {
                                t.querySelectorAll(`[${Vl}]`, t).forEach((t => {
                                    if (null === t.getAttribute("src")) {
                                        const e = t.getAttribute(Vl);
                                        t.setAttribute("src", e)
                                    }
                                }))
                            },
                            onClose: (t, e, i) => {
                                i.preventDefault()
                            }
                        })
                    }))
                }
                constructor(t) {
                    this.container = t, this.triggers = this.container.querySelectorAll(Nl), this.modalContainer = document.querySelector(zl), this.init()
                }
            }(this.container)
        }
    };
    xi("gallery", [jl, Da, Xt]);
    const Ul = (t, e) => {
        const {
            el: i,
            elStyle: s,
            elHeight: o,
            rowsLimit: r,
            rowsWrapped: n,
            options: a
        } = t;
        let l = t.buffer,
            c = l;
        if (n === r + 1) return {
            ...t
        };
        const h = l;
        let d = n,
            u = o;
        return i.innerHTML = c = l.length ? `${l}${a.delimiter}${e}${a.replaceStr}` : `${e}${a.replaceStr}`, parseFloat(s.height) > parseFloat(o) && (d++, u = s.height, d === r + 1) ? (i.innerHTML = c = "." === h[h.length - 1] && "..." === a.replaceStr ? `${h}..` : `${h}${a.replaceStr}`, {
            ...t,
            elHeight: u,
            rowsWrapped: d
        }) : (i.innerHTML = c = h.length ? `${h}${a.delimiter}${e}` : `${e}`, {
            ...t,
            buffer: c,
            elHeight: u,
            rowsWrapped: d
        })
    };
    let Jl = {},
        Kl = {},
        Yl = {};
    const Gl = "[data-product-slideshow]",
        Xl = "[data-shopify-xr]",
        Ql = "data-media-id",
        Zl = "data-model-id",
        tc = "model-viewer",
        ec = "data-shopify-model3d-id",
        ic = "#ModelJson-";

    function sc(t) {
        if (t) console.warn(t);
        else if (window.ShopifyXR) {
            for (const t in Jl)
                if (Jl.hasOwnProperty(t)) {
                    const e = Jl[t];
                    if (e.loaded) continue;
                    const i = document.querySelector(`${ic}${t}`);
                    i && (window.ShopifyXR.addModels(JSON.parse(i.innerHTML)), e.loaded = !0)
                } window.ShopifyXR.setupXRElements()
        } else document.addEventListener("shopify_xr_initialized", (function() {
            sc()
        }))
    }

    function oc(t) {
        if (t) console.warn(t);
        else
            for (const t in Kl)
                if (Kl.hasOwnProperty(t)) {
                    const e = Kl[t];
                    e.modelViewerUi || (e.modelViewerUi = new Shopify.ModelViewerUI(e.$element)), rc(e)
                }
    }

    function rc(t) {
        const e = Yl[t.sectionId];
        t.$container.addEventListener("pause", (function() {
            t.modelViewerUi.pause && t.modelViewerUi.pause()
        })), t.$container.addEventListener("theme:media:play-desktop", (function() {
            t.modelViewerUi.play && !Ea() && t.modelViewerUi.play(), e && e.$element && t && t.modelId && ec && e.$element.setAttribute(ec, t.modelId)
        })), t.$container.addEventListener("play", (function() {
            t.modelViewerUi.play && t.modelViewerUi.play()
        }))
    }
    async function nc(t) {
        const e = document.querySelector(`[data-player="${t}"]`),
            i = e.querySelector("video");
        await Et({
            name: "video-ui",
            version: "1.0"
        });
        const s = new window.Shopify.Plyr(i);
        return e.addEventListener("pause", (function() {
            s.pause && s.pause()
        })), e.addEventListener("theme:media:play-desktop", (function() {
            s.play && !Ea() && e.dispatchEvent(new CustomEvent("play"))
        })), e.addEventListener("play", (function() {
            try {
                s.play ? s.play() : s.addEventListener("onReady", (function(t) {
                    t.target.play()
                }))
            } catch (t) {
                console.warn(t)
            }
        })), e.addEventListener("destroy", (function() {
            try {
                s.destroy && s.destroy()
            } catch (t) {
                console.warn(t)
            }
        })), s
    }
    const ac = {
            productSlideshow: "[data-product-slideshow]",
            slideshowMobileStyle: "data-slideshow-mobile-style",
            slideshowDesktopStyle: "data-slideshow-desktop-style",
            productThumbs: "[data-product-thumbs]",
            leftThumbsHolder: "[data-thumbs-holder]",
            thumbImage: "[data-slideshow-thumbnail]",
            mediaSlide: "[data-media-slide]",
            dataMediaId: "data-media-id",
            dataMediaSelect: "data-media-select",
            mediaType: "data-type",
            videoPlayerExternal: '[data-type="external_video"]',
            videoPlayerNative: '[data-type="video"]',
            modelViewer: '[data-type="model"]',
            allPlayers: "[data-player]",
            loopVideo: "data-enable-video-looping",
            verticalAlignment: "[data-thumbnails-left]",
            arrowPrev: "[data-thumbs-arrow-prev]",
            arrowNext: "[data-thumbs-arrow-next]",
            aspectRatio: "data-aspect-ratio",
            flickitylockHeight: "flickity-lock-height"
        },
        lc = "is-activated",
        cc = "show";

    function hc(t) {
        return t.addEventListener("onStateChange", (function(t) {
            0 === t.data && t.target.playVideo()
        })), t
    }
    const dc = "data-store-availability-container",
        uc = "[data-api-content]",
        pc = "[data-pickup-drawer]",
        mc = "[data-pickup-drawer-open]",
        yc = "[data-pickup-drawer-close]",
        gc = "[data-pickup-body]",
        fc = "drawer--visible",
        wc = "hide",
        vc = "is-pickup-visible";
    let bc = {};
    const Sc = {
            onLoad() {
                bc[this.id] = new class {
                    fetchPickupAvailability(t) {
                        const e = this.container.querySelector(`[${dc}]`);
                        if (!e) return;
                        const i = t && t.detail.variant ? t.detail.variant.id : e.getAttribute(dc);
                        !t || t.detail.variant ? i && fetch(`${window.theme.routes.root_url}variants/${i}/?section_id=api-pickup-availability`).then(this.handleErrors).then((t => t.text())).then((t => {
                            const i = (new DOMParser).parseFromString(t, "text/html").querySelector(uc).innerHTML;
                            e.innerHTML = i, e.classList.remove(wc), this.drawer = this.container.querySelector(pc), this.buttonDrawerOpen = this.container.querySelector(mc), this.buttonDrawerClose = this.container.querySelectorAll(yc), this.drawerBody = this.container.querySelector(gc), this.buttonDrawerOpen && this.buttonDrawerOpen.addEventListener("click", (() => this.openDrawer())), this.buttonDrawerClose.length && this.buttonDrawerClose.forEach((t => {
                                t.addEventListener("click", (() => this.closeDrawer()))
                            }))
                        })).catch((t => {
                            console.error(t)
                        })) : e.classList.add(wc)
                    }
                    openDrawer() {
                        this.drawer && (document.body.classList.add(vc), this.drawer.classList.add(fc), this.drawer.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                            bubbles: !0
                        })), this.drawerBody.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                            bubbles: !0
                        })))
                    }
                    closeDrawer() {
                        this.drawer && (document.body.classList.remove(vc), this.drawer.classList.remove(fc), this.drawer.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                            bubbles: !0
                        })), this.drawerBody.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                            bubbles: !0
                        })))
                    }
                    handleErrors(t) {
                        return t.ok ? t : t.json().then((function(e) {
                            throw new W({
                                status: t.statusText,
                                headers: t.headers,
                                json: e
                            })
                        }))
                    }
                    constructor(t) {
                        this.container = t.container, this.drawer = null, this.buttonDrawerOpen = null, this.buttonDrawerClose = null, this.drawerBody = null, this.fetchPickupAvailability(), this.container.addEventListener("theme:variant:change", (t => this.fetchPickupAvailability(t)))
                    }
                }(this)
            }
        },
        Ec = t => {
            t && (t.style.display = "none")
        },
        Lc = "[data-product-form]",
        Tc = "data-option-position",
        kc = '[name^="options"], [data-popout-option]',
        Ac = "data-value",
        qc = "sold-out",
        Cc = "unavailable";
    const xc = "[data-section-id]",
        Pc = "[data-upsell-modal]",
        $c = "[data-product-form]",
        _c = "[data-product-slideshow]",
        Hc = "[data-add-to-cart]",
        Mc = "[data-add-to-cart-text]",
        Ic = "[data-compare-price]",
        Dc = "[data-compare-text]",
        Bc = "[data-buttons-wrapper]",
        Wc = "[data-product-select]",
        Fc = "[data-price-wrapper]",
        Oc = "[data-button-price]",
        Nc = "[data-product-json]",
        zc = "[data-product-price]",
        Rc = "[data-product-unit-price]",
        Vc = "[data-product-base]",
        jc = "[data-product-unit]",
        Uc = "data-enable-history-state",
        Jc = "data-option-position",
        Kc = "[data-option-value]",
        Yc = "[data-subscription-watch-price]",
        Gc = "[data-subscription-selectors]",
        Xc = "[data-price-off]",
        Qc = "[data-price-off-type]",
        Zc = "[data-price-off-amount]",
        th = "[data-toggles-group]",
        eh = "data-group-toggle",
        ih = "[data-plan-description]",
        sh = "[data-remaining-count]",
        oh = "data-remaining-max",
        rh = "[data-remaining-wrapper]",
        nh = "[data-product-remaining-json]",
        ah = "[data-product-preorder]",
        lh = "hide",
        ch = "variant--soldout",
        hh = "variant--unavailable",
        dh = "product__price--sale",
        uh = "count-is-low",
        ph = "count-is-in",
        mh = "count-is-out",
        yh = "count-is-unavailable";
    let gh = class extends HTMLElement {
        connectedCallback() {
            this.outerSection = this.container.closest(xc), this.upsell = this.container.closest(Pc), this.outerWrapper = this.upsell ? this.upsell : this.outerSection, this.productForm = this.container.querySelector($c), this.slideshow = this.outerWrapper.querySelector(_c), this.enableHistoryState = !(!this.outerSection || !this.outerSection.hasAttribute(Uc)) && "true" === this.outerSection.getAttribute(Uc), this.hasUnitPricing = this.outerWrapper.querySelector(jc), this.subSelectors = this.outerWrapper.querySelector(Gc), this.subPrices = this.outerWrapper.querySelector(Yc), this.priceOffWrap = this.outerWrapper.querySelector(Xc), this.priceOffAmount = this.outerWrapper.querySelector(Zc), this.priceOffType = this.outerWrapper.querySelector(Qc), this.planDecription = this.outerWrapper.querySelector(ih), this.isPreOrder = this.container.querySelector(ah), this.remainingWrapper = this.outerWrapper.querySelector(rh);
            const t = this.outerWrapper.querySelector(`[${oh}]`);
            this.sellout = null, this.remainingWrapper && t && (this.remainingMaxInt = parseInt(t.getAttribute(oh), 10), this.remainingCount = this.outerWrapper.querySelector(sh), this.remainingJSONWrapper = this.outerWrapper.querySelector(nh), this.remainingJSON = null, this.remainingJSONWrapper && "" !== this.remainingJSONWrapper.innerHTML ? this.remainingJSON = JSON.parse(this.remainingJSONWrapper.innerHTML) : console.warn("Missing product quantity JSON")), Mr(this.outerWrapper);
            let e = null;
            this.productJSON = null;
            const i = this.outerWrapper.querySelector(Nc);
            i && (e = i.innerHTML), e && this.productForm ? (this.productJSON = JSON.parse(e), this.sellout = new class {
                init() {
                    this.update()
                }
                update() {
                    this.getCurrentState(), this.optionElements.forEach((t => {
                        const e = t.value || t.getAttribute(Ac),
                            i = t.closest(`[${Tc}]`).getAttribute(Tc),
                            s = parseInt(i, 10) - 1;
                        let o = [...this.selections];
                        o[s] = e;
                        const r = this.productJSON.variants.find((t => {
                            let e = !0;
                            for (let i = 0; i < o.length; i++) t.options[i] !== o[i] && (e = !1);
                            return e
                        }));
                        t.classList.remove(qc, Cc), void 0 === r ? t.classList.add(Cc) : r && !1 === r.available && t.classList.add(qc)
                    }))
                }
                getCurrentState() {
                    for (var t of (this.formData = new FormData(this.form), this.selections = [], this.formData.entries())) t[0].includes("options[") && this.selections.push(t[1])
                }
                constructor(t, e) {
                    this.container = t, this.productJSON = e, this.form = this.container.querySelector(Lc), this.formData = new FormData(this.form), this.optionElements = this.container.querySelectorAll(kc), this.productJSON && this.form && this.init()
                }
            }(this.outerWrapper, this.productJSON), this.linkForm()) : console.warn("Missing product form or product JSON"), this.productJSON && new class {
                updateCookie() {
                    let t = this.cookie.read();
                    const e = t.indexOf(this.handle); - 1 === e ? (t.unshift(this.handle), t = t.splice(0, X)) : (t.splice(e, 1), t.unshift(this.handle)), this.cookie.write(t)
                }
                constructor(t) {
                    this.handle = t, this.cookie = new Y(lt), void 0 !== this.handle && (ht.push(this.handle), this.updateCookie())
                }
            }(this.productJSON.handle)
        }
        destroy() {
            this.productForm.destroy()
        }
        linkForm() {
            this.productForm = new class {
                destroy() {
                    this._listeners.removeAll()
                }
                options() {
                    return this._serializeInputValues(this.optionInputs, (function(t) {
                        return t.name = /(?:^(options\[))(.*?)(?:\])/.exec(t.name)[2], t
                    }))
                }
                variant() {
                    const t = this.options();
                    return t.length ? mt(this.product, t) : this.product.variants[0]
                }
                plan(t) {
                    let e = {
                        allocation: null,
                        group: null,
                        detail: null
                    };
                    const i = new FormData(this.form).get("selling_plan");
                    if (t && t.selling_plan_allocations && t.selling_plan_allocations.length > 0) {
                        const e = [...new Set(t.selling_plan_allocations.map((t => t.selling_plan_group_id)))],
                            i = this.element.querySelectorAll("[data-subscription-group]");
                        if (!i.length) return;
                        i.forEach((t => t.style.display = "none")), e.forEach((t => {
                            this.element.querySelector(`[data-selling-plan-group="${t}"]`).style.display = "block"
                        }))
                    }
                    return i && t && (e.allocation = t.selling_plan_allocations.find((function(t) {
                        return t.selling_plan_id.toString() === i.toString()
                    }))), e.allocation && (e.group = this.product.selling_plan_groups.find((function(t) {
                        return t.id.toString() === e.allocation.selling_plan_group_id.toString()
                    }))), e.group && (e.detail = e.group.selling_plans.find((function(t) {
                        return t.id.toString() === i.toString()
                    }))), e && e.allocation && e.detail && e.allocation ? e : null
                }
                properties() {
                    return this._serializeInputValues(this.propertyInputs, (function(t) {
                        return t.name = /(?:^(properties\[))(.*?)(?:\])/.exec(t.name)[2], t
                    }))
                }
                quantity() {
                    return this.quantityInputs[0] ? Number.parseInt(this.quantityInputs[0].value, 10) : 1
                }
                getFormState() {
                    const t = this.variant();
                    return {
                        options: this.options(),
                        variant: t,
                        properties: this.properties(),
                        quantity: this.quantity(),
                        plan: this.plan(t)
                    }
                }
                _setIdInputValue(t) {
                    t && t.id ? this.variantElement.value = t.id.toString() : this.variantElement.value = "", this.variantElement.dispatchEvent(new Event("change"))
                }
                _onSubmit(t, e) {
                    e.dataset = this.getFormState(), t.onFormSubmit && t.onFormSubmit(e)
                }
                _onOptionChange(t) {
                    this._setIdInputValue(t.dataset.variant)
                }
                _onFormEvent(t) {
                    return void 0 === t ? Function.prototype : function(e) {
                        e.dataset = this.getFormState(), this._setIdInputValue(e.dataset.variant), t(e)
                    }.bind(this)
                }
                _initInputs(t, e) {
                    return Array.prototype.slice.call(this.element.querySelectorAll(t)).map(function(t) {
                        return this._listeners.add(t, "change", this._onFormEvent(e)), t
                    }.bind(this))
                }
                _serializeInputValues(t, e) {
                    return t.reduce((function(t, i) {
                        return (i.checked || "radio" !== i.type && "checkbox" !== i.type) && t.push(e({
                            name: i.name,
                            value: i.value
                        })), t
                    }), [])
                }
                _validateProductObject(t) {
                    if ("object" != typeof t) throw new TypeError(t + " is not an object.");
                    if (void 0 === t.variants[0].options) throw new TypeError("Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route");
                    return t
                }
                constructor(t, e, i) {
                    this.element = t, this.form = "FORM" == this.element.tagName ? this.element : this.element.querySelector("form"), this.product = this._validateProductObject(e), this.variantElement = this.element.querySelector(gt), i = i || {}, this.clickedElement = null, this._listeners = new pt, this._listeners.add(this.element, "submit", this._onSubmit.bind(this, i)), this.optionInputs = this._initInputs(wt, i.onOptionChange), this.planInputs = this._initInputs(ft, i.onPlanChange), this.quantityInputs = this._initInputs(vt, i.onQuantityChange), this.propertyInputs = this._initInputs(bt, i.onPropertyChange)
                }
            }(this.outerWrapper, this.productJSON, {
                onOptionChange: this.onOptionChange.bind(this),
                onPlanChange: this.onPlanChange.bind(this),
                onQuantityChange: this.onQuantityChange.bind(this)
            }), this.pushState(this.productForm.getFormState(), !0), this.subsToggleListeners()
        }
        onOptionChange(t) {
            this.pushState(t.dataset)
        }
        onPlanChange(t) {
            this.subPrices && this.pushState(t.dataset)
        }
        onQuantityChange(t) {
            const e = t.dataset;
            this.productState = this.setProductState(e), this.updateButtonPrices(e)
        }
        pushState(t, e = !1) {
            this.productState = this.setProductState(t), this.updateProductImage(t), this.updateAddToCartState(t), this.updateProductPrices(t), this.updateSaleText(t), this.updateSubscriptionText(t), this.updateLegend(t), this.updateRemaining(t), this.fireHookEvent(t), this.sellout && this.sellout.update(t), this.enableHistoryState && !e && this.updateHistoryState(t)
        }
        updateAddToCartState(t) {
            const e = t.variant;
            let i = theme.strings.addToCart;
            const s = this.outerWrapper.querySelectorAll(Fc),
                o = this.outerWrapper.querySelector(Bc),
                r = o.querySelectorAll(Hc),
                n = o.querySelectorAll(Mc);
            if (this.isPreOrder && (i = theme.strings.preOrder), s.length && e && s.forEach((t => {
                    t.classList.remove(lh)
                })), r.length && r.forEach((t => {
                    e && e.available ? t.disabled = !1 : t.disabled = !0
                })), n.length && n.forEach((t => {
                    e ? e.available ? t.innerHTML = i : t.innerHTML = theme.strings.soldOut : t.innerHTML = theme.strings.unavailable
                })), o)
                if (e) {
                    e.available ? o.classList.remove(ch, hh) : (o.classList.add(ch), o.classList.remove(hh));
                    const t = o.querySelector(Wc);
                    t && (t.value = e.id)
                } else o.classList.add(hh), o.classList.remove(ch)
        }
        updateLegend(t) {
            const e = t.variant;
            if (e) {
                this.container.parentNode.querySelectorAll(Kc).forEach((t => {
                    const i = t.closest(`[${Jc}]`);
                    if (i) {
                        const s = i.getAttribute(Jc),
                            o = parseInt(s, 10) - 1;
                        this.newValue = e.options[o], t.innerHTML = this.newValue
                    }
                }))
            }
        }
        updateHistoryState(t) {
            const e = t.variant,
                i = t.plan,
                s = window.location.href;
            if (e && s.includes("/product")) {
                const t = new window.URL(s),
                    o = t.searchParams;
                o.set("variant", e.id), i && i.detail && i.detail.id && this.productState.hasPlan ? o.set("selling_plan", i.detail.id) : o.delete("selling_plan"), t.search = o.toString();
                const r = t.toString();
                window.history.replaceState({
                    path: r
                }, "", r)
            }
        }
        updateRemaining(t) {
            const e = t.variant;
            if (e && this.remainingWrapper && this.remainingJSON && this.remainingCount) {
                const t = this.remainingJSON[e.id];
                t && t <= this.remainingMaxInt && t > 0 ? (this.remainingWrapper.classList.remove(ph, mh, yh), this.remainingWrapper.classList.add(uh), this.remainingCount.innerHTML = t) : this.productState.soldOut ? (this.remainingWrapper.classList.remove(uh, ph, yh), this.remainingWrapper.classList.add(mh)) : this.productState.available && (this.remainingWrapper.classList.remove(uh, mh, yh), this.remainingWrapper.classList.add(ph))
            } else this.remainingWrapper && (this.remainingWrapper.classList.remove(ph, mh, uh), this.remainingWrapper.classList.add(yh))
        }
        getBaseUnit(t) {
            return 1 === t.unit_price_measurement.reference_value ? t.unit_price_measurement.reference_unit : t.unit_price_measurement.reference_value + t.unit_price_measurement.reference_unit
        }
        subsToggleListeners() {
            this.outerWrapper.querySelectorAll(th).forEach((t => {
                t.addEventListener("change", function(t) {
                    const e = t.target.value.toString(),
                        i = this.outerWrapper.querySelector(`[${eh}="${e}"]`),
                        s = this.outerWrapper.querySelectorAll(`[${eh}]`);
                    if (i) {
                        i.classList.remove(lh);
                        const t = i.querySelector('[name="selling_plan"]');
                        t.checked = !0, t.dispatchEvent(new Event("change"))
                    }
                    s.forEach((t => {
                        if (t !== i) {
                            t.classList.add(lh);
                            t.querySelectorAll('[name="selling_plan"]').forEach((t => {
                                t.checked = !1, t.dispatchEvent(new Event("change"))
                            }))
                        }
                    }))
                }.bind(this))
            }))
        }
        updateSaleText(t) {
            this.productState.planSale ? this.updateSaleTextSubscription(t) : this.productState.onSale ? this.updateSaleTextStandard(t) : this.priceOffWrap && this.priceOffWrap.classList.add(lh)
        }
        updateSaleTextStandard(t) {
            if (!this.priceOffType) return;
            this.priceOffType.innerHTML = window.theme.strings.sale || "sale";
            const e = t.variant;
            if (window.theme.settings.badge_sale_type && "percentage" === window.theme.settings.badge_sale_type) {
                const t = (e.compare_at_price - e.price) / e.compare_at_price,
                    i = Math.floor(100 * t);
                this.priceOffAmount.innerHTML = `${i}%`
            } else {
                const t = e.compare_at_price - e.price;
                this.priceOffAmount.innerHTML = this.formattingMoney(t)
            }
            this.priceOffWrap.classList.remove(lh)
        }
        updateSaleTextSubscription(t) {
            this.priceOffType.innerHTML = window.theme.strings.subscription || "subscripton";
            const e = t.variant,
                i = t.plan.detail.price_adjustments[0],
                s = i.value;
            i && "percentage" === i.value_type ? this.priceOffAmount.innerHTML = `${s}%` : i && "price" === i.value_type ? this.priceOffAmount.innerHTML = this.formattingMoney(e.price - i.value) : this.priceOffAmount.innerHTML = this.formattingMoney(s), this.priceOffWrap.classList.remove(lh)
        }
        updateSubscriptionText(t) {
            t.plan && this.planDecription && null !== t.plan.detail.description ? (this.planDecription.innerHTML = t.plan.detail.description, this.planDecription.classList.remove(lh)) : this.planDecription && this.planDecription.classList.add(lh)
        }
        getPrices(t) {
            const e = t.variant,
                i = t.plan;
            let s = "",
                o = "";
            return this.productState.available && (s = e.compare_at_price, o = e.price), this.productState.hasPlan && (o = i.allocation.price), this.productState.planSale && (s = i.allocation.compare_at_price, o = i.allocation.price), {
                price: o,
                comparePrice: s
            }
        }
        updateButtonPrices(t) {
            const e = this.outerWrapper.querySelectorAll(Oc),
                {
                    price: i
                } = this.getPrices(t);
            e.length && e.forEach((e => {
                const s = t.quantity * i;
                e.innerHTML = this.formattingMoney(s)
            }))
        }
        updateProductPrices(t) {
            const e = t.variant,
                i = this.outerWrapper.querySelectorAll(Fc),
                s = this.outerWrapper.querySelectorAll(Oc),
                {
                    price: o,
                    comparePrice: r
                } = this.getPrices(t);
            i.forEach((t => {
                const i = t.querySelector(Ic),
                    s = t.querySelector(zc),
                    n = t.querySelector(Dc);
                i && (this.productState.onSale || this.productState.planSale ? (i.classList.remove(lh), n.classList.remove(lh), s.classList.add(dh)) : (i.classList.add(lh), n.classList.add(lh), s.classList.remove(dh)), i.innerHTML = this.formattingMoney(r)), s && (s.innerHTML = e ? this.formattingMoney(o) : "&nbsp;")
            })), s.length && s.forEach((e => {
                const i = t.quantity * o;
                e.innerHTML = this.formattingMoney(i)
            })), this.hasUnitPricing && this.updateProductUnits(t)
        }
        updateProductUnits(t) {
            const e = t.variant,
                i = t.plan;
            let s = null;
            if (e && e.unit_price && (s = e.unit_price), i && i.allocation && i.allocation.unit_price && (s = i.allocation.unit_price), s) {
                const t = this.getBaseUnit(e);
                this.outerWrapper.querySelector(Rc).innerHTML = this.formattingMoney(s), this.outerWrapper.querySelector(Vc).innerHTML = t, B(this.outerWrapper.querySelector(jc))
            } else Ec(this.outerWrapper.querySelector(jc))
        }
        fireHookEvent(t) {
            const e = t.variant;
            this.container.dispatchEvent(new CustomEvent("theme:variant:change", {
                detail: {
                    variant: e
                },
                bubbles: !0
            }))
        }
        setProductState(t) {
            const e = t.variant,
                i = t.plan,
                s = {
                    available: !0,
                    soldOut: !1,
                    onSale: !1,
                    showUnitPrice: !1,
                    requiresPlan: !1,
                    hasPlan: !1,
                    planPerDelivery: !1,
                    planSale: !1
                };
            return !e || e.requires_selling_plan && !i ? s.available = !1 : (e.available || (s.soldOut = !0), e.compare_at_price > e.price && (s.onSale = !0), e.unit_price && (s.showUnitPrice = !0), this.productJSON && this.productJSON.requires_selling_plan && (s.requiresPlan = !0), i && this.subPrices && (s.hasPlan = !0, i.allocation.per_delivery_price !== i.allocation.price && (s.planPerDelivery = !0), e.price > i.allocation.price && (s.planSale = !0))), s
        }
        updateProductImage(t) {
            const e = t.variant;
            e && this.slideshow && e.featured_media && e.featured_media.id && this.slideshow.dispatchEvent(new CustomEvent("theme:image:change", {
                detail: {
                    id: e.featured_media.id
                }
            }))
        }
        formattingMoney(t) {
            return theme.settings.currency_code_enable ? l.formatMoney(t, theme.moneyFormat) + ` ${theme.currencyCode}` : l.formatMoney(t, theme.moneyFormat)
        }
        constructor() {
            super(), this.container = this
        }
    };
    const fh = "[data-product-slideshow]",
        wh = "[data-product-image]",
        vh = "[data-zoom-button]",
        bh = "[data-zoom-wrapper]",
        Sh = "data-media-id";
    const Eh = "body",
        Lh = "[data-related-section]",
        Th = "[data-tabs-holder]",
        kh = "data-tab",
        Ah = "data-tab-index",
        qh = "data-block-id",
        Ch = ".tabs > button",
        xh = ".tab-link",
        Ph = ".tab-link__recent",
        $h = ".tab-content",
        _h = "[data-scrollbar]",
        Hh = "a:first-child, input:first-child",
        Mh = "current",
        Ih = "hide",
        Dh = "alt",
        Bh = "is-focused",
        Wh = {};
    const Fh = {
            onLoad() {
                Wh[this.id] = [];
                this.container.querySelectorAll(Th).forEach((t => {
                    Wh[this.id].push(new class {
                        init() {
                            const t = this.container,
                                e = t.querySelectorAll(Ch),
                                i = t.querySelector(`${xh}-0`),
                                s = t.querySelector(`${$h}-0`);
                            s && s.classList.add(Mh), i && i.classList.add(Mh), this.checkVisibleTabLinks(), this.container.addEventListener("theme:tabs:check", (() => this.checkRecentTab())), this.container.addEventListener("theme:tabs:hide", (() => this.hideRelatedTab())), e.length && e.forEach((e => {
                                const i = parseInt(e.getAttribute(kh)),
                                    s = t.querySelector(`${$h}-${i}`);
                                e.addEventListener("click", (() => {
                                    this.tabChange(e, s)
                                })), e.addEventListener("keyup", (t => {
                                    t.which !== window.theme.keyboardKeys.SPACE && t.which !== window.theme.keyboardKeys.ENTER || !this.body.classList.contains(Bh) || (this.tabChange(e, s), s.querySelector("a, input") && (this.accessibility.lastFocused = e, this.accessibility.a11y.trapFocus(s, {
                                        elementToFocus: s.querySelector(Hh)
                                    })))
                                }))
                            }))
                        }
                        tabChange(t, e) {
                            this.container.querySelector(`${Ch}.${Mh}`).classList.remove(Mh), this.container.querySelector(`${$h}.${Mh}`).classList.remove(Mh), t.classList.add(Mh), e.classList.add(Mh), t.classList.contains(Ih) && e.classList.add(Ih), this.checkVisibleTabLinks(), this.container.dispatchEvent(new CustomEvent("theme:tab:change"))
                        }
                        initNativeScrollbar() {
                            this.scrollbarHolder.length && this.scrollbarHolder.forEach((t => {
                                new V(t)
                            }))
                        }
                        checkVisibleTabLinks() {
                            const t = this.container.querySelectorAll(Ch),
                                e = this.container.querySelectorAll(`${xh}.${Ih}`);
                            t.length - e.length < 2 ? this.container.classList.add(Dh) : this.container.classList.remove(Dh)
                        }
                        checkRecentTab() {
                            const t = this.container.querySelector(Ph);
                            if (t) {
                                t.classList.remove(Ih);
                                const e = parseInt(t.getAttribute(kh)),
                                    i = this.container.querySelector(`${$h}[${Ah}="${e}"]`);
                                i && i.classList.remove(Ih), this.checkVisibleTabLinks(), this.initNativeScrollbar()
                            }
                        }
                        hideRelatedTab() {
                            const t = this.container.querySelector(Lh);
                            if (!t) return;
                            const e = t.closest(`${$h}.${Mh}`);
                            if (!e) return;
                            const i = parseInt(e.getAttribute(Ah)),
                                s = this.container.querySelectorAll(Ch);
                            if (s.length > i) {
                                const t = s[i].nextSibling;
                                t && (s[i].classList.add(Ih), t.dispatchEvent(new Event("click")), this.initNativeScrollbar())
                            }
                        }
                        onBlockSelect(t) {
                            const e = this.container.querySelector(`${xh}[${qh}="${t.detail.blockId}"]`);
                            e && (e.dispatchEvent(new Event("click")), e.parentNode.scrollTo({
                                top: 0,
                                left: e.offsetLeft - e.clientWidth,
                                behavior: "smooth"
                            }))
                        }
                        constructor(t) {
                            this.container = t, this.body = document.querySelector(Eh), this.accessibility = window.accessibility, this.container && (this.scrollbarHolder = this.container.querySelectorAll(_h), this.init(), this.initNativeScrollbar())
                        }
                    }(t))
                }))
            },
            onBlockSelect(t) {
                Wh[this.id].forEach((e => {
                    "function" == typeof e.onBlockSelect && e.onBlockSelect(t)
                }))
            }
        },
        Oh = "[data-share-url]",
        Nh = "data-section-type",
        zh = "[data-share-details]",
        Rh = "[data-share-summary]",
        Vh = "[data-share-copy]",
        jh = "[data-share-button]",
        Uh = "[data-close-button]",
        Jh = "[data-success-message]",
        Kh = "[data-share-holder]",
        Yh = "is-hidden";
    let Gh = class extends HTMLElement {
        init() {
            navigator.share ? (this.mainDetailsToggle.classList.add(Yh), this.shareButton.classList.remove(Yh), this.shareButton.addEventListener("click", (() => {
                navigator.share({
                    url: this.urlToShare,
                    title: document.title
                })
            }))) : (this.mainDetailsToggle.addEventListener("toggle", this.toggleDetails.bind(this)), this.mainDetailsToggle.addEventListener("focusout", (() => {
                setTimeout((() => {
                    this.contains(document.activeElement) || this.close()
                }))
            })), this.shareCopy.addEventListener("click", this.copyToClipboard.bind(this)), this.closeButton.addEventListener("click", this.close.bind(this)), this.container.addEventListener("keyup", this.keyboardEvents.bind(this)))
        }
        updateShareLink() {
            "product" == this.container.getAttribute(Nh) && this.container.addEventListener("theme:variant:change", (t => {
                t.detail.variant && (this.urlToShare = `${this.urlToShare.split("?")[0]}?variant=${t.detail.variant.id}`, this.urlInput && (this.urlInput.value = `${this.urlToShare.split("?")[0]}?variant=${t.detail.variant.id}`))
            }))
        }
        toggleDetails() {
            this.mainDetailsToggle.open || (this.successMessage.classList.add(Yh), this.successMessage.textContent = "", this.closeButton.classList.add(Yh), this.shareCopy.focus())
        }
        copyToClipboard() {
            navigator.clipboard.writeText(this.urlInput.value).then((() => {
                this.successMessage.classList.remove(Yh), this.successMessage.textContent = theme.strings.successMessage, this.closeButton.classList.remove(Yh), this.closeButton.focus()
            }))
        }
        close() {
            this.mainDetailsToggle.removeAttribute("open"), this.shareSummary.setAttribute("aria-expanded", !1)
        }
        keyboardEvents(t) {
            t.which === window.theme.keyboardKeys.ESCAPE && (this.mainDetailsToggle.focus(), this.close())
        }
        constructor() {
            super(), this.container = this.closest(`[${Nh}]`), this.mainDetailsToggle = this.querySelector(zh), this.shareButton = this.querySelector(jh), this.shareCopy = this.querySelector(Vh), this.shareSummary = this.querySelector(Rh), this.closeButton = this.querySelector(Uh), this.successMessage = this.querySelector(Jh), this.shareHolder = this.querySelector(Kh), this.urlInput = this.querySelector(Oh), this.urlToShare = this.urlInput ? this.urlInput.value : document.location.href, this.init(), this.updateShareLink()
        }
    };
    const Xh = "data-image-filter",
        Qh = "[data-product-slideshow]",
        Zh = "[data-product-thumbs]",
        td = "[data-slideshow-thumbnail]",
        ed = "[data-media-slide]",
        id = "hide",
        sd = "flickity-enabled";
    const od = "[data-product-json]",
        rd = "[data-zoom-button]",
        nd = "[data-truncated-holder]",
        ad = "[data-truncated-button]",
        ld = "data-truncated-content",
        cd = "is-expanded",
        hd = "is-visible",
        dd = [];
    const ud = {
        onLoad() {
            dd[this.id] = new class {
                init() {
                    var t, e;
                    this.zoomEnabled = null !== this.container.querySelector(rd), this.zoomEnabled && (t = this.container, e = this.product, Et({
                        url: window.theme.assets.photoswipe
                    }).then((() => {
                        const i = window.themePhotoswipe.PhotoSwipe.default,
                            s = window.themePhotoswipe.PhotoSwipeUI.default;
                        t.querySelectorAll(vh).forEach((o => {
                            o.addEventListener("click", (o => {
                                const r = t.querySelector(bh),
                                    n = o.target.closest(`[${Sh}]`).getAttribute(Sh).toString(),
                                    a = [];
                                for (let t = 0; t < e.media.length; t++) "image" === e.media[t].media_type && (a[a.length] = {
                                    src: e.media[t].src,
                                    w: e.media[t].width,
                                    h: e.media[t].height,
                                    id: e.media[t].id
                                });
                                const l = {
                                    index: a.findIndex((t => t.id.toString() === n)),
                                    showHideOpacity: !0,
                                    showAnimationDuration: 150,
                                    hideAnimationDuration: 250,
                                    bgOpacity: 1,
                                    spacing: 0,
                                    allowPanToNext: !1,
                                    maxSpreadZoom: 3,
                                    history: !1,
                                    loop: !0,
                                    pinchToClose: !1,
                                    modal: !1,
                                    closeOnScroll: !1,
                                    closeOnVerticalDrag: !0,
                                    getDoubleTapZoom: function(t, e) {
                                        return t ? 1.67 : e.initialZoomLevel < .7 ? 1 : 1.3
                                    },
                                    getThumbBoundsFn: function() {
                                        let e = t.querySelector(fh);
                                        e || (e = t.querySelector(wh));
                                        const i = window.pageYOffset || document.documentElement.scrollTop,
                                            s = e.getBoundingClientRect();
                                        return {
                                            x: s.left,
                                            y: s.top + i,
                                            w: s.width
                                        }
                                    }
                                };
                                r.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                                    bubbles: !0
                                }));
                                const c = new i(r, s, a, l);
                                c.init(), c.listen("close", (function() {
                                    document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                                        bubbles: !0
                                    }))
                                }))
                            }))
                        }))
                    })).catch((t => console.error(t)))), this.truncateElementHolder && this.truncateElement && (setTimeout(this.resizeEventTruncate, 50), document.addEventListener("theme:resize", this.resizeEventTruncate)), new Ce(this.container)
                }
                truncateText() {
                    if (this.truncateElementHolder.classList.contains(hd)) return;
                    const t = this.truncateElement.querySelectorAll("style");
                    t.length && t.forEach((t => {
                        this.truncateElementHolder.prepend(t)
                    }));
                    const e = this.truncateElement.cloneNode(!0),
                        i = this.truncateElement.getAttribute(ld),
                        s = this.truncateElement.nextElementSibling;
                    s && s.remove(), this.truncateElement.parentElement.append(e);
                    const o = this.truncateElement.nextElementSibling;
                    o.classList.add(i), o.removeAttribute(ld), B(o), ((t = "", e = 1, i = {}) => {
                        const s = {
                                replaceStr: "...",
                                debounceDelay: 250,
                                delimiter: " ",
                                ...i
                            },
                            o = t && (t instanceof NodeList ? t : 1 === t.nodeType ? [t] : document.querySelectorAll(t));
                        for (let t = 0; t < o.length; t++) {
                            const i = o[t],
                                r = /<!--[\s\S]*?-->/g,
                                n = i.innerHTML.replace(r, "").split(s.delimiter);
                            i.innerHTML = "";
                            const a = window.getComputedStyle(i);
                            n.reduce(Ul, {
                                el: i,
                                buffer: i.innerHTML,
                                elStyle: a,
                                elHeight: 0,
                                rowsLimit: e,
                                rowsWrapped: 0,
                                options: s
                            })
                        }
                    })(o, 5, {
                        replaceStr: "",
                        delimiter: " "
                    }), Ec(o), this.truncateElement.innerHTML !== o.innerHTML ? this.truncateElementHolder.classList.add(cd) : (o.remove(), this.truncateElementHolder.classList.remove(cd)), this.toggleTruncatedContent(this.truncateElementHolder)
                }
                toggleTruncatedContent(t) {
                    const e = t.querySelector(ad);
                    e && e.addEventListener("click", (e => {
                        e.preventDefault(), t.classList.remove(cd), t.classList.add(hd)
                    }))
                }
                onBlockSelect(t) {
                    const e = this.container.querySelector(`[data-block-id="${t.detail.blockId}"]`);
                    e && e.dispatchEvent(new Event("click"))
                }
                onBlockDeselect(t) {
                    const e = this.container.querySelector(`[data-block-id="${t.detail.blockId}"]`);
                    e && e.dispatchEvent(new Event("click"))
                }
                onUnload() {
                    this.media.destroy(), this.truncateElementHolder && this.truncateElement && document.removeEventListener("theme:resize", this.resizeEventTruncate)
                }
                constructor(t) {
                    this.section = t, this.id = t.id, this.container = t.container, this.settings = t.settings, Di(this.id), this.media = new class {
                        init() {
                            this.storeEvents(), this.connectSliderMediaEvents(), this.detectVideo(), this.detectYouTube(), this.detect3d(), this.scrollThumbs(), document.addEventListener("theme:resize:width", (() => {
                                this.scrollThumbs()
                            }))
                        }
                        connectSliderMediaEvents() {
                            const t = `(max-width: ${window.theme.sizes.medium}px)`,
                                e = window.matchMedia(t);
                            e.addEventListener("change", (t => {
                                t.matches ? this.createMobileSlider() : this.createDesktopSlider()
                            })), e.matches ? this.createMobileSlider() : this.createDesktopSlider()
                        }
                        createMobileSlider() {
                            this.flkty && this.destroySlider();
                            const t = {
                                autoPlay: !1,
                                prevNextButtons: !1,
                                pageDots: !1,
                                adaptiveHeight: !0,
                                accessibility: !0,
                                watchCSS: !1,
                                wrapAround: !0,
                                rightToLeft: window.isRTL,
                                dragThreshold: 80,
                                contain: !0,
                                fade: !0
                            };
                            "carousel" == this.mobileStyle && (t.contain = !1, t.dragThreshold = 10, t.fade = !1), "slideshow" == this.mobileStyle && (t.pageDots = !0, t.fade = !1, t.dragThreshold = 10), this.createSlider(t)
                        }
                        createDesktopSlider() {
                            if (this.flkty && this.destroySlider(), "none" == this.desktopStyle) return;
                            const t = {
                                autoPlay: !1,
                                prevNextButtons: !1,
                                pageDots: !1,
                                adaptiveHeight: !0,
                                accessibility: !0,
                                watchCSS: !1,
                                wrapAround: !0,
                                rightToLeft: window.isRTL,
                                dragThreshold: 80,
                                contain: !0,
                                fade: !0
                            };
                            this.createSlider(t)
                        }
                        createSlider(t) {
                            this.flkty = new s(this.slideshow, t), this.flkty.resize(), this.currentSlide = this.slideshow.querySelectorAll(ac.mediaSlide)[0], this.setDraggable(), this.addEventListeners()
                        }
                        destroySlider() {
                            this.removeEventListeners(), this.flkty.destroy()
                        }
                        storeEvents() {
                            this.storeFlktyChange = t => this.doFlktyChange(t), this.storeFlktySettle = t => this.doFlktySettle(t), this.storeImageChange = t => this.doImageChange(t), this.storeArrowPrevClick = t => this.doArrowPrevClick(t), this.storeArrowNextClick = t => this.doArrowNextClick(t), this.storeThumbClick = t => this.doThumbClick(t), this.storeThumbContainerScroll = t => this.doThumbContainerScroll(t)
                        }
                        addEventListeners() {
                            var t, e, i;
                            this.flkty.on("change", this.storeFlktyChange), this.flkty.on("settle", this.storeFlktySettle), this.slideshow.addEventListener("theme:image:change", this.storeImageChange), null === (t = this.arrowPrev) || void 0 === t || t.addEventListener("click", this.storeArrowPrevClick), null === (e = this.arrowNext) || void 0 === e || e.addEventListener("click", this.storeArrowNextClick), null === (i = this.thumbs) || void 0 === i || i.addEventListener("scroll", this.storeThumbContainerScroll), this.thumbImages.forEach((t => {
                                t.addEventListener("click", this.storeThumbClick)
                            }))
                        }
                        removeEventListeners() {
                            var t, e, i;
                            this.flkty.on("change", this.storeFlktyChange), this.flkty.on("settle", this.storeFlktySettle), this.slideshow.removeEventListener("theme:image:change", this.storeImageChange), null === (t = this.arrowPrev) || void 0 === t || t.removeEventListener("click", this.storeArrowPrevClick), null === (e = this.arrowNext) || void 0 === e || e.removeEventListener("click", this.storeArrowNextClick), null === (i = this.thumbs) || void 0 === i || i.removeEventListener("scroll", this.storeThumbContainerScroll), this.thumbImages.forEach((t => {
                                t.removeEventListener("click", this.storeThumbClick)
                            }))
                        }
                        doFlktyChange(t) {
                            var e, i;
                            this.currentSlide.dispatchEvent(new CustomEvent("pause")), this.currentSlide = this.flkty.cells[t].element, this.slideshow.classList.remove(ac.flickitylockHeight);
                            const s = this.currentSlide.getAttribute(ac.dataMediaId),
                                o = null === (e = this.thumbWrapper) || void 0 === e ? void 0 : e.querySelector(`[${ac.dataMediaSelect}="${s}"]`);
                            null === (i = this.thumbWrapper) || void 0 === i || i.querySelector(`.${lc}`).classList.remove(lc), null == o || o.classList.add(lc), this.scrollThumbs()
                        }
                        doFlktySettle(t) {
                            this.allSlides = this.flkty.cells, this.currentSlide = this.flkty.cells[t].element, this.setDraggable(), this.currentSlide.dispatchEvent(new CustomEvent("theme:media:play-desktop")), document.body.classList.contains(ac.focusEnabled) && this.currentSlide.dispatchEvent(new Event("focus")), this.scrollThumbs()
                        }
                        doImageChange(t) {
                            var e = t.detail.id;
                            const i = `[${ac.dataMediaId}="${e}"]`,
                                s = this.flkty.cells.findIndex((t => t.element.matches(i)));
                            this.flkty.select(s), this.scrollThumbs()
                        }
                        doThumbContainerScroll() {
                            this.scrollThumbs("scroll")
                        }
                        doArrowPrevClick() {
                            this.scrollThumbs("clickPrev")
                        }
                        doArrowNextClick() {
                            this.scrollThumbs("clickNext")
                        }
                        doThumbClick(t) {
                            const e = t.currentTarget.getAttribute(ac.dataMediaSelect);
                            this.slideshow.dispatchEvent(new CustomEvent("theme:image:change", {
                                detail: {
                                    id: e
                                }
                            }))
                        }
                        setDraggable() {
                            if (this.currentSlide) {
                                const t = this.currentSlide.getAttribute(ac.mediaType);
                                "model" === t || "video" === t || "external_video" === t ? (this.flkty.options.draggable = !1, this.flkty.updateDraggable()) : (this.flkty.options.draggable = !0, this.flkty.updateDraggable())
                            }
                        }
                        detect3d() {
                            const t = this.container.querySelectorAll(ac.modelViewer);
                            t && (t.forEach((t => {
                                ! function(t, e) {
                                    Jl[e] = {
                                        loaded: !1
                                    };
                                    const i = t.getAttribute(Ql),
                                        s = t.querySelector(tc),
                                        o = s.getAttribute(Zl);
                                    if (null !== t.closest(Gl)) {
                                        const i = t.closest(Gl).parentElement.querySelector(Xl);
                                        Yl[e] = {
                                            $element: i,
                                            defaultId: o
                                        }
                                    }
                                    Kl[i] = {
                                        modelId: o,
                                        mediaId: i,
                                        sectionId: e,
                                        $container: t,
                                        $element: s
                                    }, window.Shopify.loadFeatures([{
                                        name: "shopify-xr",
                                        version: "1.0",
                                        onLoad: sc
                                    }, {
                                        name: "model-viewer-ui",
                                        version: "1.0",
                                        onLoad: oc
                                    }])
                                }(t, this.section.id)
                            })), document.addEventListener("shopify_xr_launch", function() {
                                this.container.querySelectorAll(ac.allPlayers).forEach((t => {
                                    t.dispatchEvent(new CustomEvent("pause"))
                                }))
                            }.bind(this)))
                        }
                        detectVideo() {
                            const t = this.section.container.querySelectorAll(ac.videoPlayerNative);
                            for (var e of t) {
                                const t = nc(e.dataset.player);
                                !0 === this.loopVideo && t.then((t => (t.loop = !0, t))).catch((t => {
                                    console.error(t)
                                }))
                            }
                        }
                        detectYouTube() {
                            const t = this.section.container.querySelectorAll(ac.videoPlayerExternal);
                            for (var e of t) {
                                const t = Aa(e.dataset.player);
                                !0 === this.loopVideo && t.then((t => hc(t))).catch((t => {
                                    console.error(t)
                                }))
                            }
                        }
                        pauseAllMedia() {
                            this.container.querySelector(ac.mediaSlide).dispatchEvent(new CustomEvent("pause"))
                        }
                        pauseOtherMedia(t) {
                            this.container.querySelector(`${ac.mediaSlide}:not([data-player="${t}"])`).dispatchEvent(new CustomEvent("pause"))
                        }
                        destroy() {
                            this.container.querySelectorAll(ac.allPlayers).forEach((t => {
                                t.dispatchEvent(new CustomEvent("destroy"))
                            }))
                        }
                        scrollThumbs(t) {
                            if (this.thumbs = this.container.querySelector(ac.productThumbs), this.thumbs) {
                                if (this.thumb = this.thumbs.querySelector(`.${lc}`), this.thumbItems = this.container.querySelectorAll(ac.thumbImage), this.lastThumb = this.thumbItems[this.thumbItems.length - 1], !this.thumb) return;
                                this.thumbsScrollTop = this.thumbs.scrollTop, this.thumbsScrollLeft = this.thumbs.scrollLeft, this.thumbsWidth = this.thumbs.offsetWidth, this.thumbsHeight = this.slideshow.offsetWidth / this.thumb.getAttribute(ac.aspectRatio), this.thumbsPositionBottom = this.thumbsScrollTop + this.thumbsHeight, this.thumbsPositionRight = this.thumbsScrollLeft + this.thumbsWidth, this.checkThumbPositions(), this.toggleToActiveThumb(t), this.toggleArrows()
                            }
                        }
                        checkThumbPositions() {
                            this.thumbWidth = this.thumb.offsetWidth, this.thumbHeight = this.thumb.offsetHeight, this.thumbPosTop = this.thumb.offsetTop, this.thumbPosLeft = this.thumb.offsetLeft, this.lastThumbRightPos = this.lastThumb.offsetLeft + this.thumbWidth, this.lastThumbBottomPos = this.lastThumb.offsetTop + this.thumbHeight, this.scrollTopPosition = this.thumbPosTop + this.thumbHeight / 2 - this.thumbsHeight / 2, this.scrollLeftPosition = this.thumbPosLeft + this.thumbWidth / 2 - this.thumbsWidth / 2, this.topCheck = this.thumbsScrollTop > 0, this.bottomCheck = this.thumbsPositionBottom < this.lastThumbBottomPos, this.leftCheck = this.thumbsScrollLeft > 0, this.rightCheck = this.thumbsPositionRight < this.lastThumbRightPos, this.verticalCheck = this.bottomCheck || this.topCheck, this.horizontalCheck = this.rightCheck || this.leftCheck
                        }
                        toggleToActiveThumb(t) {
                            "scroll" !== t && ("clickPrev" == t && (this.verticalCheck ? (this.scrollTopPosition = this.thumbsScrollTop - this.thumbsHeight, this.scrollLeftPosition = 0) : (this.scrollTopPosition = 0, this.scrollLeftPosition = this.thumbsScrollLeft - this.thumbsWidth)), "clickNext" == t && (this.verticalCheck ? (this.scrollTopPosition = this.thumbsScrollTop + this.thumbsHeight, this.scrollLeftPosition = 0) : (this.scrollTopPosition = 0, this.scrollLeftPosition = this.thumbsScrollLeft + this.thumbsWidth)), this.thumbs.scrollTo({
                                top: this.scrollTopPosition,
                                left: this.scrollLeftPosition,
                                behavior: "smooth"
                            }))
                        }
                        toggleArrows() {
                            (this.verticalCheck || this.verticalAlignment && !this.verticalCheck) && (this.arrowPrev.classList.toggle(cc, this.topCheck), this.arrowNext.classList.toggle(cc, this.bottomCheck)), (this.horizontalCheck || !this.verticalAlignment && !this.horizontalCheck) && (this.arrowPrev.classList.toggle(cc, this.leftCheck), this.arrowNext.classList.toggle(cc, this.rightCheck))
                        }
                        constructor(t) {
                            this.section = t, this.container = t.container, this.slideshow = this.container.querySelector(ac.productSlideshow), this.mobileStyle = this.slideshow.getAttribute(ac.slideshowMobileStyle), this.desktopStyle = this.slideshow.getAttribute(ac.slideshowDesktopStyle), this.arrowPrev = this.container.querySelector(ac.arrowPrev), this.arrowNext = this.container.querySelector(ac.arrowNext), this.leftThumbsHolder = this.container.querySelector(ac.leftThumbsHolder), this.thumbWrapper = this.container.querySelector(ac.productThumbs), this.thumbImages = this.container.querySelectorAll(ac.thumbImage), this.loopVideo = "true" === this.container.getAttribute(ac.loopVideo), this.verticalAlignment = Boolean(this.container.querySelector(ac.verticalAlignment)), this.flkty = null, this.thumbs = this.container.querySelector(ac.productThumbs), this.currentSlide = null, this.init()
                        }
                    }(t), new class {
                        listen() {
                            this.container.addEventListener("theme:variant:change", (t => {
                                t.detail.variant && (this.variantImage = t.detail.variant.featured_image, this.filterImages())
                            }))
                        }
                        filterImages() {
                            null !== this.variantImage && null !== this.variantImage.alt ? (this.variantImageAlt = this.variantImage.alt.split("#")[1], this.showImages()) : this.resetImages(), this.refreshSliders()
                        }
                        resetImages() {
                            this.thumbs.forEach((t => t.classList.remove(id))), this.slides.forEach((t => t.classList.remove(id)))
                        }
                        showImages() {
                            this.thumbs.forEach((t => {
                                "" === t.getAttribute(Xh) || t.getAttribute(Xh) === this.variantImageAlt ? t.classList.remove(id) : t.classList.add(id)
                            })), this.slides.forEach((t => {
                                "" === t.getAttribute(Xh) || t.getAttribute(Xh) === this.variantImageAlt ? t.classList.remove(id) : t.classList.add(id)
                            }))
                        }
                        refreshSliders() {
                            if (null !== this.slider && this.slider.classList.contains(sd)) {
                                const t = e.data(this.slider);
                                void 0 !== t && t.reloadCells()
                            }
                            if (null !== this.thumbSlider && this.thumbSlider.classList.contains(sd)) {
                                const t = h.data(this.thumbSlider);
                                void 0 !== t && t.reloadCells()
                            }
                        }
                        constructor(t) {
                            this.section = t, this.container = t.container, this.slider = this.container.querySelector(Qh), this.thumbSlider = this.container.querySelector(Zh), this.thumbs = this.container.querySelectorAll(td), this.slides = this.container.querySelectorAll(ed), this.variantImage = null, this.listen()
                        }
                    }(t);
                    const i = this.container.querySelector(od);
                    i && "" !== i.innerHTML ? (this.product = JSON.parse(i.innerHTML), this.truncateElementHolder = this.container.querySelector(nd), this.truncateElement = this.container.querySelector(`[${ld}]`), this.resizeEventTruncate = () => this.truncateText(), this.init()) : console.error("Missing product JSON")
                }
            }(this)
        },
        onUnload() {
            "function" == typeof dd[this.id].unload && dd[this.id].unload()
        },
        onBlockSelect(t) {
            "function" == typeof dd[this.id].onBlockSelect && dd[this.id].onBlockSelect(t)
        },
        onBlockDeselect(t) {
            "function" == typeof dd[this.id].onBlockDeselect && dd[this.id].onBlockDeselect(t)
        }
    };
    xi("product", [ud, Sc, gn, Fh, Ct]), customElements.get("product-form") || customElements.define("product-form", gh), customElements.get("radio-swatch") || customElements.define("radio-swatch", zt), customElements.get("popout-select") || customElements.define("popout-select", ur), customElements.get("share-button") || customElements.define("share-button", Gh);
    const pd = "data-toggle-grid",
        md = "data-grid-large",
        yd = "data-grid-small",
        gd = "is-active",
        fd = window.theme.sizes.small;
    var wd = {};
    const vd = {
            onLoad() {
                wd[this.id] = [];
                this.container.querySelectorAll(`[${pd}]`).forEach((t => {
                    wd[this.id].push(new class {
                        init() {
                            this.toggle.addEventListener("click", this.toggleFunction), document.addEventListener("theme:resize:width", this.toggleFunction), this.toggleEvent(!1)
                        }
                        unload() {
                            this.toggle.removeEventListener("click", this.toggleFunction), document.removeEventListener("theme:resize:width", this.toggleFunction)
                        }
                        toggleEvent(t = !0) {
                            const e = t && "click" === t.type,
                                i = window.innerWidth >= fd ? md : yd,
                                s = this.container.querySelector(`[${i}]`),
                                o = s.getAttribute(i),
                                r = this.toggle.parentElement.querySelector(`[${pd}].${gd}`);
                            let n = this.toggle.parentElement.querySelector(`[${pd}="${o}"]`);
                            e && (n = this.toggle, s.setAttribute(i, this.value), window.lazySizes && window.lazySizes.autoSizer.checkElems()), r && r.classList.remove(gd), n && n.classList.add(gd)
                        }
                        constructor(t, e) {
                            this.container = e || document, this.toggle = t, this.value = this.toggle.getAttribute(pd), this.toggleFunction = t => this.toggleEvent(t), this.init()
                        }
                    }(t, this.container))
                }))
            },
            onUnload: function() {
                wd[this.id].forEach((t => {
                    "function" == typeof t.unload && t.unload()
                }))
            }
        },
        bd = "data-sort-enabled",
        Sd = "[data-sort-link]",
        Ed = "[data-sort-button-text]",
        Ld = "data-value",
        Td = "popout-list__item--current";
    var kd = "[data-tag-group]",
        Ad = ".link--add",
        qd = ".link--remove",
        Cd = "data-swatch";
    xi("collection", [{
        onLoad() {
            this.collection = new class {
                init() {
                    new class {
                        init() {
                            this.sortLinks.forEach((t => {
                                t.addEventListener("click", (t => {
                                    t.preventDefault(), this.sortingResults(t)
                                }))
                            }))
                        }
                        sortingResults(t) {
                            const e = t.currentTarget,
                                i = e.getAttribute(Ld),
                                s = e.innerText;
                            this.sortButtonText.innerText = s, this.sortButtonText.parentNode.dispatchEvent(new Event("click")), this.sort.querySelector(`.${Td}`).classList.remove(Td), e.parentNode.classList.add(Td), this.sort.setAttribute(bd, i), this.container.dispatchEvent(new CustomEvent("theme:form:filter", {
                                bubbles: !0,
                                detail: {
                                    params: i
                                }
                            }))
                        }
                        constructor(t) {
                            this.container = t.container, this.sort = this.container.querySelector(`[${bd}]`), this.sortLinks = this.container.querySelectorAll(Sd), this.sortButtonText = this.container.querySelector(Ed), this.sort && this.init()
                        }
                    }(this.section), this.removeUnusableFilters()
                }
                removeUnusableFilters() {
                    const t = this.container.querySelectorAll(kd);
                    t.length > 0 && t.forEach((t => {
                        const e = t.querySelector(Ad),
                            i = t.querySelector(qd);
                        e || i || Ec(t)
                    }))
                }
                constructor(t) {
                    this.section = t, this.container = this.section.container, this.swatches = this.container.querySelectorAll(`[${Cd}]`), this.init()
                }
            }(this)
        }
    }, Ml, Ol, vd, Vt, gn, J]), customElements.get("popout-select") || customElements.define("popout-select", ur), customElements.get("radio-swatch") || customElements.define("radio-swatch", zt), customElements.get("product-grid-item") || customElements.define("product-grid-item", Wo), customElements.get("product-grid-item-content") || customElements.define("product-grid-item-content", Qo), customElements.get("upsell-product") || customElements.define("upsell-product", Ge), xi("collection-row", [Vt, J, Xt]), customElements.get("radio-swatch") || customElements.define("radio-swatch", zt), customElements.get("product-grid-item") || customElements.define("product-grid-item", Wo), customElements.get("product-grid-item-content") || customElements.define("product-grid-item-content", Qo), customElements.get("upsell-product") || customElements.define("upsell-product", Ge), xi("collection-tabs", [Fh, Ya, Vt]), customElements.get("radio-swatch") || customElements.define("radio-swatch", zt), customElements.get("product-grid-item") || customElements.define("product-grid-item", Wo), customElements.get("product-grid-item-content") || customElements.define("product-grid-item-content", Qo), customElements.get("upsell-product") || customElements.define("upsell-product", Ge);
    var xd = {};

    function Pd(t) {
        return xd[t]
    }
    xd.basic = [], xd.light = [{
        featureType: "administrative",
        elementType: "labels",
        stylers: [{
            visibility: "on"
        }, {
            lightness: "64"
        }, {
            hue: "#ff0000"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{
            color: "#bdbdbd"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "landscape",
        elementType: "all",
        stylers: [{
            color: "#f0f0f0"
        }, {
            visibility: "simplified"
        }]
    }, {
        featureType: "landscape.natural.landcover",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "landscape.natural.terrain",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "geometry.fill",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "labels",
        stylers: [{
            lightness: "100"
        }]
    }, {
        featureType: "poi.park",
        elementType: "all",
        stylers: [{
            visibility: "on"
        }]
    }, {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [{
            saturation: "-41"
        }, {
            color: "#e8ede7"
        }]
    }, {
        featureType: "poi.park",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road",
        elementType: "all",
        stylers: [{
            saturation: "-100"
        }]
    }, {
        featureType: "road",
        elementType: "labels",
        stylers: [{
            lightness: "25"
        }, {
            gamma: "1.06"
        }, {
            saturation: "-100"
        }]
    }, {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{
            gamma: "10.00"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }, {
            visibility: "simplified"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [{
            weight: "0.8"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry.fill",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{
            gamma: "10.00"
        }, {
            lightness: "100"
        }, {
            weight: "0.4"
        }]
    }, {
        featureType: "road.local",
        elementType: "labels",
        stylers: [{
            visibility: "simplified"
        }, {
            weight: "0.01"
        }, {
            lightness: "39"
        }]
    }, {
        featureType: "road.local",
        elementType: "labels.text.stroke",
        stylers: [{
            weight: "0.50"
        }, {
            gamma: "10.00"
        }, {
            lightness: "100"
        }]
    }, {
        featureType: "transit",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "water",
        elementType: "all",
        stylers: [{
            color: "#cfe5ee"
        }, {
            visibility: "on"
        }]
    }], xd.light_blank = [{
        featureType: "all",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }, {
            lightness: "64"
        }, {
            hue: "#ff0000"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{
            color: "#bdbdbd"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "landscape",
        elementType: "all",
        stylers: [{
            color: "#f0f0f0"
        }, {
            visibility: "simplified"
        }]
    }, {
        featureType: "landscape.natural.landcover",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "landscape.natural.terrain",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "geometry.fill",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "labels",
        stylers: [{
            lightness: "100"
        }]
    }, {
        featureType: "poi.park",
        elementType: "all",
        stylers: [{
            visibility: "on"
        }]
    }, {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [{
            saturation: "-41"
        }, {
            color: "#e8ede7"
        }]
    }, {
        featureType: "poi.park",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road",
        elementType: "all",
        stylers: [{
            saturation: "-100"
        }]
    }, {
        featureType: "road",
        elementType: "labels",
        stylers: [{
            lightness: "25"
        }, {
            gamma: "1.06"
        }, {
            saturation: "-100"
        }, {
            visibility: "off"
        }]
    }, {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{
            gamma: "10.00"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }, {
            visibility: "simplified"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [{
            weight: "0.8"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry.fill",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{
            gamma: "10.00"
        }, {
            lightness: "100"
        }, {
            weight: "0.4"
        }]
    }, {
        featureType: "road.local",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }, {
            weight: "0.01"
        }, {
            lightness: "39"
        }]
    }, {
        featureType: "road.local",
        elementType: "labels.text.stroke",
        stylers: [{
            weight: "0.50"
        }, {
            gamma: "10.00"
        }, {
            lightness: "100"
        }]
    }, {
        featureType: "transit",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "water",
        elementType: "all",
        stylers: [{
            color: "#cfe5ee"
        }, {
            visibility: "on"
        }]
    }], xd.white_blank = [{
        featureType: "all",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{
            color: "#444444"
        }]
    }, {
        featureType: "landscape",
        elementType: "all",
        stylers: [{
            color: "#f2f2f2"
        }]
    }, {
        featureType: "poi",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road",
        elementType: "all",
        stylers: [{
            saturation: -100
        }, {
            lightness: 45
        }]
    }, {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{
            weight: "0.8"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.8"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{
            weight: "0.8"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "transit",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "water",
        elementType: "all",
        stylers: [{
            color: "#e4e4e4"
        }, {
            visibility: "on"
        }]
    }], xd.white_label = [{
        featureType: "all",
        elementType: "all",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "all",
        elementType: "labels",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels",
        stylers: [{
            gamma: "3.86"
        }, {
            lightness: "100"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{
            color: "#cccccc"
        }]
    }, {
        featureType: "landscape",
        elementType: "all",
        stylers: [{
            color: "#f2f2f2"
        }]
    }, {
        featureType: "poi",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road",
        elementType: "all",
        stylers: [{
            saturation: -100
        }, {
            lightness: 45
        }]
    }, {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{
            weight: "0.8"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.8"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{
            weight: "0.8"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.local",
        elementType: "labels.text",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "transit",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "water",
        elementType: "all",
        stylers: [{
            color: "#e4e4e4"
        }, {
            visibility: "on"
        }]
    }], xd.dark_blank = [{
        featureType: "all",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "all",
        elementType: "labels.text.fill",
        stylers: [{
            saturation: 36
        }, {
            color: "#000000"
        }, {
            lightness: 40
        }]
    }, {
        featureType: "all",
        elementType: "labels.text.stroke",
        stylers: [{
            visibility: "on"
        }, {
            color: "#000000"
        }, {
            lightness: 16
        }]
    }, {
        featureType: "all",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "administrative",
        elementType: "geometry.fill",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 20
        }]
    }, {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 17
        }, {
            weight: 1.2
        }]
    }, {
        featureType: "administrative",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 20
        }]
    }, {
        featureType: "landscape",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 21
        }]
    }, {
        featureType: "road",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 17
        }, {
            weight: "0.8"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 29
        }, {
            weight: "0.01"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 18
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 16
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "transit",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "transit",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 19
        }]
    }, {
        featureType: "water",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 17
        }]
    }], xd.dark_label = [{
        featureType: "all",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "all",
        elementType: "labels.text.fill",
        stylers: [{
            saturation: 36
        }, {
            color: "#000000"
        }, {
            lightness: 40
        }]
    }, {
        featureType: "all",
        elementType: "labels.text.stroke",
        stylers: [{
            visibility: "on"
        }, {
            color: "#000000"
        }, {
            lightness: 16
        }]
    }, {
        featureType: "all",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "administrative",
        elementType: "geometry.fill",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 20
        }]
    }, {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 17
        }, {
            weight: 1.2
        }]
    }, {
        featureType: "administrative",
        elementType: "labels",
        stylers: [{
            visibility: "simplified"
        }, {
            lightness: "-82"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels.text.stroke",
        stylers: [{
            invert_lightness: !0
        }, {
            weight: "7.15"
        }]
    }, {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 20
        }]
    }, {
        featureType: "landscape",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 21
        }]
    }, {
        featureType: "road",
        elementType: "labels",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 17
        }, {
            weight: "0.8"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 29
        }, {
            weight: "0.01"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 18
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 16
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.local",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "transit",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "transit",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 19
        }]
    }, {
        featureType: "water",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 17
        }]
    }], window.theme.allMaps = window.theme.allMaps || {};
    let $d = window.theme.allMaps;
    const _d = "[data-map-container]",
        Hd = "data-style",
        Md = "data-api-key",
        Id = "data-zoom",
        Dd = "data-address",
        Bd = "data-latlong-correction",
        Wd = "data-lat",
        Fd = "data-long";
    const Od = {
        onLoad() {
            $d[this.id] = new class {
                initMaps() {
                    Et({
                        url: `https://maps.googleapis.com/maps/api/js?key=${this.key}`
                    }).then((() => {
                        return "true" === this.enableCorrection && "" !== this.lat && "" !== this.long ? new window.google.maps.LatLng(this.lat, this.long) : (t = this.address, new Promise(((e, i) => {
                            (new window.google.maps.Geocoder).geocode({
                                address: t
                            }, (function(t, s) {
                                if ("OK" == s) {
                                    var o = {
                                        lat: t[0].geometry.location.lat(),
                                        lng: t[0].geometry.location.lng()
                                    };
                                    e(o)
                                } else i(s)
                            }))
                        })));
                        var t
                    })).then((t => {
                        var e = {
                            zoom: parseInt(this.zoomString, 10),
                            styles: Pd(this.styleString),
                            center: t,
                            draggable: !0,
                            clickableIcons: !1,
                            scrollwheel: !1,
                            zoomControl: !1,
                            disableDefaultUI: !0
                        };
                        const i = function(t, e) {
                            var i = new window.google.maps.Map(t, e),
                                s = i.getCenter();
                            return new window.google.maps.Marker({
                                map: i,
                                position: s
                            }), window.google.maps.event.addDomListener(window, "resize", (function() {
                                window.google.maps.event.trigger(i, "resize"), i.setCenter(s)
                            })), i
                        }(this.mapWrap, e);
                        return i
                    })).then((t => {
                        this.map = t, $d[this.id] = t
                    })).catch((t => {
                        console.log("Failed to load Google Map"), console.log(t)
                    }))
                }
                onUnload() {
                    void 0 !== window.google && window.google.maps.event.clearListeners(this.map, "resize")
                }
                constructor(t) {
                    this.container = t.container, this.mapWrap = this.container.querySelector(_d), this.styleString = this.container.getAttribute(Hd) || "", this.key = this.container.getAttribute(Md), this.zoomString = this.container.getAttribute(Id) || 14, this.address = this.container.getAttribute(Dd), this.enableCorrection = this.container.getAttribute(Bd), this.lat = this.container.getAttribute(Wd), this.long = this.container.getAttribute(Fd), this.key && this.initMaps()
                }
            }(this)
        },
        onUnload() {
            "function" == typeof $d[this.id].unload && $d[this.id].unload()
        }
    };
    xi("section-map", Od), xi("section-columns", [Da, Xt]);
    const Nd = "[data-related-section]",
        zd = "[data-grid-item]",
        Rd = "[data-carousel]",
        Vd = "data-limit",
        jd = "data-minimum",
        Ud = "data-layout-desktop",
        Jd = "data-layout-tablet",
        Kd = "data-layout-mobile",
        Yd = "[data-recent-wrapper]",
        Gd = "[data-recently-viewed-wrapper]",
        Xd = "data-product-id";
    xi("related", [{
        onLoad() {
            this.section = new class {
                init() {
                    const t = this.container.querySelector(Nd);
                    if (!t) return;
                    const e = t.getAttribute(Xd),
                        i = t.getAttribute(Vd),
                        s = t.getAttribute(Ud),
                        o = t.getAttribute(Jd),
                        r = t.getAttribute(Kd),
                        a = `${window.theme.routes.product_recommendations_url||"/recommendations/products/"}?section_id=related&limit=${i}&product_id=${e}`;
                    n.get(a).then((e => {
                        const i = document.createElement("div");
                        i.innerHTML = e.data;
                        const n = i.querySelector(Nd);
                        if (n.querySelector(zd)) {
                            const e = n.innerHTML;
                            t.innerHTML = e, t.querySelector(Rd).style.setProperty("--grid-large-items", s), t.querySelector(Rd).style.setProperty("--grid-medium-items", o), t.querySelector(Rd).style.setProperty("--grid-small-items", r), t.dispatchEvent(new CustomEvent("theme:related-products:added", {
                                bubbles: !0
                            }))
                        } else t.dispatchEvent(new CustomEvent("theme:tabs:hide", {
                            bubbles: !0
                        }))
                    })).catch((function(t) {
                        console.warn(t)
                    }))
                }
                recent() {
                    const t = this.container.querySelector(Yd),
                        e = this.container.querySelector(Gd),
                        i = this.container.querySelectorAll(zd),
                        s = t.hasAttribute(jd) ? parseInt(t.getAttribute(jd)) : 4,
                        o = !e && i.length > 0,
                        r = e && i.length >= s;
                    (o || r) && t.dispatchEvent(new CustomEvent("theme:tabs:check", {
                        bubbles: !0
                    }))
                }
                constructor(t) {
                    this.section = t, this.container = t.container, this.init(), this.container.addEventListener("theme:recent-products:added", (() => {
                        this.recent()
                    }))
                }
            }(this)
        }
    }, Fh, dt]), customElements.get("radio-swatch") || customElements.define("radio-swatch", zt), customElements.get("product-grid-item") || customElements.define("product-grid-item", Wo), customElements.get("product-grid-item-content") || customElements.define("product-grid-item-content", Qo), customElements.get("upsell-product") || customElements.define("upsell-product", Ge);
    const Qd = {
            ajaxDisable: "data-ajax-disable",
            shipping: "[data-shipping-estimate-form]",
            input: "[data-update-cart]",
            update: "[data-update-button]",
            bottom: "[data-cart-bottom]",
            upsellProduct: "[data-upsell-holder]",
            upsellButton: "[data-add-action-wrapper]"
        },
        Zd = "cart--dirty",
        tu = "heart-beat",
        eu = {
            onLoad() {
                if (this.container.querySelector(Qd.shipping) && new xr(this), this.disabled = "true" == this.container.getAttribute(Qd.ajaxDisable), this.disabled) return void(this.cart = new iu(this));
                this.cart = new rn(this);
                this.cart.init().then((() => {
                    this.cart.loadHTML()
                }))
            }
        };
    let iu = class {
        initQuantity() {
            Mr(this.container)
        }
        moveUpsell() {
            const t = this.container.querySelector(Qd.bottom);
            t.insertBefore(this.upsellProduct, t.firstChild)
        }
        initInputs() {
            this.inputs.forEach((t => {
                t.addEventListener("change", function() {
                    this.updateBtn.classList.add(Zd), this.updateBtn.classList.add(tu), setTimeout(function() {
                        this.updateBtn.classList.remove(tu)
                    }.bind(this), 1300)
                }.bind(this))
            }))
        }
        constructor(t) {
            this.section = t, this.container = t.container, this.inputs = this.container.querySelectorAll(Qd.input), this.quantityWrappers = this.container.querySelectorAll(Qd.qty), this.updateBtn = this.container.querySelector(Qd.update), this.upsellProduct = this.container.querySelector(Qd.upsellProduct), this.initQuantity(), this.initInputs(), this.upsellProduct && this.moveUpsell()
        }
    };
    xi("cart", [eu, gn]), customElements.get("upsell-product") || customElements.define("upsell-product", Ge), xi("accordion-single", gn);
    const su = (t, e, i = null) => {
            t.style.opacity = 0, t.style.display = e || "block",
                function e() {
                    let s = parseFloat(t.style.opacity);
                    (s += .1) > 1 || (t.style.opacity = s, requestAnimationFrame(e)), 1 === s && "function" == typeof i && i()
                }()
        },
        ou = (t, e = null) => {
            t.style.opacity = 1,
                function i() {
                    (t.style.opacity -= .1) < 0 ? t.style.display = "none" : requestAnimationFrame(i), 0 === parseFloat(t.style.opacity) && "function" == typeof e && e()
                }()
        },
        ru = "[data-tracking-consent]",
        nu = "[data-confirm-cookies]",
        au = "[data-close-modal]",
        lu = "[data-popup-inner]",
        cu = "[data-newsletter]",
        hu = "[data-newsletter-holder]",
        du = "[data-newsletter-field]",
        uu = "[data-newsletter-form]",
        pu = "[data-promo-text]",
        mu = "data-popup-delay",
        yu = "data-cookie-name",
        gu = "data-target-referrer",
        fu = "has-value",
        wu = "has-success",
        vu = "desktop",
        bu = "mobile";
    let Su = {},
        Eu = class {
            write() {
                (-1 !== document.cookie.indexOf("; ") && !document.cookie.split("; ").find((t => t.startsWith(this.name))) || -1 === document.cookie.indexOf("; ")) && (document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`)
            }
            read() {
                if (-1 !== document.cookie.indexOf("; ") && document.cookie.split("; ").find((t => t.startsWith(this.name)))) {
                    return document.cookie.split("; ").find((t => t.startsWith(this.name))).split("=")[1]
                }
                return !1
            }
            destroy() {
                document.cookie.split("; ").find((t => t.startsWith(this.name))) && (document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`)
            }
            constructor(t, e) {
                this.configuration = {
                    expires: null,
                    path: "/",
                    domain: window.location.hostname
                }, this.name = t, this.value = e
            }
        },
        Lu = class {
            always() {
                su(this.element)
            }
            delayed() {
                setTimeout((() => {
                    su(this.element)
                }), 1e4)
            }
            bottom() {
                window.addEventListener("scroll", (() => {
                    window.scrollY + window.innerHeight >= document.body.clientHeight && su(this.element)
                }))
            }
            idle() {
                let t = 0;
                const e = ["mousemove", "mousedown", "click", "touchmove", "touchstart", "touchend", "keydown", "keypress"],
                    i = ["load", "resize", "scroll"],
                    s = () => {
                        t = setTimeout((() => {
                            t = 0, su(this.element)
                        }), 6e4), e.forEach((t => {
                            document.addEventListener(t, o)
                        })), i.forEach((t => {
                            window.addEventListener(t, o)
                        }))
                    },
                    o = () => {
                        t && clearTimeout(t), e.forEach((t => {
                            document.removeEventListener(t, o)
                        })), i.forEach((t => {
                            window.removeEventListener(t, o)
                        })), s()
                    };
                s()
            }
            constructor(t, e) {
                this.element = e, this.delay = t.getAttribute(mu), "always" === this.delay && this.always(), "delayed" === this.delay && this.delayed(), "bottom" === this.delay && this.bottom(), "idle" === this.delay && this.idle()
            }
        },
        Tu = class {
            init() {
                -1 !== this.locationPath.indexOf(this.el.getAttribute(gu)) || window.Shopify.designMode || this.el.parentNode.removeChild(this.el)
            }
            constructor(t) {
                this.el = t, this.locationPath = location.href, this.el.hasAttribute(gu) && this.init()
            }
        };
    xi("popups", [Sa, {
        onLoad() {
            Su[this.id] = [];
            this.container.querySelectorAll(ru).forEach((t => {
                Su[this.id].push(new class {
                    init() {
                        this.showPopup && su(this.modalInner), this.clickEvents()
                    }
                    clickEvents() {
                        this.close.addEventListener("click", (t => {
                            t.preventDefault(), window.Shopify.customerPrivacy.setTrackingConsent(!1, (() => ou(this.modalInner)))
                        })), this.acceptButton.addEventListener("click", (t => {
                            t.preventDefault(), window.Shopify.customerPrivacy.setTrackingConsent(!0, (() => ou(this.modalInner)))
                        })), document.addEventListener("trackingConsentAccepted", (function() {
                            console.log("trackingConsentAccepted event fired")
                        }))
                    }
                    onBlockSelect(t) {
                        this.popup.contains(t.target) && this.showPopup && su(this.modalInner)
                    }
                    onBlockDeselect(t) {
                        this.popup.contains(t.target) && ou(this.modalInner)
                    }
                    constructor(t) {
                        this.popup = t, this.modal = document.querySelector(ru), this.modalInner = this.popup.querySelector(lu), this.close = this.modal.querySelector(au), this.acceptButton = this.modal.querySelector(nu), this.enable = "true" === this.modal.getAttribute("data-enable"), this.showPopup = !1, window.Shopify.loadFeatures([{
                            name: "consent-tracking-api",
                            version: "0.1"
                        }], (t => {
                            if (t) throw t;
                            const e = window.Shopify.customerPrivacy.userCanBeTracked(),
                                i = window.Shopify.customerPrivacy.getTrackingConsent();
                            this.showPopup = !e && "no_interaction" === i && this.enable, window.Shopify.designMode && (this.showPopup = !0), this.init()
                        }))
                    }
                }(t))
            }));
            this.container.querySelectorAll(cu).forEach((t => {
                Su[this.id].push(new class {
                    init() {
                        !1 !== this.cookie.read() && !window.Shopify.designMode || (this.show(), this.form.classList.contains(wu) && this.checkForSuccess())
                    }
                    show() {
                        window.Shopify.designMode ? su(this.popupInner) : new Lu(this.popup, this.popupInner), this.inputField(), this.closePopup()
                    }
                    checkForSuccess() {
                        su(this.popupInner), this.cookie.write()
                    }
                    closePopup() {
                        this.close.addEventListener("click", (t => {
                            t.preventDefault(), ou(this.popupInner), this.cookie.write()
                        }))
                    }
                    inputField() {
                        this.newsletterField.addEventListener("input", (() => {
                            "" !== this.newsletterField.value && this.holder.classList.add(fu, "" !== this.newsletterField.value)
                        })), this.newsletterField.addEventListener("focus", (() => {
                            "" !== this.newsletterField.value && this.holder.classList.add(fu, "" !== this.newsletterField.value)
                        })), this.newsletterField.addEventListener("focusout", (() => {
                            setTimeout((() => {
                                this.holder.classList.remove(fu)
                            }), 2e3)
                        }))
                    }
                    onBlockSelect(t) {
                        this.popup.contains(t.target) && su(this.popupInner)
                    }
                    onBlockDeselect(t) {
                        this.popup.contains(t.target) && ou(this.popupInner)
                    }
                    constructor(t) {
                        this.popup = t, this.popupInner = this.popup.querySelector(lu), this.holder = this.popup.querySelector(hu), this.close = this.popup.querySelector(au), this.newsletterField = this.popup.querySelector(du), this.cookie = new Eu(this.popup.getAttribute(yu), "newsletter_is_closed"), this.form = this.popup.querySelector(uu), this.isTargeted = new Tu(this.popup), this.init()
                    }
                }(t))
            }));
            this.container.querySelectorAll(pu).forEach((t => {
                Su[this.id].push(new class {
                    init() {
                        !1 !== this.cookie.read() && !window.Shopify.designMode || (window.Shopify.designMode ? su(this.popupInner) : new Lu(this.popup, this.popupInner), this.clickEvents())
                    }
                    clickEvents() {
                        this.close.addEventListener("click", (t => {
                            t.preventDefault(), ou(this.popupInner), this.cookie.write()
                        }))
                    }
                    onBlockSelect(t) {
                        this.popup.classList.contains(bu) && (this.hasDeviceClass = bu), this.popup.classList.contains(vu) && (this.hasDeviceClass = vu), "" !== this.hasDeviceClass && this.popup.classList.remove(this.hasDeviceClass), this.popup.contains(t.target) && su(this.popupInner)
                    }
                    onBlockDeselect(t) {
                        this.popup.contains(t.target) && ou(this.popupInner), "" !== this.hasDeviceClass && this.popup.classList.add(this.hasDeviceClass)
                    }
                    constructor(t) {
                        this.popup = t, this.popupInner = this.popup.querySelector(lu), this.close = this.popup.querySelector(au), this.cookie = new Eu(this.popup.getAttribute(yu), "user_has_closed"), this.isTargeted = new Tu(this.popup), this.hasDeviceClass = "", this.init()
                    }
                }(t))
            }))
        },
        onBlockSelect(t) {
            Su[this.id].forEach((e => {
                "function" == typeof e.onBlockSelect && e.onBlockSelect(t)
            }))
        },
        onBlockDeselect(t) {
            Su[this.id].forEach((e => {
                "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t)
            }))
        }
    }]), xi("tabs", Fh);
    const ku = "data-look-dot",
        Au = "data-products-holder",
        qu = "[data-carousel]",
        Cu = "[data-button-close-holder]",
        xu = "data-carousel-index",
        Pu = "data-block-id",
        $u = "button",
        _u = "is-active",
        Hu = "is-expanded",
        Mu = {};
    xi("look", [{
        onLoad() {
            Mu[this.id] = [], Mu[this.id].push(new class {
                init() {
                    this.keyEvents = t => this.keyboardEventShowProductHolder(t), this.keyCloseEvent = t => this.hideProductsHolder(t), this.clickEventsDot = t => this.clickEventShowProductsHolder(t), this.clickEventToClose = t => this.clickEventCloseProductsHolder(t), this.toggleOnResize = t => A(this.onResize(t), 200), this.initSlider(), this.addEvents()
                }
                initSlider() {
                    this.slider && (this.carousel = s.data(this.slider), this.carousel.options.wrapAround = !0, this.carousel.options.freeScroll = !1, this.carousel.resize(), this.carousel.on("change", (t => {
                        this.currentDot = this.container.querySelector(`[${ku}="${t}"]`), this.currentDot.classList.add(_u), this.removeClassOnSiblingDots()
                    })))
                }
                addEvents() {
                    this.dots.forEach((t => {
                        t.addEventListener("click", this.clickEventsDot), t.addEventListener("keyup", this.keyEvents)
                    })), document.addEventListener("keyup", this.keyCloseEvent), document.addEventListener("theme:resize", this.toggleOnResize), this.buttonClose && this.buttonClose.addEventListener("click", this.clickEventToClose)
                }
                showProductsHolder() {
                    const t = !this.productsHolder.classList.contains(Hu);
                    this.currentDot.classList.toggle(_u), this.productsHolder.classList.toggle(Hu, this.currentDot.classList.contains(_u)), this.currentDot.classList.contains(_u) && (this.hasDefaultOpen = !0, this.carousel.selectCell(Number(this.currentDot.getAttribute(ku)), !0, t)), this.removeClassOnSiblingDots()
                }
                hideProductsHolder(t) {
                    t.which === window.theme.keyboardKeys.ESCAPE && (this.removeClasses(), Le(), this.currentDot.focus())
                }
                removeClasses() {
                    this.productsHolder.classList.remove(Hu), this.currentDot.classList.remove(_u), this.hasDefaultOpen = !1
                }
                clickEventShowProductsHolder(t) {
                    this.currentDot = t.currentTarget, this.showProductsHolder()
                }
                clickEventCloseProductsHolder() {
                    this.removeClasses()
                }
                keyboardEventShowProductHolder(t) {
                    t.which !== window.theme.keyboardKeys.ENTER && t.which !== window.theme.keyboardKeys.SPACE || setTimeout((() => {
                        const t = this.productsHolder.querySelector($u);
                        Ee(this.productsHolder, {
                            elementToFocus: t
                        })
                    }), 400)
                }
                onResize() {
                    this.currentDot && (window.innerWidth < window.theme.sizes.medium ? (this.currentDot.classList.remove(_u), this.productsHolder.classList.remove(Hu)) : this.hasDefaultOpen && (this.currentDot.classList.add(_u), this.productsHolder.classList.add(Hu)))
                }
                removeEvents() {
                    this.dots.forEach((t => {
                        t.removeEventListener("click", this.clickEventsDot), t.removeEventListener("keyup", this.keyEvents)
                    })), document.removeEventListener("keyup", this.keyCloseEvent), document.removeEventListener("theme:resize", this.toggleOnResize), this.buttonClose && this.buttonClose.removeEventListener("click", this.clickEventToClose)
                }
                removeClassOnSiblingDots() {
                    for (let t of this.currentDot.parentNode.children) t !== this.currentDot && t.classList.remove(_u)
                }
                onUnload() {
                    this.slider && this.carousel && this.carousel.destroy(), this.removeEvents()
                }
                onBlockSelect(t) {
                    if (this.slider && this.carousel) {
                        const e = this.container.querySelector(`[${Pu}="${t.detail.blockId}"]`);
                        this.productsHolder.classList.add(Hu), this.carousel.selectCell(Number(e.getAttribute(xu)), !0, !0)
                    }
                }
                onBlockDeselect() {
                    window.innerWidth < window.theme.sizes.medium && (this.productsHolder.classList.remove(Hu), this.currentDot.classList.remove(_u))
                }
                constructor(t) {
                    this.section = t, this.container = this.section.container, this.dots = this.container.querySelectorAll(`[${ku}]`), this.productsHolder = this.container.querySelector(`[${Au}]`), this.slider = this.container.querySelector(qu), this.buttonClose = this.container.querySelector(Cu), this.currentDot = this.container.querySelector(`[${ku}].${_u}`), this.hasDefaultOpen = Boolean(this.currentDot), this.init()
                }
            }(this))
        },
        onUnload() {
            Mu[this.id].forEach((t => {
                "function" == typeof t.onUnload && t.onUnload()
            }))
        },
        onBlockSelect(t) {
            Mu[this.id].forEach((e => {
                "function" == typeof e.onBlockSelect && e.onBlockSelect(t)
            }))
        },
        onBlockDeselect(t) {
            Mu[this.id].forEach((e => {
                "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t)
            }))
        }
    }]);
    const Iu = (t, e = "", i) => ((i = i || document.createElement("div")).classList.add(e), t.parentNode.insertBefore(i, t), i.appendChild(t));
    window.theme.settings.animate_scroll && t.init({
        once: !0
    }), document.addEventListener("DOMContentLoaded", (function() {
        const t = document.querySelector("[data-header-height]");
        if (t) {
            const e = t.clientHeight || 0;
            document.documentElement.style.setProperty("--menu-height", `${e}px`)
        }
        Pi("*"), window.theme.settings.animate_hover && document.body.classList.add("theme-animate-hover"), document.addEventListener("lazyloaded", (function(t) {
            const e = t.target.parentNode;
            e.classList.contains("lazy-image") && (e.style.backgroundImage = "none")
        }));
        document.querySelectorAll(".rte table").forEach((t => {
            Iu(t, "rte__table-wrapper")
        }));
        document.querySelectorAll('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe').forEach((t => {
                Iu(t, "rte__video-wrapper")
            })), document.addEventListener("mousedown", (() => {
                document.body.classList.remove("focus-enabled")
            })), document.addEventListener("keyup", (t => {
                9 === t.keyCode && document.body.classList.add("focus-enabled")
            })), window.navigator.cookieEnabled && (document.documentElement.className = document.documentElement.className.replace("supports-no-cookies", "supports-cookies")),
            function(t) {
                t = t || {};
                var e = window.location.hash,
                    i = document.getElementById(e.slice(1));
                if (i && t.ignore && i.matches(t.ignore)) return !1;
                e && i && ve(i, t)
            }(), be(), "scrollBehavior" in document.documentElement.style || Et({
                url: window.theme.assets.smoothscroll
            })
    }))
}(themeVendor.AOS, themeVendor.FlickityFade, themeVendor.BodyScrollLock, themeVendor.Flickity, themeVendor.Sqrl, themeVendor.MicroModal, themeVendor.axios, themeVendor.Rellax, themeVendor.themeCurrency, themeVendor.themeAddresses, themeVendor.FlickitySync);
//# sourceMappingURL=theme.js.map